import React from "react";
import { motion } from "framer-motion";

import { gradient } from "./GradientImage";

const IconMap = {
	AlignLeft: AlignLeft,
	AlignCenter: AlignCenter,
	AlignRight: AlignRight,
	AlignTop: AlignTop,
	AlignMiddle: AlignMiddle,
	AlignBottom: AlignBottom,
	AlignDistribute: AlignDistribute,

	ListBullet: ListBullet,
	ListNumber: ListNumber,
	ColorPaletteFill: ColorPaletteFill,
	Dropdown: Dropdown,
	Compose: Compose,
	Book: Book,
	OpenLink: OpenLink,
	Link: Link,

	Cut: Cut,
	Copy: Copy,
	Paste: Paste,
	Rename: Rename,
	PlusSquareOutline: PlusSquareOutline,
	PlusSmall: PlusSmall,
	Delete: Delete,
	Checkmark: Checkmark,
	Download: Download,
	DuplicateSquare: DuplicateSquare,
	DuplicateLandscape: DuplicateLandscape,
	SquareStack:SquareStack,
	AIImage:AIImage,

	ChevronLeft: ChevronLeft,
	ChevronDown: ChevronDown,
	ChevronRight: ChevronRight,
	CaretDown: CaretDown,
	Help: Help,
	HelpFill: HelpFill,

	PlayFilled: PlayFilled,
	PlaybackPlay: PlaybackPlay,
	PlaybackPlayButton: PlaybackPlayButton,
	PlaybackPause: PlaybackPause,
	Trim: Trim,

	VolumeHigh: VolumeHigh,
	VolumeMid: VolumeMid,
	VolumeOff: VolumeOff,
	Waveform: Waveform,
	Comment: Comment,
	CommentFill: CommentFill,
	Close: Close,
	Clear: Clear,

	Text: Text,
	TextSize: TextSize,
	TextSizeAlt: TextSizeAlt,
	Title: Title,
	TitleOff: TitleOff,
	ShortenText: ShortenText,
	LengthenText: LengthenText,
	TextSizeDecrease: TextSizeDecrease,
	TextSizeIncrease: TextSizeIncrease,

	FillLandscape: FillLandscape,
	FitLandscape: FitLandscape,
	Crop: Crop,

	Code: Code,
	Image: Image,
	Add: Add,
	Video: Video,
	History: History,
	Background: Background,
	VideoCamera: VideoCamera,
	Microphone: Microphone,
	Record: Record,
	Theme: Theme,
	MagicWand: MagicWand,
	ArrowCursor: ArrowCursor,
	Annotate: Annotate,
	Scribble: Scribble,
	Flashlight: Flashlight,
	RectSelect: RectSelect,
	LineHairline: LineHairline,
	LineWavy: LineWavy,
	ShowOnClick: ShowOnClick,
	ShowAlways: ShowAlways,
	LightMode: LightMode,
	DarkMode: DarkMode,
	Fullscreen: Fullscreen,
	FullscreenAlt1: FullscreenAlt1,
	FullscreenAlt2: FullscreenAlt2,
	Preferences: Preferences,
	Expand: Expand,
	ExpandFlipped: ExpandFlipped,
	ExpandTile: ExpandTile,
	CollapseTile: CollapseTile,
	CollapseFlipped: CollapseFlipped,
	MoreCircleOutline: MoreCircleOutline,
	More: More,
	Share: Share,
	HeartEmpty: HeartEmpty,
	AddPage: AddPage,
	Grid: Grid,
	GridFilled: GridFilled,
	View: View,
	Photo: Photo,
	Table: Table,
	Web: Web,
	Search: Search,

	Twitter: Twitter,
	Giphy: Giphy,
	Figma: Figma,
	Airtable: Airtable,
	Framer: Framer,
	Miro: Miro,
	Looker: Looker,
	Dalle: Dalle,
	Unsplash: Unsplash,

	AddTableRow: AddTableRow,
	AddTableColumn: AddTableColumn,
	RemoveTableRow: RemoveTableRow,
	RemoveTableColumn: RemoveTableColumn,
	WrapText: WrapText,
	UnwrapText: UnwrapText,

	PaintBucket: PaintBucket,
	Color: Color,
	Lightbulb: Lightbulb,
	PlusLandscape: PlusLandscape,
	Diagram: Diagram,
	Subtract: Subtract,
	FitCanvasToContent: FitCanvasToContent,
	DiagramPan: DiagramPan,
	DiagramShapeRectangle: DiagramShapeRectangle,
	DiagramShapeCircle: DiagramShapeCircle,
	// DiagramShapeSquare: DiagramShapeSquare,
	DiagramShapeDiamond: DiagramShapeDiamond,
	DiagramShapeParallelogram: DiagramShapeParallelogram,
	DiagramShapeCylinder: DiagramShapeCylinder,
	DiagramShapeCloud: DiagramShapeCloud,
	DiagramConnectorStartCapArrow: DiagramConnectorStartCapArrow,
	DiagramConnectorStartCapDot: DiagramConnectorStartCapDot,
	DiagramConnectorEndCapArrow: DiagramConnectorEndCapArrow,
	DiagramConnectorEndCapDot: DiagramConnectorEndCapDot,
	DiagramConnectorLineSolid: DiagramConnectorLineSolid,
	DiagramConnectorLineDotted: DiagramConnectorLineDotted,

	DiagramConnectorDotArrowSolid: DiagramConnectorDotArrowSolid,
	DiagramConnectorDotDotSolid: DiagramConnectorDotDotSolid,
	DiagramConnectorArrowArrowSolid: DiagramConnectorArrowArrowSolid,
	DiagramConnectorArrowDotSolid: DiagramConnectorArrowDotSolid,
	DiagramConnectorDotArrowDotted: DiagramConnectorDotArrowDotted,
	DiagramConnectorDotDotDotted: DiagramConnectorDotDotDotted,
	DiagramConnectorArrowArrowDotted: DiagramConnectorArrowArrowDotted,
	DiagramConnectorArrowDotDotted: DiagramConnectorArrowDotDotted,

	ColorRing: ColorRing,
	ArrowLeft: ArrowLeft,
	ArrowRight: ArrowRight,
	ArrowUp: ArrowUp,
	ArrowTopRight: ArrowTopRight,
	ArrowLeftRightOut: ArrowLeftRightOut,
	MoveIndicator: MoveIndicator,
	MoveIndicator4Dots: MoveIndicator4Dots,

	DoubleSparkle: DoubleSparkle,
	Upload: Upload,
	Info: Info,
	Retake: Retake,
	Warning: Warning,
	Report: Report,
	Return: Return,
	TomeLogo: TomeLogo,
	Doc: Doc,
	OutlineAlt: OutlineAlt,
	Page: Page,
	PageLandscape: PageLandscape,
	MultiplePagesLandscape: MultiplePagesLandscape,
	PagesStacked: PagesStacked,

	TwoArrowCirclePathCounterclockwise: TwoArrowCirclePathCounterclockwise,
	BigText: BigText,
	Clock: Clock,
	Wavy: Wavy,
};

export const Icon = props => {
	const {
		name = "Add",
		size = 28,
		color = "rgba(255,255,255,1.0)",
		opacity = 0.4,
		selected,
		forceColor = false,
		style,
		layout = undefined,
		animate = undefined,
		initial = false,
		variants = undefined,
		transition = undefined,
	} = props;
	const Drawing = IconMap[name] ? IconMap[name] : null;
	if (!Drawing) console.log("Missing Icon: " + name);
	return (
		<motion.svg
			width={size}
			height={size}
			viewBox="0 0 64 64"
			animate={
				animate
					? animate
					: {
							fill: color,
							opacity: opacity,
					  }
			}
			initial={initial}
			variants={variants}
			transition={transition ? transition : { duration: 0.01 }}
			style={{
				display: "block",
				position: "relative",
				pointerEvents: "none",
				flexShrink: 0,
				fill: animate ? color : undefined,
				...style,
			}}
			layout={layout}
		>
			<Drawing color={color} selected={selected} forceColor={forceColor} />
		</motion.svg>
	);
};

function AlignLeft(props) {
	return (
		<motion.g>
			<path d="M12 20C12 18.8954 12.8954 18 14 18H50C51.1046 18 52 18.8954 52 20C52 21.1046 51.1046 22 50 22H14C12.8954 22 12 21.1046 12 20Z" />
			<path d="M12 32C12 30.8954 12.8954 30 14 30H38C39.1046 30 40 30.8954 40 32C40 33.1046 39.1046 34 38 34H14C12.8954 34 12 33.1046 12 32Z" />
			<path d="M14 42C12.8954 42 12 42.8954 12 44C12 45.1046 12.8954 46 14 46H50C51.1046 46 52 45.1046 52 44C52 42.8954 51.1046 42 50 42H14Z" />
		</motion.g>
	);
}

function AlignCenter(props) {
	return (
		<motion.g>
			<path d="M12 20C12 18.8954 12.8954 18 14 18H50C51.1046 18 52 18.8954 52 20C52 21.1046 51.1046 22 50 22H14C12.8954 22 12 21.1046 12 20Z" />
			<path d="M18 32C18 30.8954 18.8954 30 20 30H44C45.1046 30 46 30.8954 46 32C46 33.1046 45.1046 34 44 34H20C18.8954 34 18 33.1046 18 32Z" />
			<path d="M14 42C12.8954 42 12 42.8954 12 44C12 45.1046 12.8954 46 14 46H50C51.1046 46 52 45.1046 52 44C52 42.8954 51.1046 42 50 42H14Z" />
		</motion.g>
	);
}

function Download(props) {
	return (
		<motion.g>
			<path d="M34 12C34 10.8954 33.1046 10 32 10C30.8954 10 30 10.8954 30 12V35.1716L23.4142 28.5858C22.6332 27.8047 21.3668 27.8047 20.5858 28.5858C19.8047 29.3668 19.8047 30.6332 20.5858 31.4142L30.5858 41.4142C31.3668 42.1953 32.6332 42.1953 33.4142 41.4142L43.4142 31.4142C44.1953 30.6332 44.1953 29.3668 43.4142 28.5858C42.6332 27.8047 41.3668 27.8047 40.5858 28.5858L34 35.1716V12Z" />
			<path d="M14 50C12.8954 50 12 50.8954 12 52C12 53.1046 12.8954 54 14 54H50C51.1046 54 52 53.1046 52 52C52 50.8954 51.1046 50 50 50H14Z" />
		</motion.g>
	);
}

function Search(props) {
	return (
		<motion.g>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M38.3358 43.0775C35.5086 44.9256 32.1297 46 28.5 46C18.5589 46 10.5 37.9411 10.5 28C10.5 18.0589 18.5589 10 28.5 10C38.4411 10 46.5 18.0589 46.5 28C46.5 32.1441 45.0996 35.9611 42.7462 39.0035L52.6213 48.8787C53.7929 50.0503 53.7929 51.9497 52.6213 53.1213C51.4497 54.2929 49.5503 54.2929 48.3787 53.1213L38.3787 43.1213C38.3642 43.1068 38.3499 43.0922 38.3358 43.0775ZM42.5 28C42.5 35.732 36.232 42 28.5 42C20.768 42 14.5 35.732 14.5 28C14.5 20.268 20.768 14 28.5 14C36.232 14 42.5 20.268 42.5 28Z"
			/>
		</motion.g>
	);
}

function DuplicateSquare(props) {
	return (
		<motion.g>
			<path d="M37 27C35.8954 27 35 27.8954 35 29V35H29C27.8954 35 27 35.8954 27 37C27 38.1046 27.8954 39 29 39H35V45C35 46.1046 35.8954 47 37 47C38.1046 47 39 46.1046 39 45V39H45C46.1046 39 47 38.1046 47 37C47 35.8954 46.1046 35 45 35H39V29C39 27.8954 38.1046 27 37 27Z" />
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M15 9C11.6863 9 9 11.6863 9 15V39C9 42.3137 11.6863 45 15 45H19V49C19 52.3137 21.6863 55 25 55H49C52.3137 55 55 52.3137 55 49V25C55 21.6863 52.3137 19 49 19H45V15C45 11.6863 42.3137 9 39 9H15ZM41 19V15C41 13.8954 40.1046 13 39 13H15C13.8954 13 13 13.8954 13 15V39C13 40.1046 13.8954 41 15 41H19V25C19 21.6863 21.6863 19 25 19H41ZM25 23C23.8954 23 23 23.8954 23 25V49C23 50.1046 23.8954 51 25 51H49C50.1046 51 51 50.1046 51 49V25C51 23.8954 50.1046 23 49 23H25Z"
			/>
		</motion.g>
	);
}

function DuplicateLandscape(props) {
	return (
		<motion.g>
			<path d="M37 30C35.8954 30 35 30.8954 35 32V35H32C30.8954 35 30 35.8954 30 37C30 38.1046 30.8954 39 32 39H35V42C35 43.1046 35.8954 44 37 44C38.1046 44 39 43.1046 39 42V39H42C43.1046 39 44 38.1046 44 37C44 35.8954 43.1046 35 42 35H39V32C39 30.8954 38.1046 30 37 30Z" />
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M14 13C10.6863 13 8 15.6863 8 19V35C8 38.3137 10.6863 41 14 41H18V45C18 48.3137 20.6863 51 24 51H50C53.3137 51 56 48.3137 56 45V29C56 25.6863 53.3137 23 50 23H46V19C46 15.6863 43.3137 13 40 13H14ZM42 23V19C42 17.8954 41.1046 17 40 17H14C12.8954 17 12 17.8954 12 19V35C12 36.1046 12.8954 37 14 37H18V29C18 25.6863 20.6863 23 24 23H42ZM24 27C22.8954 27 22 27.8954 22 29V45C22 46.1046 22.8954 47 24 47H50C51.1046 47 52 46.1046 52 45V29C52 27.8954 51.1046 27 50 27H24Z"
			/>
		</motion.g>
	);
}

function AlignRight(props) {
	return (
		<motion.g>
			<path d="M12 20C12 18.8954 12.8954 18 14 18H50C51.1046 18 52 18.8954 52 20C52 21.1046 51.1046 22 50 22H14C12.8954 22 12 21.1046 12 20Z" />
			<path d="M24 32C24 30.8954 24.8954 30 26 30H50C51.1046 30 52 30.8954 52 32C52 33.1046 51.1046 34 50 34H26C24.8954 34 24 33.1046 24 32Z" />
			<path d="M14 42C12.8954 42 12 42.8954 12 44C12 45.1046 12.8954 46 14 46H50C51.1046 46 52 45.1046 52 44C52 42.8954 51.1046 42 50 42H14Z" />
		</motion.g>
	);
}

function AlignTop(props) {
	return (
		<motion.g>
			<path d="M14 18C12.8954 18 12 18.8954 12 20C12 21.1046 12.8954 22 14 22H50C51.1046 22 52 21.1046 52 20C52 18.8954 51.1046 18 50 18H14Z" />
			<path d="M33.4142 33.5858C32.6332 32.8047 31.3668 32.8047 30.5858 33.5858L22.5858 41.5858C21.8047 42.3668 21.8047 43.6332 22.5858 44.4142C23.3668 45.1953 24.6332 45.1953 25.4142 44.4142L32 37.8284L38.5858 44.4142C39.3668 45.1953 40.6332 45.1953 41.4142 44.4142C42.1953 43.6332 42.1953 42.3668 41.4142 41.5858L33.4142 33.5858Z" />
		</motion.g>
	);
}

function AlignMiddle(props) {
	return (
		<motion.g>
			<path d="M33.4142 24.4142L41.4142 16.4142C42.1953 15.6332 42.1953 14.3668 41.4142 13.5858C40.6332 12.8047 39.3668 12.8047 38.5858 13.5858L32 20.1716L25.4142 13.5858C24.6332 12.8047 23.3668 12.8047 22.5858 13.5858C21.8047 14.3668 21.8047 15.6332 22.5858 16.4142L30.5858 24.4142C31.3668 25.1953 32.6332 25.1953 33.4142 24.4142Z" />
			<path d="M12 32C12 33.1046 12.8954 34 14 34H50C51.1046 34 52 33.1046 52 32C52 30.8954 51.1046 30 50 30H14C12.8954 30 12 30.8954 12 32Z" />
			<path d="M41.4142 47.5858L33.4142 39.5858C32.6332 38.8047 31.3668 38.8047 30.5858 39.5858L22.5858 47.5858C21.8047 48.3668 21.8047 49.6332 22.5858 50.4142C23.3668 51.1953 24.6332 51.1953 25.4142 50.4142L32 43.8284L38.5858 50.4142C39.3668 51.1953 40.6332 51.1953 41.4142 50.4142C42.1953 49.6332 42.1953 48.3668 41.4142 47.5858Z" />
		</motion.g>
	);
}

function AlignBottom(props) {
	return (
		<motion.g>
			<path d="M41.4142 22.4142L33.4142 30.4142C32.6332 31.1953 31.3668 31.1953 30.5858 30.4142L22.5858 22.4142C21.8047 21.6332 21.8047 20.3668 22.5858 19.5858C23.3668 18.8047 24.6332 18.8047 25.4142 19.5858L32 26.1716L38.5858 19.5858C39.3668 18.8047 40.6332 18.8047 41.4142 19.5858C42.1953 20.3668 42.1953 21.6332 41.4142 22.4142Z" />
			<path d="M14 46C12.8954 46 12 45.1046 12 44C12 42.8954 12.8954 42 14 42H50C51.1046 42 52 42.8954 52 44C52 45.1046 51.1046 46 50 46H14Z" />
		</motion.g>
	);
}

function AlignDistribute(props) {
	return (
		<motion.g>
			<path d="M33.4142 51.4142C32.6332 52.1953 31.3668 52.1953 30.5858 51.4142L18.5858 39.4142C17.8047 38.6332 17.8047 37.3668 18.5858 36.5858C19.3668 35.8047 20.6332 35.8047 21.4142 36.5858L32 47.1716L42.5858 36.5858C43.3668 35.8047 44.6332 35.8047 45.4142 36.5858C46.1953 37.3668 46.1953 38.6332 45.4142 39.4142L33.4142 51.4142Z" />
			<path d="M21.4142 27.4142C20.6332 28.1953 19.3668 28.1953 18.5858 27.4142C17.8047 26.6332 17.8047 25.3668 18.5858 24.5858L30.5858 12.5858C31.3668 11.8047 32.6332 11.8047 33.4142 12.5858L45.4142 24.5858C46.1953 25.3668 46.1953 26.6332 45.4142 27.4142C44.6332 28.1953 43.3668 28.1953 42.5858 27.4142L32 16.8284L21.4142 27.4142Z" />
		</motion.g>
	);
}

function Rename(props) {
	return (
		<motion.g>
			<path d="M39 10C38.4477 10 38 10.4477 38 11C38 11.5523 38.4477 12 39 12H44V52H39C38.4477 52 38 52.4477 38 53C38 53.5523 38.4477 54 39 54H51C51.5523 54 52 53.5523 52 53C52 52.4477 51.5523 52 51 52H46V12H51C51.5523 12 52 11.5523 52 11C52 10.4477 51.5523 10 51 10H39Z" />
			<path d="M12 19C12 17.8954 12.8954 17 14 17H34C35.1046 17 36 17.8954 36 19C36 20.1046 35.1046 21 34 21H26V45C26 46.1046 25.1046 47 24 47C22.8954 47 22 46.1046 22 45V21H14C12.8954 21 12 20.1046 12 19Z" />
		</motion.g>
	);
}

function Book(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M29.15 50.8534H29.15C25.5124 48.9537 21.4637 47.9768 17.36 48.0086C15.0346 48.0303 12.7213 48.3468 10.4755 48.9503C9.88645 49.1406 9.25462 48.8174 9.0643 48.2283C9.02788 48.1156 9.00955 47.9978 9.01002 47.8793V15.2635V15.2634C9.00986 14.7935 9.30188 14.3729 9.7423 14.2089H9.7423C12.211 13.4467 14.7765 13.0433 17.36 13.011H17.36C21.981 12.9558 26.5228 14.2131 30.4575 16.6367C30.8049 16.8684 31.0126 17.2592 31.01 17.6767V49.7836V49.7836C31.0051 50.47 30.4447 51.0224 29.7584 51.0175C29.5449 51.016 29.3353 50.9595 29.15 50.8534H29.15ZM55.01 15.2634V47.8793V47.8793C55.0124 48.4984 54.5126 49.0022 53.8935 49.0046C53.775 49.0051 53.6572 48.9867 53.5445 48.9503C51.2987 48.3468 48.9854 48.0303 46.66 48.0086C42.5563 47.9768 38.5076 48.9537 34.87 50.8534C34.2743 51.1943 33.515 50.9877 33.1741 50.392C33.068 50.2066 33.0115 49.997 33.01 49.7834V17.6767V17.6767C33.0075 17.2592 33.2151 16.8684 33.5625 16.6367H33.5625C37.4973 14.2131 42.039 12.9558 46.66 13.011H46.66C49.2436 13.0433 51.8092 13.4467 54.278 14.2089C54.7183 14.3731 55.0102 14.7936 55.01 15.2635V15.2634Z"
		/>
	);
}

function PlusSquareOutline(props) {
	return (
		<motion.g>
			<path d="M30 20C30 18.8954 30.8954 18 32 18C33.1046 18 34 18.8954 34 20V30H44C45.1046 30 46 30.8954 46 32C46 33.1046 45.1046 34 44 34H34V44C34 45.1046 33.1046 46 32 46C30.8954 46 30 45.1046 30 44V34H20C18.8954 34 18 33.1046 18 32C18 30.8954 18.8954 30 20 30H30V20Z" />
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M10 18C10 13.5817 13.5817 10 18 10H46C50.4183 10 54 13.5817 54 18V46C54 50.4183 50.4183 54 46 54H18C13.5817 54 10 50.4183 10 46V18ZM14 18C14 15.7909 15.7909 14 18 14H46C48.2091 14 50 15.7909 50 18V46C50 48.2091 48.2091 50 46 50H18C15.7909 50 14 48.2091 14 46V18Z"
			/>
		</motion.g>
	);
}

function PlusSmall(props) {
	return (
		<path d="M30 17C30 15.8954 30.8954 15 32 15C33.1046 15 34 15.8954 34 17V30H47C48.1046 30 49 30.8954 49 32C49 33.1046 48.1046 34 47 34H34V47C34 48.1046 33.1046 49 32 49C30.8954 49 30 48.1046 30 47V34H17C15.8954 34 15 33.1046 15 32C15 30.8954 15.8954 30 17 30H30V17Z" />
	);
}

function Delete(props) {
	return (
		<motion.g>
			<path d="M38.0001 26C38.0001 24.8954 37.1046 24 36.0001 24C34.8955 24 34.0001 24.8954 34.0001 26V46C34.0001 47.1046 34.8955 48 36.0001 48C37.1046 48 38.0001 47.1046 38.0001 46V26Z" />
			<path d="M28.0001 24C29.1046 24 30.0001 24.8954 30.0001 26V46C30.0001 47.1046 29.1046 48 28.0001 48C26.8955 48 26.0001 47.1046 26.0001 46V26C26.0001 24.8954 26.8955 24 28.0001 24Z" />
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M25 8C22.7909 8 21 9.79086 21 12V15.5C21 15.7761 20.7761 16 20.5 16H14C12.8954 16 12 16.8954 12 18C12 19.1046 12.8954 20 14 20H16L17.7901 52.2219C17.9079 54.3415 19.661 56 21.7839 56H42.2161C44.339 56 46.0921 54.3415 46.2099 52.2219L48 20H50C51.1046 20 52 19.1046 52 18C52 16.8954 51.1046 16 50 16H43.5C43.2239 16 43 15.7761 43 15.5V12C43 9.79086 41.2091 8 39 8H25ZM42.9355 20H21.0645C20.4876 20 20.0304 20.4867 20.0664 21.0624L21.9414 51.0624C21.9743 51.5894 22.4114 52 22.9395 52H41.0605C41.5886 52 42.0257 51.5894 42.0586 51.0624L43.9336 21.0624C43.9696 20.4867 43.5124 20 42.9355 20ZM38.75 16H25.25C25.1119 16 25 15.8881 25 15.75V13C25 12.4477 25.4477 12 26 12H38C38.5523 12 39 12.4477 39 13V15.75C39 15.8881 38.8881 16 38.75 16Z"
			/>
		</motion.g>
	);
}

function Checkmark(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M16.6257 30.8353L26.4175 44.8488L47.3744 14.8566C48.0067 13.9503 49.2546 13.7278 50.1617 14.3595C50.2557 14.425 50.3439 14.4983 50.4253 14.5789C51.1212 15.3103 51.1934 16.4345 50.5967 17.2488L28.4527 48.94C27.6673 50.063 26.1194 50.3373 24.9953 49.5526C24.7565 49.3859 24.549 49.1785 24.3822 48.94L13.4034 33.2278C12.8066 32.4134 12.8788 31.289 13.5748 30.5574C14.3607 29.7803 15.6284 29.7868 16.4062 30.572C16.4868 30.6534 16.5602 30.7414 16.6257 30.8353H16.6257Z"
		/>
	);
}

function ListBullet(props) {
	return (
		<motion.g>
			<path d="M16 22C16 24.2091 14.2091 26 12 26C9.79086 26 8 24.2091 8 22C8 19.7909 9.79086 18 12 18C14.2091 18 16 19.7909 16 22Z" />
			<path d="M26 20C24.8954 20 24 20.8954 24 22C24 23.1046 24.8954 24 26 24H54C55.1046 24 56 23.1046 56 22C56 20.8954 55.1046 20 54 20H26Z" />
			<path d="M26 40C24.8954 40 24 40.8954 24 42C24 43.1046 24.8954 44 26 44H54C55.1046 44 56 43.1046 56 42C56 40.8954 55.1046 40 54 40H26Z" />
			<path d="M12 46C14.2091 46 16 44.2091 16 42C16 39.7909 14.2091 38 12 38C9.79086 38 8 39.7909 8 42C8 44.2091 9.79086 46 12 46Z" />
		</motion.g>
	);
}

function ListNumber(props) {
	return (
		<motion.g>
			<path d="M13.7343 15.9089C14.8389 15.9089 15.7343 16.8044 15.7343 17.9089V27.2229C15.7343 28.2043 14.9387 28.9998 13.9573 28.9998C12.9759 28.9998 12.1803 28.2043 12.1803 27.2229V19.1817H12.1036L11.2044 19.7196C10.3392 20.2372 9.23997 19.6139 9.23997 18.6057C9.23997 18.1535 9.4753 17.7339 9.86114 17.4981L11.9814 16.2024C12.2954 16.0105 12.6563 15.9089 13.0243 15.9089H13.7343Z" />
			<path d="M26.0001 19.9999C24.8955 19.9999 24.0001 20.8954 24.0001 21.9999C24.0001 23.1045 24.8955 23.9999 26.0001 23.9999H54.0001C55.1046 23.9999 56.0001 23.1045 56.0001 21.9999C56.0001 20.8954 55.1046 19.9999 54.0001 19.9999H26.0001Z" />
			<path d="M26.0001 39.9999C24.8955 39.9999 24.0001 40.8954 24.0001 41.9999C24.0001 43.1045 24.8955 43.9999 26.0001 43.9999H54.0001C55.1046 43.9999 56.0001 43.1045 56.0001 41.9999C56.0001 40.8954 55.1046 39.9999 54.0001 39.9999H26.0001Z" />
			<path d="M8.05141 47.9998C8.05141 48.5521 8.49913 48.9998 9.05141 48.9998H16.6807C17.4644 48.9998 18.0997 48.3645 18.0997 47.5808C18.0997 46.7971 17.4644 46.1617 16.6807 46.1617H12.9861V46.085L14.2133 45.0623C15.2105 44.2313 15.9797 43.5154 16.5209 42.9146C17.0621 42.3137 17.4371 41.7661 17.6459 41.2718C17.8547 40.7733 17.9591 40.2725 17.9591 39.7697C17.9591 38.9558 17.7481 38.2463 17.3263 37.6411C16.9087 37.036 16.3142 36.5673 15.5429 36.2349C14.7758 35.8983 13.8682 35.7299 12.8199 35.7299C11.8057 35.7299 10.9214 35.9089 10.1672 36.2669C9.41292 36.6248 8.82911 37.1362 8.41576 37.8009C8.27551 38.0265 8.15905 38.2668 8.06639 38.5218C7.74808 39.3977 8.55125 40.1788 9.48323 40.1788H10.2057C10.7387 40.1788 11.1245 39.7158 11.3753 39.2456C11.5116 38.9899 11.7034 38.796 11.9506 38.6639C12.202 38.5318 12.4918 38.4657 12.8199 38.4657C13.148 38.4657 13.4378 38.5318 13.6892 38.6639C13.9406 38.7917 14.1366 38.975 14.2773 39.2136C14.4222 39.4522 14.4946 39.7399 14.4946 40.0765C14.4946 40.3833 14.4307 40.6625 14.3028 40.9139C14.1793 41.1653 14.0003 41.4103 13.7659 41.649C13.5358 41.8833 13.2588 42.1348 12.9349 42.4032L8.77661 45.8431C8.3173 46.223 8.05141 46.7881 8.05141 47.3842V47.9998Z" />
		</motion.g>
	);
}

function Dropdown(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M54.2671 18.7125C56.3037 20.4096 56.5788 23.4363 54.8817 25.4729L38.6334 44.9708C35.1794 49.1157 28.8133 49.1157 25.3592 44.9708L9.11095 25.4729C7.41384 23.4363 7.689 20.4096 9.72553 18.7125C11.7621 17.0154 14.7888 17.2906 16.4859 19.3271L31.9963 37.9396L47.5068 19.3271C49.2039 17.2906 52.2306 17.0154 54.2671 18.7125Z"
		/>
	);
}

function CaretDown(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M20.8643 26.9562C21.8826 26.1077 23.396 26.2453 24.2445 27.2635L31.9998 36.5698L39.755 27.2635C40.6035 26.2453 42.1169 26.1077 43.1352 26.9562C44.1534 27.8048 44.291 29.3181 43.4424 30.3364L35.3183 40.0854C33.5913 42.1578 30.4082 42.1578 28.6812 40.0854L20.5571 30.3364C19.7085 29.3181 19.8461 27.8048 20.8643 26.9562Z"
		/>
	);
}

function ArrowLeft(props) {
	return (
		<path
			d="M52.01 34.0209H16.8385L28.4256 45.5938C29.2109 46.3718 29.2168 47.6392 28.4388 48.4245C27.6607 49.2098 26.3934 49.2157 25.6081 48.4376C25.6031 48.4327 25.5982 48.4277 25.5932 48.4227L10.5707 33.4183C9.7895 32.6388 9.7881 31.3736 10.5676 30.5924C10.5686 30.5914 10.5697 30.5903 10.5707 30.5893L25.5932 15.5848C26.3708 14.799 27.6382 14.7924 28.424 15.57C29.2098 16.3476 29.2164 17.615 28.4388 18.4008C28.4344 18.4052 28.43 18.4096 28.4256 18.414L16.8046 30.0209H52.01C53.1146 30.0209 54.01 30.9163 54.01 32.0209C54.01 33.1255 53.1146 34.0209 52.01 34.0209V34.0209Z"
			fillRule="evenodd"
			clipRule="evenodd"
		/>
	);
}
function ArrowRight(props) {
	return (
		<path
			d="M38.4276 48.4568C37.6464 49.239 36.3791 49.2398 35.5969 48.4585C34.8148 47.6773 34.814 46.41 35.5952 45.6278L47.2162 34.0209H12.01C10.9054 34.0209 10.01 33.1255 10.01 32.0209C10.01 30.9164 10.9054 30.0209 12.01 30.0209H47.1823L35.5952 18.4478C34.814 17.6657 34.8148 16.3984 35.5969 15.6171C36.3791 14.8359 37.6464 14.8367 38.4276 15.6188L53.45 30.6233C54.2312 31.403 54.2326 32.6683 53.4529 33.4495C53.452 33.4505 53.451 33.4515 53.45 33.4524L38.4276 48.4568Z"
			fillRule="evenodd"
			clipRule="evenodd"
		/>
	);
}

function ArrowUp(props) {
	return (
		<path
			d="M30.5858 10.5858C31.3668 9.80474 32.6332 9.80474 33.4142 10.5858L48.4142 25.5858C49.1953 26.3668 49.1953 27.6332 48.4142 28.4142C47.6332 29.1953 46.3668 29.1953 45.5858 28.4142L34 16.8284V52C34 53.1046 33.1046 54 32 54C30.8954 54 30 53.1046 30 52V16.8284L18.4142 28.4142C17.6332 29.1953 16.3668 29.1953 15.5858 28.4142C14.8047 27.6332 14.8047 26.3668 15.5858 25.5858L30.5858 10.5858Z"
			fillRule="evenodd"
			clipRule="evenodd"
		/>
	);
}

function ArrowTopRight(props) {
	return (
		<path
			d="M23 18C23 16.8954 23.8954 16 25 16H46C47.1046 16 48 16.8954 48 18V39C48 40.1046 47.1046 41 46 41C44.8954 41 44 40.1046 44 39V22.8284L19.4142 47.4142C18.6332 48.1953 17.3668 48.1953 16.5858 47.4142C15.8047 46.6332 15.8047 45.3668 16.5858 44.5858L41.1716 20H25C23.8954 20 23 19.1046 23 18Z"
			fillRule="evenodd"
			clipRule="evenodd"
		/>
	);
}

function ArrowLeftRightOut(props) {
	return (
		<path
			d="M21.4142 20.5858C22.1953 21.3668 22.1953 22.6332 21.4142 23.4142L14.8284 30H49.1716L42.5858 23.4142C41.8047 22.6332 41.8047 21.3668 42.5858 20.5858C43.3668 19.8047 44.6332 19.8047 45.4142 20.5858L55.4142 30.5858C56.1953 31.3668 56.1953 32.6332 55.4142 33.4142L45.4142 43.4142C44.6332 44.1953 43.3668 44.1953 42.5858 43.4142C41.8047 42.6332 41.8047 41.3668 42.5858 40.5858L49.1716 34H14.8284L21.4142 40.5858C22.1953 41.3668 22.1953 42.6332 21.4142 43.4142C20.6332 44.1953 19.3668 44.1953 18.5858 43.4142L8.58579 33.4142C7.80474 32.6332 7.80474 31.3668 8.58579 30.5858L18.5858 20.5858C19.3668 19.8047 20.6332 19.8047 21.4142 20.5858Z"
			fillRule="evenodd"
			clipRule="evenodd"
		/>
	);
}

function Theme(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M32 56C18.7452 56 8 45.2548 8 32C8 18.7452 18.7452 8 32 8C45.2548 8 56 18.7452 56 32C56 45.2548 45.2548 56 32 56ZM32 52C43.0457 52 52 43.0457 52 32C52 20.9543 43.0457 12 32 12V52Z"
		/>
	);
}

function Compose(props) {
	return (
		<g>
			<path d="M30.6338 30.4809L50.5899 10.5248C51.371 9.74376 52.6373 9.74376 53.4184 10.5248C54.1994 11.3059 54.1994 12.5722 53.4184 13.3532L33.4622 33.3094C33.0445 33.7271 32.5818 34.0973 32.0825 34.4131L27.012 37.621C26.5613 37.9061 26.037 37.3818 26.3222 36.9311L29.53 31.8607C29.8459 31.3614 30.2161 30.8987 30.6338 30.4809Z" />
			<path d="M52.01 46.0209V28.02C52.01 26.9154 51.1146 26.02 50.01 26.02C48.9054 26.02 48.01 26.9154 48.01 28.02V46.0209C48.0089 47.1251 47.1142 48.02 46.01 48.0215H18.01C16.9057 48.0202 16.011 47.1252 16.01 46.0209V18.0146C16.011 16.9103 16.9057 16.0153 18.01 16.014H36.01C37.115 16.014 38.0107 15.1183 38.0107 14.0133C38.0107 12.9083 37.115 12.0126 36.01 12.0126H18.01C14.6973 12.0169 12.0132 14.7019 12.0101 18.0146V46.0209C12.0132 49.3337 14.6974 52.0188 18.0101 52.023H46.0101C49.3229 52.0187 52.007 49.3337 52.01 46.0209Z" />
		</g>
	);
}

function ChevronDown(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M33.4079 43.4299C32.6276 44.2111 31.3618 44.2119 30.5806 43.4316C30.58 43.4311 30.5794 43.4305 30.5789 43.4299L15.5744 28.4177V28.4177C14.7825 27.6469 14.7654 26.3802 15.5362 25.5883C16.307 24.7964 17.5738 24.7794 18.3657 25.5501C18.3784 25.5625 18.3909 25.575 18.4033 25.5877L31.9933 39.1845L45.5833 25.5877C46.3535 24.7953 47.6204 24.7773 48.4128 25.5476C49.2053 26.3179 49.2233 27.5847 48.453 28.3772C48.4396 28.3909 48.4261 28.4044 48.4124 28.4177L33.4079 43.4299Z"
		/>
	);
}

function ChevronLeft(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M38.4256 48.4227H38.4256C37.6432 49.2043 36.3755 49.2043 35.5932 48.4227L20.5707 33.4183C19.7894 32.6387 19.7881 31.3734 20.5677 30.5921C20.5687 30.5911 20.5697 30.5902 20.5707 30.5892L35.5932 15.5848C36.3744 14.8026 37.6417 14.8019 38.4239 15.5831C39.206 16.3643 39.2068 17.6316 38.4256 18.4138L24.8192 32.0038L38.4256 45.5938C39.2068 46.3732 39.2082 47.6383 38.4287 48.4195C38.4277 48.4206 38.4266 48.4216 38.4256 48.4227V48.4227Z"
		/>
	);
}

function ChevronRight(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M28.4276 48.4568C27.6464 49.239 26.379 49.2398 25.5969 48.4585C24.8147 47.6773 24.814 46.41 25.5952 45.6278L39.2016 32.0378L25.5952 18.4478C24.814 17.6657 24.8147 16.3984 25.5969 15.6171C26.379 14.8359 27.6464 14.8367 28.4276 15.6188L43.45 30.6233C44.2312 31.403 44.2325 32.6683 43.4529 33.4495C43.4519 33.4505 43.451 33.4515 43.45 33.4524L28.4276 48.4568Z"
		/>
	);
}

function Return(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M32 12C32 10.8954 32.8954 10 34 10H46C50.4183 10 54 13.5817 54 18V31C54 35.4183 50.4183 39 46 39H16.8284L24.4142 46.5858C25.1953 47.3668 25.1953 48.6332 24.4142 49.4142C23.6332 50.1953 22.3668 50.1953 21.5858 49.4142L10.5858 38.4142C9.80474 37.6332 9.80474 36.3668 10.5858 35.5858L21.5858 24.5858C22.3668 23.8047 23.6332 23.8047 24.4142 24.5858C25.1953 25.3668 25.1953 26.6332 24.4142 27.4142L16.8284 35H46C48.2091 35 50 33.2091 50 31V18C50 15.7909 48.2091 14 46 14H34C32.8954 14 32 13.1046 32 12Z"
		/>
	);
}

function HelpFill(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M32.0021 55.9843H32.0021C18.7473 55.9843 8.00208 45.2391 8.00208 31.9843C8.00208 18.7295 18.7473 7.98425 32.0021 7.98425C45.2569 7.98425 56.0021 18.7295 56.0021 31.9843V31.9843C56.0021 45.2391 45.2569 55.9843 32.0021 55.9843H32.0021ZM34.2521 35.9843C34.2521 36.5365 33.8044 36.9843 33.2521 36.9843H31.0021C30.4498 36.9843 30.0021 36.5365 30.0021 35.9843C30.0021 29.3398 35.6271 29.966 35.6271 24.9843C35.6271 23.3274 33.7471 21.9843 31.8146 21.9843C29.8821 21.9843 27.971 23.3274 27.971 24.9843V24.9843C27.9643 25.5534 28.0521 26.1196 28.231 26.66C28.4126 27.1789 28.1392 27.7468 27.6203 27.9285C27.5144 27.9655 27.4031 27.9844 27.291 27.9844H25.26C24.809 27.9855 24.4126 27.6858 24.2907 27.2517C24.0914 26.5126 23.9943 25.7497 24.0024 24.9843C24.0024 21.1183 27.5841 17.9843 32.0024 17.9843C36.4207 17.9843 40.0024 21.1182 40.0024 24.9843C40.0021 31.4012 34.2521 31.1512 34.2521 35.9844L34.2521 35.9843ZM32.0021 39.9843H32.0021C33.6589 39.9843 35.0021 41.3274 35.0021 42.9843C35.0021 44.6411 33.6589 45.9843 32.0021 45.9843C30.3452 45.9843 29.0021 44.6411 29.0021 42.9843V42.9844C29.0021 41.3275 30.3452 39.9844 32.002 39.9844L32.0021 39.9843Z"
		/>
	);
}

function PlayFilled(props) {
	return (
		<path d="M20 46.6907V17.3096C20 14.6432 22.8944 12.9836 25.1956 14.3306L50.292 29.0212C52.5693 30.3543 52.5693 33.646 50.292 34.9791L25.1956 49.6697C22.8944 51.0167 20 49.3571 20 46.6907Z" />
	);
}

function PlaybackPlay(props) {
	return (
		<path d="M20 46.6906V17.3094C20 14.643 22.8944 12.9835 25.1956 14.3305L50.292 29.021C52.5693 30.3541 52.5693 33.6459 50.292 34.979L25.1956 49.6695C22.8944 51.0165 20 49.357 20 46.6906Z" />
	);
}

function PlaybackPlayButton(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M32 56C45.2548 56 56 45.2548 56 32C56 18.7452 45.2548 8 32 8C18.7452 8 8 18.7452 8 32C8 45.2548 18.7452 56 32 56ZM25 22.7434V41.0127C25 42.6707 26.7998 43.7026 28.2306 42.865L43.8356 33.7304C45.2517 32.9015 45.2517 30.8546 43.8356 30.0257L28.2306 20.8911C26.7998 20.0535 25 21.0854 25 22.7434Z"
		/>
	);
}

function PlaybackPause(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M25.01 50.0208H19.01C17.3532 50.0208 16.01 48.6776 16.01 47.0208V17.0208C16.01 15.3639 17.3532 14.0208 19.01 14.0208H25.01C26.6669 14.0208 28.01 15.3639 28.01 17.0208V47.0208C28.01 48.6776 26.6669 50.0208 25.01 50.0208ZM39.01 50.0208C37.3532 50.0208 36.01 48.6776 36.01 47.0208V17.0208C36.01 15.3639 37.3532 14.0208 39.01 14.0208H45.01C46.6669 14.0208 48.01 15.3639 48.01 17.0208V47.0208C48.01 48.6776 46.6669 50.0208 45.01 50.0208H39.01Z"
		/>
	);
}

function Trim(props) {
	return (
		<g>
			<path d="M18 10C14.6863 10 12 12.6863 12 16V48C12 51.3137 14.6863 54 18 54H24C25.1046 54 26 53.1046 26 52C26 50.8954 25.1046 50 24 50H18C16.8954 50 16 49.1046 16 48V16C16 14.8954 16.8954 14 18 14H24C25.1046 14 26 13.1046 26 12C26 10.8954 25.1046 10 24 10H18Z" />
			<path d="M46 10C49.3137 10 52 12.6863 52 16V48C52 51.3137 49.3137 54 46 54H40C38.8954 54 38 53.1046 38 52C38 50.8954 38.8954 50 40 50H46C47.1046 50 48 49.1046 48 48V16C48 14.8954 47.1046 14 46 14H40C38.8954 14 38 13.1046 38 12C38 10.8954 38.8954 10 40 10H46Z" />
		</g>
	);
}

function VolumeHigh(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M44.5379 50.3322C43.8013 49.5178 43.8642 48.2603 44.6784 47.5235C44.6843 47.5182 44.6902 47.5129 44.6961 47.5077H44.6961C53.2614 40.4445 54.4803 27.7736 47.4187 19.2063C46.6004 18.2136 45.6887 17.3016 44.6961 16.4831C43.8731 15.756 43.7953 14.4992 44.5223 13.676C44.5274 13.6702 44.5326 13.6643 44.5379 13.6585C45.28 12.8537 46.5269 12.7836 47.3546 13.5001C57.567 22.0372 58.9267 37.2385 50.3915 47.4533C49.4716 48.5542 48.4553 49.5708 47.3546 50.4909C46.5269 51.2074 45.2799 51.1372 44.5379 50.3323V50.3322ZM40.016 45.7512C39.0609 46.2871 37.8532 45.9752 37.2769 45.0437C36.7075 44.1152 36.9985 42.9007 37.9268 42.3312C37.9453 42.3199 37.9639 42.3088 37.9828 42.2981C43.6717 39.089 45.6826 31.8748 42.4742 26.1845C41.4147 24.3054 39.8615 22.7518 37.9828 21.6921C37.0362 21.1535 36.7053 19.9493 37.2438 19.0025C37.2545 18.9836 37.2656 18.9649 37.2769 18.9464V18.9464C37.8532 18.0149 39.0609 17.703 40.016 18.239C47.6116 22.5778 50.2525 32.2539 45.9146 39.8512C44.5109 42.3098 42.474 44.3471 40.016 45.7512L40.016 45.7512ZM8 26.0016V26.0014C8.00057 24.3438 9.3444 23.0005 11.0016 23.0009H16.5022C17.5631 23.0009 18.5805 22.5797 19.331 21.8299L27.5832 13.5854C28.3654 12.8041 29.6326 12.805 30.4137 13.5873C30.7882 13.9624 30.9986 14.4707 30.9989 15.0008V48.9984V48.9983C30.9984 50.1044 30.1015 51.0005 28.9957 51C28.4654 50.9997 27.9569 50.7891 27.5817 50.4142L19.3379 42.1775C18.5873 41.4276 17.5698 41.0065 16.5089 41.0066H11.0015H11.0015C9.34425 41.007 8.00045 39.6636 8.00001 38.0059L8 26.0016Z"
		/>
	);
}

function VolumeMid(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M16.509 41.0067H11.0017C9.34439 41.0071 8.0005 39.6637 8 38.0061V26.0019V26.0017C8.00057 24.3441 9.34452 23.0007 11.0018 23.0012H16.5018C17.5627 23.0013 18.5801 22.5801 19.3306 21.8303L27.5828 13.5859C28.3647 12.8044 29.6319 12.8048 30.4132 13.5868C30.7882 13.962 30.9989 14.4708 30.999 15.0013V48.9983V48.9983C30.9986 50.1042 30.102 51.0004 28.9963 51C28.4659 50.9998 27.9573 50.7891 27.5821 50.4142L19.3381 42.178C18.5875 41.428 17.57 41.0067 16.509 41.0067H16.509ZM37.9828 21.6927C37.0363 21.1541 36.7055 19.95 37.2439 19.0032C37.2547 18.9843 37.2657 18.9656 37.2771 18.9471C37.8532 18.0156 39.061 17.7036 40.016 18.2396C47.6116 22.5783 50.2526 32.2542 45.9148 39.8513C44.5111 42.31 42.4741 44.3473 40.016 45.7514C39.061 46.2874 37.8533 45.9755 37.2771 45.044C36.7076 44.1155 36.9985 42.9012 37.9267 42.3316C37.9452 42.3202 37.9639 42.3091 37.9828 42.2984C43.6717 39.0895 45.6827 31.8754 42.4744 26.1852C41.4149 24.306 39.8616 22.7525 37.9828 21.6927V21.6927Z"
		/>
	);
}

function VolumeOff(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M39.0073 15.0142V31.0871V31.0871C39.0068 31.6088 38.5834 32.0313 38.0617 32.0307C37.8116 32.0305 37.5718 31.931 37.3949 31.7542L28.4372 22.8047C27.8658 22.2343 27.865 21.3086 28.4354 20.7372C28.4363 20.7364 28.4371 20.7355 28.438 20.7347L35.59 13.5987C36.3727 12.8173 37.6406 12.8184 38.422 13.601C38.7964 13.9761 39.0069 14.4842 39.0073 15.0142L39.0073 15.0142ZM18.8472 24.5301L37.8352 43.501C38.5856 44.2504 39.0073 45.2673 39.0073 46.3278V48.9878C39.006 50.0942 38.1081 50.9901 37.0017 50.9888C36.4719 50.9882 35.9638 50.7777 35.5888 50.4034L27.3388 42.1719C26.5874 41.4225 25.5694 41.0017 24.5082 41.0019H18.9972C17.3394 41.0028 15.9946 39.6597 15.9936 38.0019V26.0079V26.0078C15.9933 25.7056 16.0393 25.4051 16.1302 25.1169C16.4382 24.2651 17.3783 23.8243 18.2301 24.1322C18.4632 24.2165 18.6742 24.3525 18.8472 24.5301L18.8472 24.5301ZM10.5672 10.5971C11.3488 9.81594 12.6156 9.81594 13.3972 10.5971L53.4312 50.6025C54.2124 51.3842 54.212 52.651 53.4303 53.4322C52.6487 54.2133 51.3818 54.213 50.6006 53.4313L10.5676 13.4263C9.78648 12.6461 9.78572 11.3804 10.5659 10.5993C10.5665 10.5987 10.567 10.5982 10.5676 10.5976L10.5672 10.5971Z"
		/>
	);
}

function Waveform(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M12.6402 37.3423C13.1763 37.3423 13.6205 37.1584 13.9729 36.7908C14.3405 36.4232 14.5243 35.9866 14.5243 35.4811V28.5189C14.5243 28.0134 14.3405 27.5768 13.9729 27.2092C13.6205 26.8262 13.1763 26.6348 12.6402 26.6348C12.1347 26.6348 11.7058 26.8262 11.3534 27.2092C11.0011 27.5768 10.825 28.0134 10.825 28.5189V35.4811C10.825 35.9866 11.0011 36.4232 11.3534 36.7908C11.7058 37.1584 12.1347 37.3423 12.6402 37.3423ZM20.3836 46.7401C20.9197 46.7401 21.364 46.5639 21.7163 46.2116C22.0686 45.8439 22.2448 45.3997 22.2448 44.8789V19.1211C22.2448 18.6003 22.0686 18.1561 21.7163 17.7884C21.364 17.4208 20.9197 17.237 20.3836 17.237C19.8628 17.237 19.4262 17.4208 19.0739 17.7884C18.7216 18.1561 18.5454 18.6003 18.5454 19.1211V44.8789C18.5454 45.3997 18.7216 45.8439 19.0739 46.2116C19.4262 46.5639 19.8628 46.7401 20.3836 46.7401ZM28.104 56C28.6402 56 29.0844 55.8162 29.4367 55.4485C29.8044 55.0962 29.9882 54.6596 29.9882 54.1388V9.86118C29.9882 9.34035 29.8044 8.90378 29.4367 8.55146C29.0844 8.18382 28.6402 8 28.104 8C27.5832 8 27.1466 8.18382 26.7943 8.55146C26.4573 8.90378 26.2888 9.34035 26.2888 9.86118V54.1388C26.2888 54.6596 26.4573 55.0962 26.7943 55.4485C27.1466 55.8162 27.5832 56 28.104 56ZM35.8475 43.9368C36.3683 43.9368 36.8048 43.7607 37.1572 43.4083C37.5248 43.056 37.7086 42.6194 37.7086 42.0986V21.9014C37.7086 21.3806 37.5248 20.944 37.1572 20.5917C36.8048 20.224 36.3683 20.0402 35.8475 20.0402C35.3266 20.0402 34.8901 20.224 34.5377 20.5917C34.1854 20.944 34.0093 21.3806 34.0093 21.9014V42.0986C34.0093 42.6194 34.1854 43.056 34.5377 43.4083C34.8901 43.7607 35.3266 43.9368 35.8475 43.9368ZM43.5909 50.899C44.1117 50.899 44.5483 50.7152 44.9006 50.3475C45.2529 49.9952 45.4291 49.5663 45.4291 49.0608V14.9392C45.4291 14.4337 45.2529 13.9971 44.9006 13.6295C44.5483 13.2618 44.1117 13.078 43.5909 13.078C43.0547 13.078 42.6105 13.2618 42.2582 13.6295C41.9059 13.9971 41.7297 14.4337 41.7297 14.9392V49.0608C41.7297 49.5663 41.9059 49.9952 42.2582 50.3475C42.6105 50.7152 43.0547 50.899 43.5909 50.899ZM51.3113 39.3183C51.8321 39.3183 52.2687 39.1422 52.621 38.7899C52.9887 38.4222 53.1725 37.9856 53.1725 37.4801V26.5199C53.1725 26.0144 52.9887 25.5778 52.621 25.2101C52.2687 24.8425 51.8321 24.6587 51.3113 24.6587C50.7752 24.6587 50.3309 24.8425 49.9786 25.2101C49.6416 25.5778 49.4731 26.0144 49.4731 26.5199V37.4801C49.4731 37.9856 49.6416 38.4222 49.9786 38.7899C50.3309 39.1422 50.7752 39.3183 51.3113 39.3183Z"
		/>
	);
}

function Comment(props) {
	return (
		<g>
			<path d="M19 26C19 24.8954 19.8954 24 21 24H43C44.1046 24 45 24.8954 45 26C45 27.1046 44.1046 28 43 28H21C19.8954 28 19 27.1046 19 26Z" />
			<path d="M21 32C19.8954 32 19 32.8954 19 34C19 35.1046 19.8954 36 21 36H37C38.1046 36 39 35.1046 39 34C39 32.8954 38.1046 32 37 32H21Z" />
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M10 22V38.4706C10 42.629 13.371 46 17.5294 46C17.7893 46 18 46.2107 18 46.4706V51.7299C18 53.4256 19.9777 54.3519 21.2804 53.2664L29.4437 46.4636C29.8032 46.164 30.2562 46 30.7241 46H46C50.4183 46 54 42.4183 54 38V22C54 17.5817 50.4183 14 46 14H18C13.5817 14 10 17.5817 10 22ZM14 22V38C14 40.2091 15.7909 42 18 42H21C21.5523 42 22 42.4477 22 43V46.9129C22 47.3401 22.5011 47.5705 22.8254 47.2925L28.4383 42.4815C28.8008 42.1708 29.2624 42 29.7398 42H46C48.2091 42 50 40.2091 50 38V22C50 19.7909 48.2091 18 46 18H18C15.7909 18 14 19.7909 14 22Z"
			/>
		</g>
	);
}

function CommentFill(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M10 38.4706V22C10 17.5817 13.5817 14 18 14H46C50.4183 14 54 17.5817 54 22V38C54 42.4183 50.4183 46 46 46H30.7241C30.2562 46 29.8032 46.164 29.4437 46.4636L21.2804 53.2664C19.9777 54.3519 18 53.4256 18 51.7299V46.4706C18 46.2107 17.7893 46 17.5294 46C13.371 46 10 42.629 10 38.4706ZM19 26C19 24.8954 19.8954 24 21 24H43C44.1046 24 45 24.8954 45 26C45 27.1046 44.1046 28 43 28H21C19.8954 28 19 27.1046 19 26ZM21 32C19.8954 32 19 32.8954 19 34C19 35.1046 19.8954 36 21 36H37C38.1046 36 39 35.1046 39 34C39 32.8954 38.1046 32 37 32H21Z"
		/>
	);
}

function Close(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M47.4142 47.4355C46.6328 48.2172 45.3658 48.2174 44.5841 47.4361C44.5839 47.4359 44.5837 47.4357 44.5835 47.4355L31.9835 34.8355L19.3951 47.4246C18.6093 48.2021 17.342 48.1953 16.5645 47.4095C15.7928 46.6296 15.7928 45.3738 16.5645 44.5939L29.1533 32.0052L16.5668 19.4187C15.7965 18.6258 15.8148 17.3587 16.6077 16.5884C17.3843 15.8339 18.6201 15.8338 19.3968 16.5882L31.9838 29.1746L44.5813 16.5772C45.3526 15.7853 46.6198 15.7687 47.4116 16.54C48.2034 17.3113 48.2201 18.5784 47.4488 19.3703C47.4365 19.3829 47.424 19.3954 47.4113 19.4078L34.8145 32.0052L47.4145 44.6052C48.196 45.3866 48.1961 46.6535 47.4147 47.435C47.4145 47.4352 47.4144 47.4353 47.4142 47.4355L47.4142 47.4355Z"
		/>
	);
}

function Clear(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M32.01 8.02002H32.01C45.2654 8.01947 56.0114 18.7646 56.012 32.02C56.0126 45.2754 45.2674 56.0214 32.012 56.022C18.7566 56.0226 8.01061 45.2774 8.01001 32.022C8.01001 32.0216 8.01001 32.0212 8.01001 32.0208V32.0209C8.01001 18.766 18.755 8.02062 32.0099 8.02002L32.01 8.02002ZM21.5957 39.594C20.8254 40.3869 20.8437 41.6541 21.6366 42.4244C22.4135 43.1792 23.6498 43.179 24.4265 42.424L31.9995 34.8509L39.5837 42.435C40.3757 43.2061 41.6429 43.1892 42.414 42.3972C43.1707 41.62 43.1706 40.3815 42.4137 39.6044L34.83 32.0207L42.4432 24.4077C43.2093 23.6108 43.1844 22.3438 42.3875 21.5777C41.6127 20.8329 40.388 20.8329 39.6132 21.5777L31.9995 29.19L24.3976 21.588C23.616 20.8063 22.3486 20.8062 21.5669 21.5879C20.7851 22.3695 20.7851 23.6369 21.5667 24.4186L29.1689 32.0206L21.5957 39.594Z"
		/>
	);
}

function Photo(props) {
	return (
		<g>
			<path d="M22 30C24.2091 30 26 28.2091 26 26C26 23.7909 24.2091 22 22 22C19.7909 22 18 23.7909 18 26C18 28.2091 19.7909 30 22 30Z" />
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M16 12C11.5817 12 8 15.5817 8 20V44C8 48.4183 11.5817 52 16 52H48C52.4183 52 56 48.4183 56 44V20C56 15.5817 52.4183 12 48 12H16ZM16 16C13.7909 16 12 17.7909 12 20V44L18.2131 37.7869C19.2456 36.7544 20.8716 36.6152 22.0645 37.4573L28.1796 41.7738C28.3677 41.9066 28.6222 41.8937 28.796 41.7426L37.8886 33.836C39.0777 32.802 40.8642 32.8642 41.9785 33.9785L52 44V20C52 17.7909 50.2091 16 48 16H16Z"
			/>
		</g>
	);
}

function Add(props) {
	return (
		<path d="M34.4999 14.0001C34.4999 12.6193 33.3807 11.5001 31.9999 11.5001C30.6192 11.5001 29.4999 12.6193 29.4999 14.0001V29.5H14C12.6193 29.5 11.5 30.6193 11.5 32C11.5 33.3807 12.6193 34.5 14 34.5H29.4999V50.0001C29.4999 51.3808 30.6192 52.5001 31.9999 52.5001C33.3807 52.5001 34.4999 51.3808 34.4999 50.0001V34.5H50C51.3807 34.5 52.5 33.3807 52.5 32C52.5 30.6193 51.3807 29.5 50 29.5H34.4999V14.0001Z" />
	);
}

function Record(props) {
	return (
		<g>
			<path d="M32 42C37.5228 42 42 37.5228 42 32C42 26.4772 37.5228 22 32 22C26.4772 22 22 26.4772 22 32C22 37.5228 26.4772 42 32 42Z" />
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M56 32C56 45.2548 45.2548 56 32 56C18.7452 56 8 45.2548 8 32C8 18.7452 18.7452 8 32 8C45.2548 8 56 18.7452 56 32ZM52 32C52 43.0457 43.0457 52 32 52C20.9543 52 12 43.0457 12 32C12 20.9543 20.9543 12 32 12C43.0457 12 52 20.9543 52 32Z"
			/>
		</g>
	);
}

function MagicWand(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M10.4645 54.5368C12.4159 56.4891 15.5806 56.4898 17.5329 54.5384C17.5334 54.5379 17.534 54.5373 17.5345 54.5368L44.5345 27.5368C46.4872 25.5849 46.4878 22.4196 44.5359 20.467C44.5354 20.4665 44.535 20.466 44.5345 20.4656L43.5345 19.4656C41.5824 17.5132 38.4172 17.5131 36.4649 19.4652C36.4647 19.4653 36.4646 19.4655 36.4645 19.4656L9.46451 46.4656C7.51218 48.4174 7.51178 51.5823 9.4636 53.5347C9.4639 53.535 9.46421 53.5353 9.46451 53.5356L10.4645 54.5368ZM32.2927 29.2946L39.2927 22.2946C39.6829 21.9041 40.3158 21.9039 40.7062 22.2941C40.7064 22.2942 40.7065 22.2944 40.7067 22.2946L41.7067 23.2946C42.0971 23.6846 42.0975 24.3174 41.7074 24.7078C41.7072 24.708 41.7069 24.7082 41.7067 24.7085L34.7067 31.7085C34.3165 32.0989 33.6837 32.0992 33.2932 31.709C33.293 31.7088 33.2929 31.7086 33.2927 31.7085L32.2927 30.7085V30.7085C31.9023 30.3183 31.902 29.6855 32.2922 29.2951C32.2924 29.2949 32.2925 29.2948 32.2927 29.2946H32.2927ZM31.1356 14.4561C30.3296 14.3024 29.6993 13.672 29.5456 12.8661L29.0933 10.4928C29.0309 10.165 28.7146 9.94979 28.3868 10.0122C28.1432 10.0585 27.9526 10.2491 27.9062 10.4928L27.454 12.8657C27.3003 13.6716 26.67 14.302 25.864 14.4557L23.4911 14.9077C23.1633 14.9701 22.9481 15.2864 23.0105 15.6142C23.0569 15.8578 23.2474 16.0484 23.4911 16.0948L25.864 16.5468C26.67 16.7005 27.3003 17.3308 27.454 18.1368L27.9062 20.5098C27.9686 20.8376 28.2849 21.0528 28.6127 20.9904C28.8564 20.944 29.0469 20.7534 29.0933 20.5098L29.5452 18.1369C29.6989 17.3309 30.3292 16.7006 31.1352 16.5469L33.508 16.0949C33.8358 16.0325 34.051 15.7162 33.9886 15.3884C33.9423 15.1447 33.7517 14.9541 33.508 14.9078L31.1356 14.4561ZM55.1356 30.4561C54.3296 30.3024 53.6993 29.672 53.5456 28.8661L53.0937 26.4932C53.0313 26.1654 52.715 25.9502 52.3872 26.0126C52.1435 26.0589 51.953 26.2495 51.9066 26.4932L51.4545 28.8662C51.3008 29.6721 50.6705 30.3025 49.8645 30.4562L47.4916 30.9082C47.1638 30.9706 46.9486 31.2869 47.011 31.6147C47.0574 31.8583 47.2479 32.0489 47.4916 32.0953L49.8645 32.5473C50.6705 32.701 51.3008 33.3313 51.4545 34.1373L51.9066 36.5102C51.969 36.838 52.2853 37.0532 52.6131 36.9908C52.8568 36.9444 53.0473 36.7538 53.0937 36.5102L53.5456 34.1373C53.6993 33.3313 54.3296 32.701 55.1356 32.5473L57.5086 32.0953C57.8364 32.0329 58.0516 31.7166 57.9892 31.3888C57.9429 31.1451 57.7523 30.9545 57.5086 30.9082L55.1356 30.4561ZM51.6475 9.88787L51.082 6.49478C51.0294 6.17321 50.726 5.9552 50.4044 6.00784C50.1544 6.04877 49.9584 6.24475 49.9175 6.49478L49.352 9.88787C49.1413 11.1524 48.1504 12.1433 46.8859 12.354L43.4928 12.9194C43.1713 12.9722 42.9534 13.2757 43.0062 13.5972C43.0472 13.847 43.243 14.0428 43.4928 14.0838L46.8859 14.6494C48.1504 14.8601 49.1413 15.8509 49.352 17.1154L49.9175 20.5085C49.9701 20.83 50.2735 21.0481 50.5951 20.9954C50.8451 20.9545 51.0411 20.7585 51.082 20.5085L51.6475 17.1154C51.8582 15.851 52.849 14.8602 54.1133 14.6494L57.5065 14.0838C57.828 14.031 58.0459 13.7275 57.9931 13.406C57.9521 13.1562 57.7563 12.9604 57.5065 12.9194L54.1133 12.354V12.354C52.8489 12.1432 51.8582 11.1523 51.6475 9.88787Z"
		/>
	);
}

function ArrowCursor(props) {
	return (
		<path d="M30.3393 37.6163C30.1846 37.2537 29.7207 37.1483 29.4245 37.4084L23.137 42.9303C22.3219 43.6462 21.0391 43.0713 21.0379 41.9896L21.0024 12.2608C21.0011 11.1502 22.3422 10.5839 23.1442 11.3563L44.6135 32.033C45.3947 32.7853 44.9192 34.1027 43.8355 34.1888L35.4793 34.8526C35.0847 34.884 34.8372 35.2931 34.9925 35.6571L42.08 52.2697C42.3526 52.9086 42.053 53.6464 41.4108 53.9176L39.0853 54.8998C38.4431 55.171 37.7015 54.8729 37.4289 54.234L30.3393 37.6163Z" />
	);
}

function Annotate(props) {
	return (
		<motion.g>
			<path d="M12 20C12 15.5817 15.5817 12 20 12H44C48.4183 12 52 15.5817 52 20V29.5C52 29.7761 51.7761 30 51.5 30H38C33.5817 30 30 33.5817 30 38V51.5C30 51.7761 29.7761 52 29.5 52H20C15.5817 52 12 48.4183 12 44V20Z" />
			<path d="M47.7929 34H38C35.7909 34 34 35.7909 34 38V47.7929C34 48.2383 34.5386 48.4614 34.8536 48.1464L48.1464 34.8536C48.4614 34.5386 48.2383 34 47.7929 34Z" />
		</motion.g>
	);
}

function Scribble(props) {
	return (
		<path d="M4.799 39.2754C5.85145 40.4049 7.51998 40.3792 8.5981 39.2754L13.116 34.7576C29.9809 17.8926 37.5278 10.6024 39.9151 12.964C41.7119 14.7353 37.0401 19.9975 30.0323 28.2375C23.0501 36.4774 14.9128 45.5388 20.6115 51.2888C25.6941 56.3971 33.6773 49.8257 40.3771 43.3826C46.1015 37.8636 49.0535 35.1683 49.7979 35.887C50.4653 36.5545 49.0021 38.1716 47.0512 41.5857C44.5869 45.8212 41.3269 51.0835 44.741 54.4975C47.3593 57.1158 51.6204 55.7297 56.7287 50.5701C57.9608 49.3123 58.0378 47.6437 56.934 46.5656C55.8559 45.5132 54.2387 45.5132 53.1349 46.5399C50.3113 49.1839 48.5401 50.6471 48.232 50.3647C47.9497 50.108 49.3102 48.0031 51.4151 44.512C55.1885 38.2743 56.241 34.7319 53.674 32.1906C50.3369 28.8536 45.203 31.3178 36.5523 39.5065C29.4162 46.2319 25.7198 48.7219 24.4106 47.4384C22.9218 45.9495 25.7968 41.2777 34.0881 31.7542C44.7666 19.4328 48.155 13.5801 43.7142 9.16494C38.1952 3.64597 32.3939 7.90713 9.31685 30.9585L4.799 35.4763C3.72087 36.5545 3.74654 38.1973 4.799 39.2754Z" />
	);
}

function Flashlight(props) {
	return (
		<path d="M20.4785 13.6465H43.0801V12.4004C43.0801 9.45703 41.5547 7.95312 38.7188 7.95312H24.8398C22.0039 7.95312 20.4785 9.45703 20.4785 12.4004V13.6465ZM29.2227 56.8945H34.3359C37.1719 56.8945 38.6758 55.4121 38.6758 52.4473V30.2109C38.6758 28.041 39.1699 26.4727 39.9863 25.248L41.3398 23.207C42.4141 21.5527 43.0801 20.0488 43.0801 18.1797V16.4609H20.4785V18.1797C20.4785 20.0488 21.123 21.5527 22.1973 23.207L23.5723 25.248C24.3672 26.4727 24.8613 28.041 24.8613 30.2109V52.4473C24.8613 55.4121 26.3867 56.8945 29.2227 56.8945ZM31.7793 28.2559C33.627 28.2559 34.8301 29.5879 34.8301 31.5V37.4297C34.8301 39.2988 33.627 40.5879 31.7793 40.6094C29.9316 40.6523 28.7285 39.3418 28.7285 37.4297V31.5C28.7285 29.5879 29.9316 28.2559 31.7793 28.2559ZM31.7793 29.8672C30.7695 29.8672 29.9102 30.7051 29.9102 31.7148C29.9102 32.7246 30.7695 33.584 31.7793 33.584C32.7891 33.584 33.6484 32.7246 33.6484 31.7148C33.6484 30.7051 32.7891 29.8672 31.7793 29.8672Z" />
	);
}

function Lightbulb(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M39.268 40.5977C38.6861 42.5877 38.2125 44.0192 36.198 44.0192H27.8468C25.832 44.0192 25.3583 42.5875 24.7768 40.5977C22.8344 33.9552 17.1026 31.7516 17.0268 23.1716V23.1716C16.9468 14.8894 23.5959 8.1105 31.8781 8.0305C40.1602 7.95048 46.9392 14.5996 47.0192 22.8818C47.0201 22.9784 47.0201 23.075 47.0192 23.1716C46.9423 31.7516 41.21 33.9552 39.268 40.5977V40.5977ZM27.0188 46.0194H37.0257C38.1305 46.0194 39.0261 46.915 39.0261 48.0198C39.0261 49.1246 38.1305 50.0202 37.0257 50.0202H27.0188C25.914 50.0202 25.0184 49.1246 25.0184 48.0198C25.0184 46.915 25.914 46.0194 27.0188 46.0194ZM28.19 52.0199H35.8548C36.5017 52.0201 37.026 52.5447 37.0259 53.1916V53.1917C37.0259 53.7223 36.8152 54.2311 36.4401 54.6063L35.6124 55.4348C35.2376 55.8098 34.7292 56.0206 34.199 56.0206H29.8455H29.8455C29.3153 56.0206 28.8069 55.8098 28.4321 55.4348L27.6044 54.6063V54.6063C27.2295 54.231 27.0188 53.7222 27.0188 53.1917V53.1917C27.0186 52.5448 27.5428 52.0201 28.1898 52.0199C28.1898 52.0199 28.1899 52.0199 28.19 52.0199V52.0199Z"
		/>
	);
}

function History(props) {
	return (
		<path d="M30.9003 18.4354C30.3784 18.4354 29.9277 18.6129 29.5481 18.9678C29.1843 19.3227 29.0024 19.7548 29.0024 20.264V33.1795C29.0024 33.4573 29.0499 33.7196 29.1448 33.9665C29.2397 34.198 29.382 34.4372 29.5718 34.684L35.4315 42.2297C35.8269 42.7235 36.2777 43.0167 36.7838 43.1093C37.3057 43.1864 37.8039 43.063 38.2784 42.7389C38.7212 42.4457 38.9585 42.0522 38.9901 41.5585C39.0376 41.0492 38.8794 40.5632 38.5156 40.1003L30.6156 29.7076L32.7745 36.1885V20.264C32.7745 19.7548 32.5926 19.3227 32.2289 18.9678C31.8651 18.6129 31.4222 18.4354 30.9003 18.4354ZM31.8018 55.6082C35.1073 55.6082 38.2151 54.991 41.1252 53.7565C44.0512 52.522 46.6291 50.8169 48.8592 48.6412C51.0892 46.4655 52.8368 43.9579 54.1021 41.1187C55.3674 38.264 56 35.2241 56 31.9991C56 28.7741 55.3674 25.7419 54.1021 22.9026C52.8368 20.048 51.0892 17.5327 48.8592 15.357C46.6291 13.1813 44.0512 11.4762 41.1252 10.2417C38.2151 9.00723 35.1073 8.39 31.8018 8.39C28.4963 8.39 25.3806 9.00723 22.4547 10.2417C19.5446 11.4762 16.9745 13.1813 14.7445 15.357C12.5145 17.5173 10.7668 20.0248 9.50154 22.8795C8.23628 25.7188 7.60365 28.7509 7.60365 31.9759H11.6367C11.6367 29.2447 12.1507 26.6909 13.1787 24.3146C14.2226 21.9382 15.6697 19.8551 17.5202 18.0651C19.3706 16.2751 21.5136 14.8786 23.9493 13.8756C26.3849 12.8572 29.0024 12.348 31.8018 12.348C34.6012 12.348 37.2187 12.8572 39.6544 13.8756C42.09 14.8786 44.2251 16.2828 46.0598 18.0882C47.9102 19.8782 49.3574 21.9614 50.4012 24.3377C51.445 26.7141 51.967 29.2678 51.967 31.9991C51.967 34.7303 51.445 37.2919 50.4012 39.6836C49.3574 42.06 47.9102 44.1508 46.0598 45.9562C44.2251 47.7462 42.09 49.1504 39.6544 50.1688C37.2187 51.1873 34.6012 51.6888 31.8018 51.6733C29.5402 51.6579 27.3971 51.3107 25.3727 50.6318C23.3483 49.9682 21.4899 49.027 19.7976 47.8079C18.1212 46.5889 16.6819 45.1615 15.4799 43.5259C15.1162 43.0475 14.6733 42.7466 14.1514 42.6232C13.6453 42.4843 13.1392 42.5615 12.6331 42.8546C12.1586 43.1478 11.866 43.5722 11.7553 44.1277C11.6604 44.6832 11.8186 45.2156 12.2298 45.7248C13.7323 47.6845 15.4957 49.405 17.5202 50.8864C19.5446 52.3832 21.7667 53.5405 24.1865 54.3583C26.6063 55.1916 29.1448 55.6082 31.8018 55.6082ZM4.68563 27.5319C4.11626 27.5319 3.68924 27.6476 3.40455 27.8791C3.11987 28.0951 2.98543 28.3883 3.00125 28.7586C3.01706 29.129 3.17522 29.5302 3.47572 29.9622L8.78983 37.3227C9.18523 37.8628 9.63598 38.1328 10.1421 38.1328C10.6482 38.1174 11.091 37.8474 11.4706 37.3227L16.7847 29.9391C17.0852 29.507 17.2355 29.1135 17.2355 28.7586C17.2513 28.3883 17.1169 28.0951 16.8322 27.8791C16.5475 27.6476 16.1284 27.5319 15.5748 27.5319H4.68563Z" />
	);
}

function RectSelect(props) {
	return (
		<motion.g>
			<path d="M11.2857 9C10.0233 9 9 10.0233 9 11.2857V16.4286C9 17.6909 10.0233 18.7143 11.2857 18.7143C12.5481 18.7143 13.5714 17.6909 13.5714 16.4286V13.5714H16.4286C17.6909 13.5714 18.7143 12.5481 18.7143 11.2857C18.7143 10.0233 17.6909 9 16.4286 9H11.2857Z" />
			<path d="M47.2857 9C46.0234 9 45 10.0233 45 11.2857C45 12.5481 46.0234 13.5714 47.2857 13.5714H50.1429V16.4286C50.1429 17.6909 51.1662 18.7143 52.4286 18.7143C53.6909 18.7143 54.7143 17.6909 54.7143 16.4286V11.2857C54.7143 10.0233 53.6909 9 52.4286 9H47.2857Z" />
			<path d="M24.4286 11.2857C24.4286 10.0233 25.4519 9 26.7143 9H37C38.2624 9 39.2857 10.0233 39.2857 11.2857C39.2857 12.5481 38.2624 13.5714 37 13.5714H26.7143C25.4519 13.5714 24.4286 12.5481 24.4286 11.2857Z" />
			<path d="M13.5714 47.2857C13.5714 46.0234 12.5481 45 11.2857 45C10.0233 45 9 46.0234 9 47.2857V52.4286C9 53.6909 10.0233 54.7143 11.2857 54.7143H16.4286C17.6909 54.7143 18.7143 53.6909 18.7143 52.4286C18.7143 51.1662 17.6909 50.1429 16.4286 50.1429H13.5714V47.2857Z" />
			<path d="M24.4286 52.4286C24.4286 51.1662 25.4519 50.1429 26.7143 50.1429H37C38.2624 50.1429 39.2857 51.1662 39.2857 52.4286C39.2857 53.6909 38.2624 54.7143 37 54.7143H26.7143C25.4519 54.7143 24.4286 53.6909 24.4286 52.4286Z" />
			<path d="M54.7143 47.2857C54.7143 46.0234 53.6909 45 52.4286 45C51.1662 45 50.1429 46.0234 50.1429 47.2857V50.1429H47.2857C46.0234 50.1429 45 51.1662 45 52.4286C45 53.6909 46.0234 54.7143 47.2857 54.7143H52.4286C53.6909 54.7143 54.7143 53.6909 54.7143 52.4286V47.2857Z" />
			<path d="M52.4286 24.4286C53.6909 24.4286 54.7143 25.4519 54.7143 26.7143V37C54.7143 38.2624 53.6909 39.2857 52.4286 39.2857C51.1662 39.2857 50.1429 38.2624 50.1429 37V26.7143C50.1429 25.4519 51.1662 24.4286 52.4286 24.4286Z" />
			<path d="M13.5714 26.7143C13.5714 25.4519 12.5481 24.4286 11.2857 24.4286C10.0233 24.4286 9 25.4519 9 26.7143V37C9 38.2624 10.0233 39.2857 11.2857 39.2857C12.5481 39.2857 13.5714 38.2624 13.5714 37V26.7143Z" />
		</motion.g>
	);
}

function Help(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M32.0209 56.0208C18.7661 56.0208 8.02087 45.2756 8.02087 32.0208C8.02087 18.766 18.7661 8.02075 32.0209 8.02075C45.2757 8.02075 56.0209 18.766 56.0209 32.0208C56.0209 45.2756 45.2757 56.0208 32.0209 56.0208ZM32.0209 12.0208C20.9752 12.0208 12.0209 20.9751 12.0209 32.0208C12.0209 43.0665 20.9752 52.0208 32.0209 52.0208C43.0666 52.0208 52.0209 43.0664 52.0209 32.0208V32.021C52.0209 20.9754 43.0667 12.0211 32.0211 12.021L32.0209 12.0208ZM34.2709 36.0208C34.2709 36.573 33.8232 37.0208 33.2709 37.0208H31.0209C30.4686 37.0208 30.0209 36.573 30.0209 36.0208C30.0209 29.3763 35.6459 30.0025 35.6459 25.0208C35.6459 23.3639 33.7659 22.0208 31.8335 22.0208C29.9011 22.0208 27.9897 23.3639 27.9897 25.0208V25.0208C27.9829 25.5899 28.0708 26.1561 28.2497 26.6965C28.4313 27.2154 28.1579 27.7833 27.639 27.965C27.5331 28.002 27.4218 28.0209 27.3097 28.0209H25.2785C24.8274 28.022 24.431 27.7224 24.309 27.2882C24.1097 26.5491 24.0127 25.7862 24.0209 25.0208C24.0209 21.1548 27.6024 18.0208 32.0209 18.0208C36.4394 18.0208 40.0209 21.1547 40.0209 25.0208C40.0208 31.4377 34.2707 31.1877 34.2707 36.0209L34.2709 36.0208ZM32.0209 40.0208C33.6777 40.0208 35.0209 41.3639 35.0209 43.0208C35.0209 44.6776 33.6777 46.0208 32.0209 46.0208C30.364 46.0208 29.0209 44.6776 29.0209 43.0208V43.0209C29.0209 41.364 30.364 40.0209 32.0208 40.0209L32.0209 40.0208Z"
		/>
	);
}

function LineHairline(props) {
	return <path fillRule="evenodd" clipRule="evenodd" d="M56 32.6667H8V31.3333H56V32.6667Z" />;
}

function LineWavy(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M15.3266 29.3331C14.2203 30.3093 13.0469 31.8373 11.8267 33.9907L9.50659 32.676C10.8049 30.3849 12.15 28.5796 13.5622 27.3336C14.9827 26.0802 16.5428 25.3333 18.2222 25.3333C19.9016 25.3333 21.4617 26.0802 22.8821 27.3336C24.2943 28.5796 25.6395 30.3849 26.9378 32.676C28.158 34.8293 29.3314 36.3574 30.4377 37.3336C31.5357 38.3024 32.4942 38.6667 33.3333 38.6667C34.1724 38.6667 35.1308 38.3024 36.2289 37.3336C37.3352 36.3574 38.5086 34.8293 39.7288 32.676C41.0271 30.3849 42.3722 28.5796 43.7845 27.3336C45.2049 26.0802 46.765 25.3333 48.4444 25.3333C50.1238 25.3333 51.6839 26.0802 53.1043 27.3336C54.5166 28.5796 55.8617 30.3849 57.16 32.676L54.8399 33.9907C53.6197 31.8373 52.4463 30.3093 51.34 29.3331C50.2419 28.3642 49.2835 28 48.4444 28C47.6053 28 46.6469 28.3642 45.5488 29.3331C44.4425 30.3093 43.2691 31.8373 42.0489 33.9907C40.7506 36.2818 39.4054 38.087 37.9932 39.3331C36.5728 40.5864 35.0127 41.3333 33.3333 41.3333C31.6539 41.3333 30.0938 40.5864 28.6733 39.3331C27.2611 38.087 25.916 36.2818 24.6177 33.9907C23.3975 31.8373 22.2241 30.3093 21.1178 29.3331C20.0197 28.3642 19.0613 28 18.2222 28C17.383 28 16.4246 28.3642 15.3266 29.3331Z"
		/>
	);
}

function Wavy(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M19.3508 29.3899C17.7021 27.3291 14.5447 27.4016 12.9924 29.536L9.61761 34.1763C8.96794 35.0697 7.7171 35.2672 6.8238 34.6175C5.93049 33.9678 5.73299 32.717 6.38267 31.8237L9.75746 27.1833C12.862 22.9145 19.1769 22.7695 22.4743 26.8911L28.8767 34.8941C30.478 36.8957 33.5223 36.8957 35.1236 34.8941L41.526 26.8911C44.8233 22.7695 51.1383 22.9145 54.2428 27.1833L57.6176 31.8237C58.2673 32.717 58.0698 33.9678 57.1765 34.6175C56.2832 35.2672 55.0323 35.0697 54.3827 34.1763L51.0079 29.536C49.4556 27.4016 46.2981 27.3291 44.6495 29.3899L38.2471 37.3929C35.0445 41.3961 28.9558 41.3961 25.7532 37.3929L19.3508 29.3899Z"
		/>
	);
}

function ShowOnClick(props) {
	return (
		<path d="M33.4509 16.4508C33.4509 15.6671 32.7877 15 31.9917 15C31.2123 15 30.5491 15.6671 30.5491 16.4508V21.3203C30.5491 22.1041 31.2123 22.7712 31.9917 22.7712C32.7877 22.7712 33.4509 22.1041 33.4509 21.3203V16.4508ZM22.5564 25.6728C23.1202 26.2398 24.0488 26.2398 24.596 25.6728C25.1598 25.1225 25.1598 24.1886 24.596 23.6216L21.1967 20.1863C20.6495 19.636 19.7209 19.6193 19.1571 20.1697C18.6099 20.72 18.6099 21.6538 19.1571 22.2208L22.5564 25.6728ZM39.205 23.7884C38.6578 24.3554 38.6578 25.2893 39.205 25.8396C39.7688 26.4066 40.714 26.4066 41.2612 25.8396L44.6771 22.4043C45.2409 21.8373 45.2409 20.9034 44.6771 20.3364C44.1299 19.7861 43.2013 19.7861 42.6541 20.3364L39.205 23.7884ZM30.6817 44.6838C30.6651 45.3342 31.4279 45.5343 31.8425 45.1174L34.363 42.5659L37.1985 49.62C37.3312 49.9202 37.6794 50.0869 37.9779 49.9535L39.6195 49.3031C39.918 49.153 40.0341 48.8028 39.8848 48.5027L36.9 41.5653L40.4818 41.4152C41.1119 41.3819 41.4104 40.7815 40.9627 40.2979L31.9088 30.9425C31.4777 30.509 30.8475 30.7424 30.831 31.3594L30.6817 44.6838ZM15.4427 31.6429C14.6633 31.6429 14 32.31 14 33.0938C14 33.8776 14.6633 34.5446 15.4427 34.5446H20.3012C21.0972 34.5446 21.7605 33.8776 21.7605 33.0938C21.7605 32.31 21.0972 31.6429 20.3012 31.6429H15.4427ZM48.5408 34.5446C49.3367 34.5446 50 33.8776 50 33.0938C50 32.31 49.3367 31.6429 48.5408 31.6429H43.6988C42.9194 31.6429 42.2561 32.31 42.2561 33.0938C42.2561 33.8776 42.9194 34.5446 43.6988 34.5446H48.5408ZM19.3063 43.7833C18.7591 44.3336 18.7591 45.2841 19.2897 45.8345C19.8369 46.3848 20.7821 46.4015 21.3459 45.8511L24.7619 42.4158C25.3257 41.8655 25.3257 40.9316 24.7619 40.3646C24.2312 39.8143 23.286 39.8143 22.7222 40.3646L19.3063 43.7833Z" />
	);
}

function ShowAlways(props) {
	return (
		<path d="M32.423 42C42.7214 42 49.8333 33.6184 49.8333 31C49.8333 28.3687 42.7086 20 32.423 20C22.2649 20 15 28.3687 15 31C15 33.6184 22.2522 42 32.423 42ZM32.423 39.972C24.0238 39.972 17.2305 32.8098 17.2305 31C17.2305 29.4726 24.0238 22.028 32.423 22.028C40.7841 22.028 47.6029 29.4726 47.6029 31C47.6029 32.8098 40.7841 39.972 32.423 39.972ZM32.423 38.1879C36.3869 38.1879 39.5732 34.9148 39.5732 31C39.5732 26.9825 36.3869 23.8121 32.423 23.8121C28.4337 23.8121 25.2346 26.9825 25.2473 31C25.2728 34.9148 28.4337 38.1879 32.423 38.1879ZM32.423 33.3874C31.0975 33.3874 30.0269 32.3092 30.0269 31C30.0269 29.6779 31.0975 28.6126 32.423 28.6126C33.7358 28.6126 34.8064 29.6779 34.8064 31C34.8064 32.3092 33.7358 33.3874 32.423 33.3874Z" />
	);
}

function LightMode(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M57 34H53C52.4696 34 51.9609 33.7893 51.5858 33.4142C51.2107 33.0391 51 32.5304 51 32C51 31.4696 51.2107 30.9609 51.5858 30.5858C51.9609 30.2107 52.4696 30 53 30H57C57.5304 30 58.0391 30.2107 58.4142 30.5858C58.7893 30.9609 59 31.4696 59 32C59 32.5304 58.7893 33.0391 58.4142 33.4142C58.0391 33.7893 57.5304 34 57 34ZM13 32C13 32.5304 12.7893 33.0391 12.4142 33.4142C12.0391 33.7893 11.5304 34 11 34H7C6.46957 34 5.96086 33.7893 5.58579 33.4142C5.21071 33.0391 5 32.5304 5 32C5 31.4696 5.21071 30.9609 5.58579 30.5858C5.96086 30.2107 6.46957 30 7 30H11C11.5304 30 12.0391 30.2107 12.4142 30.5858C12.7893 30.9609 13 31.4696 13 32ZM51.2213 51.2212C50.8462 51.5962 50.3376 51.8069 49.8072 51.8069C49.2767 51.8069 48.7681 51.5962 48.393 51.2212L45.5643 48.3928C45.3786 48.2071 45.2313 47.9866 45.1308 47.7439C45.0303 47.5013 44.9785 47.2412 44.9785 46.9786C44.9785 46.7159 45.0303 46.4558 45.1308 46.2132C45.2313 45.9705 45.3786 45.7501 45.5644 45.5644C45.7501 45.3786 45.9706 45.2313 46.2132 45.1308C46.4559 45.0303 46.7159 44.9786 46.9786 44.9786C47.2412 44.9786 47.5013 45.0303 47.744 45.1308C47.9866 45.2314 48.2071 45.3787 48.3928 45.5644L51.2213 48.3928C51.5964 48.7679 51.8071 49.2766 51.8071 49.807C51.8071 50.3374 51.5964 50.8461 51.2213 51.2212ZM48.42 12.7518C48.7966 12.3846 49.3028 12.1805 49.8288 12.1839C50.3549 12.1872 50.8584 12.3976 51.2304 12.7696C51.6024 13.1416 51.8128 13.6451 51.8161 14.1711C51.8195 14.6972 51.6154 15.2033 51.2482 15.58L48.42 18.4087C48.0449 18.7838 47.5361 18.9945 47.0057 18.9945C46.4752 18.9945 45.9664 18.7838 45.5914 18.4086C45.2163 18.0335 45.0055 17.5248 45.0055 16.9943C45.0056 16.4638 45.2163 15.9551 45.5914 15.58L48.42 12.7518ZM30 57V53C30 52.4696 30.2107 51.9609 30.5858 51.5858C30.9609 51.2107 31.4696 51 32 51C32.5304 51 33.0391 51.2107 33.4142 51.5858C33.7893 51.9609 34 52.4696 34 53V57C34 57.5304 33.7893 58.0391 33.4142 58.4142C33.0391 58.7893 32.5304 59 32 59C31.4696 59 30.9609 58.7893 30.5858 58.4142C30.2107 58.0391 30 57.5304 30 57ZM18.4358 45.5643C18.8109 45.9394 19.0216 46.4481 19.0216 46.9785C19.0216 47.5089 18.8109 48.0176 18.4358 48.3927L15.6073 51.2527C15.2322 51.6278 14.7235 51.8385 14.1931 51.8385C13.6626 51.8385 13.1539 51.6278 12.7788 51.2528C12.4038 50.8777 12.193 50.369 12.193 49.8385C12.193 49.3081 12.4037 48.7994 12.7788 48.4243L15.6073 45.5643C15.793 45.3786 16.0135 45.2312 16.2562 45.1307C16.4988 45.0302 16.7589 44.9785 17.0215 44.9785C17.2842 44.9785 17.5443 45.0302 17.7869 45.1307C18.0296 45.2312 18.2501 45.3786 18.4358 45.5643ZM12.7519 12.7519C12.9376 12.5662 13.1581 12.4188 13.4008 12.3183C13.6434 12.2178 13.9035 12.1661 14.1662 12.1661C14.4288 12.1661 14.6889 12.2178 14.9315 12.3183C15.1742 12.4188 15.3947 12.5662 15.5804 12.7519L18.4087 15.58C18.7838 15.9551 18.9946 16.4639 18.9946 16.9944C18.9946 17.5249 18.7839 18.0336 18.4088 18.4088C18.0336 18.7839 17.5249 18.9946 16.9944 18.9946C16.4639 18.9946 15.9551 18.7839 15.58 18.4088L12.7519 15.58C12.3769 15.2049 12.1663 14.6963 12.1663 14.1659C12.1663 13.6356 12.3769 13.127 12.7519 12.7519ZM30 11V7C30 6.46957 30.2107 5.96086 30.5858 5.58579C30.9609 5.21071 31.4696 5 32 5C32.5304 5 33.0391 5.21071 33.4142 5.58579C33.7893 5.96086 34 6.46957 34 7V11C34 11.5304 33.7893 12.0391 33.4142 12.4142C33.0391 12.7893 32.5304 13 32 13C31.4696 13 30.9609 12.7893 30.5858 12.4142C30.2107 12.0391 30 11.5304 30 11ZM48 32C48 35.1645 47.0616 38.2579 45.3035 40.8891C43.5454 43.5203 41.0466 45.5711 38.1229 46.7821C35.1993 47.9931 31.9823 48.3099 28.8786 47.6926C25.7749 47.0752 22.9239 45.5513 20.6863 43.3137C18.4487 41.0761 16.9248 38.2251 16.3074 35.1214C15.6901 32.0177 16.0069 28.8007 17.2179 25.8771C18.4289 22.9534 20.4797 20.4546 23.1109 18.6965C25.7421 16.9384 28.8355 16 32 16C36.2435 16 40.3131 17.6857 43.3137 20.6863C46.3143 23.6869 48 27.7565 48 32ZM32 20C29.6267 20.0001 27.3066 20.704 25.3333 22.0227C23.3601 23.3414 21.8221 25.2156 20.9139 27.4083C20.0058 29.601 19.7683 32.0138 20.2314 34.3415C20.6945 36.6692 21.8374 38.8074 23.5157 40.4855C25.1939 42.1637 27.3321 43.3065 29.6599 43.7695C31.9876 44.2324 34.4004 43.9948 36.5931 43.0865C38.7857 42.1782 40.6598 40.6401 41.9784 38.6668C43.2969 36.6934 44.0007 34.3733 44.0007 32C44.0008 30.424 43.6904 28.8635 43.0873 27.4075C42.4843 25.9515 41.6003 24.6285 40.4859 23.5141C39.3715 22.3998 38.0486 21.5158 36.5925 20.9128C35.1365 20.3097 33.576 19.9999 32 20Z"
		/>
	);
}

function DarkMode(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M24.9996 18.004C24.9986 20.7615 25.5408 23.4922 26.5951 26.0402C27.6494 28.5882 29.1953 30.9035 31.1445 32.854C33.0937 34.8046 35.4079 36.3521 37.9552 37.4082C40.5024 38.4643 43.2327 39.0084 45.9902 39.0093C47.9195 38.9706 49.8337 38.6609 51.6768 38.0893C52.0131 37.994 52.3698 37.9978 52.704 38.1002C53.0382 38.2025 53.3358 38.3992 53.561 38.6666C53.7862 38.9339 53.9295 39.2605 53.9736 39.6073C54.0177 39.9541 53.9609 40.3062 53.8098 40.6214C52.2655 43.9862 49.9299 46.9273 47.0025 49.1938C44.0751 51.4603 40.6427 52.9849 36.9984 53.6373C33.3541 54.2898 29.606 54.0508 26.0741 52.9407C22.5422 51.8307 19.3313 49.8825 16.7154 47.2625C14.0996 44.6426 12.1566 41.4286 11.0521 37.8949C9.94763 34.3612 9.71456 30.6128 10.3728 26.9695C11.031 23.3262 12.561 19.8963 14.8321 16.9725C17.1032 14.0486 20.0481 11.7177 23.4153 10.1787C23.7308 10.0276 24.0832 9.97063 24.4302 10.0148C24.7773 10.0589 25.1042 10.2022 25.3718 10.4276C25.6394 10.6529 25.8363 10.9506 25.9389 11.2851C26.0415 11.6195 26.0454 11.9765 25.9502 12.3131C25.3682 14.1562 25.0482 16.0719 24.9996 18.004Z"
		/>
	);
}

function Expand(props) {
	return (
		<motion.g>
			<path d="M12 14C12 12.8954 12.8954 12 14 12H26C27.1046 12 28 12.8954 28 14C28 15.1046 27.1046 16 26 16H18.8284L29.4142 26.5858C30.1953 27.3668 30.1953 28.6332 29.4142 29.4142C28.6332 30.1953 27.3668 30.1953 26.5858 29.4142L16 18.8284V26C16 27.1046 15.1046 28 14 28C12.8954 28 12 27.1046 12 26V14Z" />
			<path d="M34.5858 34.5858C35.3668 33.8047 36.6332 33.8047 37.4142 34.5858L48 45.1716V38C48 36.8954 48.8954 36 50 36C51.1046 36 52 36.8954 52 38V50C52 51.1046 51.1046 52 50 52H38C36.8954 52 36 51.1046 36 50C36 48.8954 36.8954 48 38 48H45.1716L34.5858 37.4142C33.8047 36.6332 33.8047 35.3668 34.5858 34.5858Z" />
		</motion.g>
	);
}

function ExpandTile(props) {
	return (
		<motion.g>
			<path d="M6 8.4C6 7.07452 7.07452 6 8.4 6H22.8C24.1255 6 25.2 7.07452 25.2 8.4C25.2 9.72548 24.1255 10.8 22.8 10.8H14.1941L28.8971 25.5029C29.8343 26.4402 29.8343 27.9598 28.8971 28.8971C27.9598 29.8343 26.4402 29.8343 25.5029 28.8971L10.8 14.1941V22.8C10.8 24.1255 9.72548 25.2 8.4 25.2C7.07452 25.2 6 24.1255 6 22.8V8.4Z" />
			<path d="M35.1029 35.1029C36.0402 34.1657 37.5598 34.1657 38.4971 35.1029L53.2 49.8059V41.2C53.2 39.8745 54.2745 38.8 55.6 38.8C56.9255 38.8 58 39.8745 58 41.2V55.6C58 56.9255 56.9255 58 55.6 58H41.2C39.8745 58 38.8 56.9255 38.8 55.6C38.8 54.2745 39.8745 53.2 41.2 53.2H49.8059L35.1029 38.4971C34.1657 37.5598 34.1657 36.0402 35.1029 35.1029Z" />
		</motion.g>
	);
}

function CollapseTile(props) {
	return (
		<motion.g>
			<path d="M57.2971 57.2971C56.3598 58.2343 54.8402 58.2343 53.9029 57.2971L39.2 42.5941V51.2C39.2 52.5255 38.1255 53.6 36.8 53.6C35.4745 53.6 34.4 52.5255 34.4 51.2V36.8C34.4 35.4745 35.4745 34.4 36.8 34.4H51.2C52.5255 34.4 53.6 35.4745 53.6 36.8C53.6 38.1255 52.5255 39.2 51.2 39.2H42.5941L57.2971 53.9029C58.2343 54.8402 58.2343 56.3598 57.2971 57.2971Z" />
			<path d="M29.6 27.2C29.6 28.5255 28.5255 29.6 27.2 29.6H12.8C11.4745 29.6 10.4 28.5255 10.4 27.2C10.4 25.8745 11.4745 24.8 12.8 24.8H21.4059L6.70295 10.097C5.76569 9.15977 5.76569 7.64018 6.70295 6.70292C7.6402 5.76566 9.1598 5.76566 10.0971 6.70292L24.8 21.4059V12.8C24.8 11.4745 25.8745 10.4 27.2 10.4C28.5255 10.4 29.6 11.4745 29.6 12.8V27.2Z" />
		</motion.g>
	);
}

function ExpandFlipped(props) {
	return (
		<motion.g>
			<path d="M52 14C52 12.8954 51.1046 12 50 12H38C36.8954 12 36 12.8954 36 14C36 15.1046 36.8954 16 38 16H45.1716L34.5858 26.5858C33.8047 27.3668 33.8047 28.6332 34.5858 29.4142C35.3668 30.1953 36.6332 30.1953 37.4142 29.4142L48 18.8284V26C48 27.1046 48.8954 28 50 28C51.1046 28 52 27.1046 52 26V14Z" />
			<path d="M29.4142 34.5858C28.6332 33.8047 27.3668 33.8047 26.5858 34.5858L16 45.1716V38C16 36.8954 15.1046 36 14 36C12.8954 36 12 36.8954 12 38V50C12 51.1046 12.8954 52 14 52H26C27.1046 52 28 51.1046 28 50C28 48.8954 27.1046 48 26 48H18.8284L29.4142 37.4142C30.1953 36.6332 30.1953 35.3668 29.4142 34.5858Z" />
		</motion.g>
	);
}

function CollapseFlipped(props) {
	return (
		<motion.g>
			<path d="M34 28C34 29.1046 34.8954 30 36 30H48C49.1046 30 50 29.1046 50 28C50 26.8954 49.1046 26 48 26H40.8284L51.4142 15.4142C52.1953 14.6332 52.1953 13.3668 51.4142 12.5858C50.6332 11.8047 49.3668 11.8047 48.5858 12.5858L38 23.1716V16C38 14.8954 37.1046 14 36 14C34.8954 14 34 14.8954 34 16V28Z" />
			<path d="M23.1716 38L12.5858 48.5858C11.8047 49.3668 11.8047 50.6332 12.5858 51.4142C13.3668 52.1953 14.6332 52.1953 15.4142 51.4142L26 40.8284V48C26 49.1046 26.8954 50 28 50C29.1046 50 30 49.1046 30 48V36C30 34.8954 29.1046 34 28 34H16C14.8954 34 14 34.8954 14 36C14 37.1046 14.8954 38 16 38H23.1716Z" />
		</motion.g>
	);
}

function Fullscreen(props) {
	return (
		<motion.g>
			<path d="M14 21C14 19.8954 14.8954 19 16 19H24C25.1046 19 26 18.1046 26 17C26 15.8954 25.1046 15 24 15H16C12.6863 15 10 17.6863 10 21V27C10 28.1046 10.8954 29 12 29C13.1046 29 14 28.1046 14 27V21Z" />
			<path d="M50 21C50 19.8954 49.1046 19 48 19H40C38.8954 19 38 18.1046 38 17C38 15.8954 38.8954 15 40 15H48C51.3137 15 54 17.6863 54 21V27C54 28.1046 53.1046 29 52 29C50.8954 29 50 28.1046 50 27V21Z" />
			<path d="M16 45C14.8954 45 14 44.1046 14 43V37C14 35.8954 13.1046 35 12 35C10.8954 35 10 35.8954 10 37V43C10 46.3137 12.6863 49 16 49H24C25.1046 49 26 48.1046 26 47C26 45.8954 25.1046 45 24 45H16Z" />
			<path d="M50 43C50 44.1046 49.1046 45 48 45H40C38.8954 45 38 45.8954 38 47C38 48.1046 38.8954 49 40 49H48C51.3137 49 54 46.3137 54 43V37C54 35.8954 53.1046 35 52 35C50.8954 35 50 35.8954 50 37V43Z" />
		</motion.g>
	);
}

function FullscreenAlt1(props) {
	return (
		<motion.g>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M38 20C38 18.8954 38.8954 18 40 18H48C49.1046 18 50 18.8954 50 20V28C50 29.1046 49.1046 30 48 30C46.8954 30 46 29.1046 46 28V22H40C38.8954 22 38 21.1046 38 20Z"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M16 34C17.1046 34 18 34.8954 18 36V42H24C25.1046 42 26 42.8954 26 44C26 45.1046 25.1046 46 24 46H16C14.8954 46 14 45.1046 14 44V36C14 34.8954 14.8954 34 16 34Z"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M6 14C6 11.7909 7.79086 10 10 10H54C56.2091 10 58 11.7909 58 14V50C58 52.2091 56.2091 54 54 54H10C7.79086 54 6 52.2091 6 50V14ZM54 14H10V50H54V14Z"
			/>
		</motion.g>
	);
}

function FullscreenAlt2(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M58 52H52C51.4696 52 50.9609 51.7893 50.5858 51.4142C50.2107 51.0391 50 50.5304 50 50C50 49.4696 50.2107 48.9609 50.5858 48.5858C50.9609 48.2107 51.4696 48 52 48H56V44C56 43.4696 56.2107 42.9609 56.5858 42.5858C56.9609 42.2107 57.4696 42 58 42C58.5304 42 59.0391 42.2107 59.4142 42.5858C59.7893 42.9609 60 43.4696 60 44V50C60 50.5304 59.7893 51.0391 59.4142 51.4142C59.0391 51.7893 58.5304 52 58 52ZM58 22C57.4696 22 56.9609 21.7893 56.5858 21.4142C56.2107 21.0391 56 20.5304 56 20V16H52C51.4696 16 50.9609 15.7893 50.5858 15.4142C50.2107 15.0391 50 14.5304 50 14C50 13.4696 50.2107 12.9609 50.5858 12.5858C50.9609 12.2107 51.4696 12 52 12H58C58.5304 12 59.0391 12.2107 59.4142 12.5858C59.7893 12.9609 60 13.4696 60 14V20C60 20.5304 59.7893 21.0391 59.4142 21.4142C59.0391 21.7893 58.5304 22 58 22ZM14 14C14 14.5304 13.7893 15.0391 13.4142 15.4142C13.0391 15.7893 12.5304 16 12 16H8V20C8 20.5304 7.78929 21.0391 7.41421 21.4142C7.03914 21.7893 6.53043 22 6 22C5.46957 22 4.96086 21.7893 4.58579 21.4142C4.21071 21.0391 4 20.5304 4 20V14C4 13.4696 4.21071 12.9609 4.58579 12.5858C4.96086 12.2107 5.46957 12 6 12H12C12.5304 12 13.0391 12.2107 13.4142 12.5858C13.7893 12.9609 14 13.4696 14 14ZM11 43.5V20.5C11 20.1022 11.158 19.7206 11.4393 19.4393C11.7206 19.158 12.1022 19 12.5 19H51.5C51.8978 19 52.2794 19.158 52.5607 19.4393C52.842 19.7206 53 20.1022 53 20.5V43.5C53 43.8978 52.842 44.2794 52.5607 44.5607C52.2794 44.842 51.8978 45 51.5 45H12.5C12.1022 45 11.7206 44.842 11.4393 44.5607C11.158 44.2794 11 43.8978 11 43.5ZM6 42C6.53043 42 7.03914 42.2107 7.41421 42.5858C7.78929 42.9609 8 43.4696 8 44V48H12C12.5304 48 13.0391 48.2107 13.4142 48.5858C13.7893 48.9609 14 49.4696 14 50C14 50.5304 13.7893 51.0391 13.4142 51.4142C13.0391 51.7893 12.5304 52 12 52H6C5.46957 52 4.96086 51.7893 4.58579 51.4142C4.21071 51.0391 4 50.5304 4 50V44C4 43.4696 4.21071 42.9609 4.58579 42.5858C4.96086 42.2107 5.46957 42 6 42V42Z"
		/>
	);
}

function Preferences(props) {
	return (
		<motion.g>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M20 30C23.7277 30 26.8599 27.4505 27.748 24H46C47.1046 24 48 23.1046 48 22C48 20.8954 47.1046 20 46 20H27.748C26.8599 16.5495 23.7277 14 20 14C15.5817 14 12 17.5817 12 22C12 26.4183 15.5817 30 20 30ZM20 26C17.7909 26 16 24.2091 16 22C16 19.7909 17.7909 18 20 18C22.2091 18 24 19.7909 24 22C24 24.2091 22.2091 26 20 26Z"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M44 50C40.2723 50 37.1401 47.4505 36.252 44H18C16.8954 44 16 43.1046 16 42C16 40.8954 16.8954 40 18 40H36.252C37.1401 36.5495 40.2723 34 44 34C48.4183 34 52 37.5817 52 42C52 46.4183 48.4183 50 44 50ZM44 46C46.2091 46 48 44.2091 48 42C48 39.7909 46.2091 38 44 38C41.7909 38 40 39.7909 40 42C40 44.2091 41.7909 46 44 46Z"
			/>
		</motion.g>
	);
}

function MoreCircleOutline(props) {
	return (
		<motion.g>
			<path d="M22 35C23.6569 35 25 33.6569 25 32C25 30.3431 23.6569 29 22 29C20.3431 29 19 30.3431 19 32C19 33.6569 20.3431 35 22 35Z" />
			<path d="M32 35C33.6569 35 35 33.6569 35 32C35 30.3431 33.6569 29 32 29C30.3431 29 29 30.3431 29 32C29 33.6569 30.3431 35 32 35Z" />
			<path d="M45 32C45 33.6569 43.6569 35 42 35C40.3431 35 39 33.6569 39 32C39 30.3431 40.3431 29 42 29C43.6569 29 45 30.3431 45 32Z" />
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M8 32C8 45.2548 18.7452 56 32 56C45.2548 56 56 45.2548 56 32C56 18.7452 45.2548 8 32 8C18.7452 8 8 18.7452 8 32ZM11.9996 32.0005C11.9993 20.9543 20.9538 11.9994 32 11.9991C43.0462 11.9991 52.0014 20.9538 52.0014 32C52.0014 43.046 43.047 52.0006 32.001 52.0009C20.9548 52.0012 11.9999 43.0467 11.9996 32.0005Z"
			/>
		</motion.g>
	);
}

function OpenLink(props) {
	return (
		<motion.g>
			<path d="M37.5 11C36.3954 11 35.5 11.8954 35.5 13C35.5 14.1046 36.3954 15 37.5 15H46.6716L30.5858 31.0858C29.8047 31.8668 29.8047 33.1332 30.5858 33.9142C31.3668 34.6953 32.6332 34.6953 33.4142 33.9142L49.5 17.8284V27C49.5 28.1046 50.3954 29 51.5 29C52.6046 29 53.5 28.1046 53.5 27V13C53.5 11.8954 52.6046 11 51.5 11H37.5Z" />
			<path d="M16 22C16 20.8954 16.8954 20 18 20H22C23.1046 20 24 19.1046 24 18C24 16.8954 23.1046 16 22 16H18C14.6863 16 12 18.6863 12 22V47C12 50.3137 14.6863 53 18 53H43C46.3137 53 49 50.3137 49 47V43C49 41.8954 48.1046 41 47 41C45.8954 41 45 41.8954 45 43V47C45 48.1046 44.1046 49 43 49H18C16.8954 49 16 48.1046 16 47V22Z" />
		</motion.g>
	);
}

function Unsplash(props) {
	return (
		<motion.g>
			<path d="M24.1538 22.8464V11.0771H39.8461V22.8464H24.1538ZM39.8461 29.3848H52.9231V52.9233H11.0769V29.3848H24.1538V41.1541H39.8461V29.3848Z" />
		</motion.g>
	);
}

function Link(props) {
	return (
		<motion.g>
			<path d="M50.2254 13.7746C45.1926 8.7418 37.0328 8.7418 32 13.7746L27.2092 18.5654C22.4995 23.2751 22.4995 30.9112 27.2092 35.621L27.7941 36.2059C28.5684 36.9801 29.8238 36.9801 30.598 36.2059C31.3723 35.4316 31.3723 34.1762 30.598 33.402L30.0132 32.8171C26.8519 29.6558 26.8519 24.5305 30.0132 21.3693L34.8039 16.5785C38.2882 13.0943 43.9372 13.0943 47.4215 16.5785C50.9057 20.0628 50.9057 25.7118 47.4215 29.1961L43.9166 32.701C43.1423 33.4753 43.1423 34.7306 43.9166 35.5049C44.6909 36.2792 45.9462 36.2792 46.7205 35.5049L50.2254 32C55.2582 26.9672 55.2582 18.8074 50.2254 13.7746Z" />
			<path d="M13.7746 50.2254C18.8074 55.2582 26.9672 55.2582 32 50.2254L36.7908 45.4346C41.5005 40.7249 41.5005 33.0888 36.7908 28.379L36.2059 27.7941C35.4316 27.0199 34.1762 27.0199 33.402 27.7941C32.6277 28.5684 32.6277 29.8238 33.402 30.598L33.9868 31.1829C37.1481 34.3442 37.1481 39.4695 33.9868 42.6307L29.1961 47.4215C25.7118 50.9057 20.0628 50.9057 16.5785 47.4215C13.0943 43.9372 13.0943 38.2882 16.5785 34.8039L20.0834 31.299C20.8577 30.5247 20.8577 29.2694 20.0834 28.4951C19.3091 27.7208 18.0538 27.7208 17.2795 28.4951L13.7746 32C8.7418 37.0328 8.7418 45.1926 13.7746 50.2254Z" />
		</motion.g>
	);
}

function More(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M53.0208 32.0208C53.0208 34.7822 50.7822 37.0208 48.0208 37.0208C45.2594 37.0208 43.0208 34.7822 43.0208 32.0208C43.0208 29.2593 45.2594 27.0208 48.0208 27.0208C50.7822 27.0208 53.0208 29.2593 53.0208 32.0208ZM37.0208 32.0208C37.0208 34.7822 34.7822 37.0208 32.0208 37.0208C29.2594 37.0208 27.0208 34.7822 27.0208 32.0208C27.0208 29.2593 29.2594 27.0208 32.0208 27.0208C34.7822 27.0207 37.0209 29.2592 37.0209 32.0207C37.0209 32.0207 37.0209 32.0207 37.0209 32.0208H37.0208ZM16.0208 27.0208C18.7822 27.0208 21.0208 29.2593 21.0208 32.0208C21.0208 34.7822 18.7822 37.0208 16.0208 37.0208C13.2594 37.0208 11.0208 34.7822 11.0208 32.0208V32.0209C11.0208 29.2595 13.2593 27.021 16.0206 27.0209L16.0208 27.0208Z"
		/>
	);
}

function HeartEmpty(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M16.0002 26C13.7011 26 5.00042 20.2731 5.00042 12.5386L5.00042 12.5385C4.96091 8.97471 7.7207 6.05005 11.1703 6V6C13.0643 6.00815 14.8479 6.92206 16.0002 8.47491H16.0002C17.1526 6.92202 18.9362 6.00809 20.8302 6V6C24.2798 6.04998 27.0396 8.97468 27.0001 12.5385C27.0001 20.2731 18.2995 26 16.0002 26V26ZM20.8302 7.8182C17.978 7.8182 17.0104 10.5455 16.0002 10.5455C14.9901 10.5455 14.0225 7.8182 11.1703 7.8182V7.8182C8.69229 7.86731 6.71996 9.97849 6.76039 12.5386C6.76039 19.4025 14.849 24.1676 16.0002 24.1818C17.1515 24.1676 25.2401 19.4025 25.2401 12.5386V12.5385C25.2805 9.97847 23.3082 7.86728 20.8302 7.81819V7.8182Z"
		/>
	);
}

function AddPage(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M14 14C9.58172 14 6 17.5817 6 22V42C6 46.4183 9.58172 50 14 50H50C54.4183 50 58 46.4183 58 42V22C58 17.5817 54.4183 14 50 14H14ZM30 24C30 22.8954 30.8954 22 32 22C33.1046 22 34 22.8954 34 24V30H40C41.1046 30 42 30.8954 42 32C42 33.1046 41.1046 34 40 34H34V40C34 41.1046 33.1046 42 32 42C30.8954 42 30 41.1046 30 40V34H24C22.8954 34 22 33.1046 22 32C22 30.8954 22.8954 30 24 30H30V24Z"
		/>
	);
}

function GridFilled(props) {
	return (
		<motion.g>
			<path d="M16 12C13.7909 12 12 13.7909 12 16V25C12 27.2091 13.7909 29 16 29H25C27.2091 29 29 27.2091 29 25V16C29 13.7909 27.2091 12 25 12H16Z" />
			<path d="M16 35C13.7909 35 12 36.7909 12 39V48C12 50.2091 13.7909 52 16 52H25C27.2091 52 29 50.2091 29 48V39C29 36.7909 27.2091 35 25 35H16Z" />
			<path d="M35 16C35 13.7909 36.7909 12 39 12H48C50.2091 12 52 13.7909 52 16V25C52 27.2091 50.2091 29 48 29H39C36.7909 29 35 27.2091 35 25V16Z" />
			<path d="M39 35C36.7909 35 35 36.7909 35 39V48C35 50.2091 36.7909 52 39 52H48C50.2091 52 52 50.2091 52 48V39C52 36.7909 50.2091 35 48 35H39Z" />
		</motion.g>
	);
}

function Grid(props) {
	return (
		<motion.g>
			<path d="M16 12C13.7909 12 12 13.7909 12 16V26C12 28.2091 13.7909 30 16 30H26C28.2091 30 30 28.2091 30 26V16C30 13.7909 28.2091 12 26 12H16Z" />
			<path d="M38 12C35.7909 12 34 13.7909 34 16V26C34 28.2091 35.7909 30 38 30H48C50.2091 30 52 28.2091 52 26V16C52 13.7909 50.2091 12 48 12H38Z" />
			<path d="M34 38C34 35.7909 35.7909 34 38 34H48C50.2091 34 52 35.7909 52 38V48C52 50.2091 50.2091 52 48 52H38C35.7909 52 34 50.2091 34 48V38Z" />
			<path d="M16 34C13.7909 34 12 35.7909 12 38V48C12 50.2091 13.7909 52 16 52H26C28.2091 52 30 50.2091 30 48V38C30 35.7909 28.2091 34 26 34H16Z" />
		</motion.g>
	);
}

function View(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M32.0057 48.0208C17.3297 48.0208 10.0402 36.3485 8.22567 32.943C7.91778 32.3667 7.91778 31.6748 8.22567 31.0986C10.0402 27.6931 17.3297 16.0208 32.0057 16.0208C46.6817 16.0208 53.9712 27.6931 55.7857 31.0986C56.0938 31.6748 56.0938 32.3668 55.7857 32.943C53.9712 36.3485 46.6817 48.0208 32.0057 48.0208ZM32.0208 21.0208C25.9456 21.021 21.021 25.9461 21.0213 32.0213C21.0215 38.0964 25.9466 43.0211 32.0218 43.0208C38.0967 43.0205 43.0213 38.0957 43.0213 32.0208V32.02C43.0213 25.9448 38.0964 21.02 32.0213 21.02C32.0208 21.02 32.0204 21.02 32.02 21.02L32.0208 21.0208ZM32.0208 39.0215C28.1548 39.0215 25.0208 35.8874 25.0208 32.0215C25.0208 28.1555 28.1548 25.0215 32.0208 25.0215C35.8868 25.0215 39.0208 28.1555 39.0208 32.0215V32.0211C39.0208 35.8869 35.887 39.0208 32.0212 39.0211L32.0208 39.0215Z"
		/>
	);
}

function Title(props) {
	return (
		<path d="M19.5 13C18.1193 13 17 14.1193 17 15.5C17 16.8807 18.1193 18 19.5 18H29.5V48.5C29.5 49.8807 30.6193 51 32 51C33.3807 51 34.5 49.8807 34.5 48.5V18H44.5C45.8807 18 47 16.8807 47 15.5C47 14.1193 45.8807 13 44.5 13H19.5Z" />
	);
}

function TitleOff(props) {
	return (
		<motion.g>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M29.5 38.0061V48.5C29.5 49.8807 30.6193 51 32 51C33.3807 51 34.5 49.8807 34.5 48.5V43.0212L29.5 38.0061ZM34.5 25.9528V18H44.5C45.8807 18 47 16.8807 47 15.5C47 14.1193 45.8807 13 44.5 13H21.568C23.0484 14.4778 24.742 16.1718 26.5677 18H29.5V20.9379C31.1197 22.5615 32.8021 24.249 34.5 25.9528Z"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M53.403 50.5808L13.4106 10.5765C12.6351 9.78981 11.3688 9.78071 10.5822 10.5561C9.79556 11.3315 9.78646 12.5978 10.5619 13.3845C10.5688 13.3915 10.5757 13.3984 10.5828 13.4053L50.5755 53.4092C51.343 54.2036 52.6091 54.2254 53.4035 53.4579C54.1978 52.6904 54.2196 51.4243 53.4521 50.6299C53.436 50.6132 53.4196 50.5969 53.403 50.5808Z"
			/>
		</motion.g>
	);
}

function Text(props) {
	return (
		<motion.g>
			<path d="M8.58031 48C9.60321 48 10.5138 47.352 10.849 46.3856L13.1683 39.6993C13.2032 39.5987 13.298 39.5312 13.4045 39.5312H25.5484C25.655 39.5312 25.7499 39.5989 25.7847 39.6997L28.0905 46.3828C28.4244 47.3506 29.3354 48 30.3592 48C32.0213 48 33.1801 46.3513 32.6174 44.7874L23.2022 18.6243C22.6356 17.0498 21.1421 16 19.4688 16C17.7954 16 16.3019 17.0498 15.7353 18.6243L6.32082 44.7856C5.75771 46.3504 6.91726 48 8.58031 48ZM14.9837 35.4688C14.8119 35.4688 14.6913 35.2995 14.7474 35.1371L19.3107 21.9306C19.3352 21.8599 19.4018 21.8125 19.4766 21.8125C19.5514 21.8125 19.618 21.8599 19.6424 21.9306L24.2057 35.1371C24.2618 35.2995 24.1412 35.4688 23.9694 35.4688H14.9837Z" />
			<path d="M45.0039 48.5312C48.9727 48.5312 51.207 46.5156 52.0977 44.7188H52.2852V45.7188C52.2852 46.9786 53.3065 48 54.5664 48C55.8263 48 56.8477 46.9786 56.8477 45.7188V32.0625C56.8477 25.0781 51.3477 23.6875 47.5352 23.6875C44.0395 23.6875 40.7665 24.8209 38.8073 27.5436C38.0105 28.6509 38.7992 30.0791 40.1293 30.382C41.2187 30.6301 42.2931 30.0012 43.0669 29.1953C44.0216 28.2012 45.4992 27.4688 47.5977 27.4688C50.6133 27.4688 52.1602 29.0469 52.1602 31.7656V31.875C52.1602 33.5781 50.4102 33.5469 46.0977 34.0469C41.5508 34.5781 36.8945 35.7656 36.8945 41.2188C36.8945 45.9375 40.4414 48.5312 45.0039 48.5312ZM46.0195 44.7812C43.3789 44.7812 41.4727 43.5938 41.4727 41.2812C41.4727 38.7812 43.6914 37.8906 46.3945 37.5312C47.9102 37.3281 51.5039 36.9219 52.1758 36.25V39.3438C52.1758 42.1875 49.9102 44.7812 46.0195 44.7812Z" />
		</motion.g>
	);
}

function TextSize(props) {
	return (
		<motion.g>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M57.9023 45.2549C58.4298 46.569 57.4623 48 56.0463 48H55.7607C54.9332 48 54.1911 47.4903 53.894 46.718L50.8533 38.8119C50.779 38.6188 50.5935 38.4914 50.3866 38.4914H36.7191C36.5122 38.4914 36.3267 38.6188 36.2524 38.8119L33.2117 46.718C32.9146 47.4903 32.1725 48 31.345 48H31.2841C29.8691 48 28.9016 46.5709 29.4271 45.2572L40.1956 18.336C40.7599 16.9251 42.1264 16 43.646 16C45.1638 16 46.5291 16.9231 47.0946 18.3318L57.9023 45.2549ZM43.1001 21.0221C42.9498 21.4169 42.7942 21.817 42.6386 22.2171L37.8326 34.6772C37.7694 34.841 37.8903 35.0171 38.0658 35.0171H49.0399C49.2154 35.0171 49.3363 34.841 49.2731 34.6772L44.4671 22.2171C44.3319 21.8693 44.2048 21.5215 44.0789 21.1771C44.0594 21.1235 44.0398 21.07 44.0202 21.0165C43.8625 20.5855 43.2634 20.5932 43.1001 21.0221Z"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M25.2811 45.9884C25.6676 46.9513 24.9586 48 23.9209 48C23.3145 48 22.7707 47.6265 22.553 47.0605L20.4617 41.6231C20.4245 41.5266 20.3318 41.4629 20.2283 41.4629H10.7032C10.5997 41.4629 10.507 41.5266 10.4698 41.6231L8.36096 47.1062C8.15385 47.6447 7.63649 48 7.05954 48C6.07309 48 5.39856 47.0037 5.76492 46.0878L13.1576 27.606C13.5456 26.636 14.4851 26 15.5298 26C16.5733 26 17.512 26.6347 17.9007 27.6031L25.2811 45.9884ZM15.2413 29.2232C15.1117 29.5685 14.9744 29.9214 14.8372 30.2743L11.574 38.7343C11.5109 38.8981 11.6317 39.0743 11.8073 39.0743H19.1242C19.2998 39.0743 19.4207 38.8981 19.3575 38.7343L16.0943 30.2743C16.0013 30.0351 15.9139 29.796 15.8274 29.5592C15.7857 29.445 15.7442 29.3314 15.7023 29.2186C15.6225 29.0035 15.3219 29.0083 15.2413 29.2232Z"
			/>
		</motion.g>
	);
}

function TextSizeAlt(props) {
	return (
		<motion.g>
			<path d="M9 14C7.89543 14 7 14.8954 7 16C7 17.1046 7.89543 18 9 18H20.5C20.7761 18 21 18.2239 21 18.5V48C21 49.1046 21.8954 50 23 50C24.1046 50 25 49.1046 25 48V18.5C25 18.2239 25.2239 18 25.5 18H37C38.1046 18 39 17.1046 39 16C39 14.8954 38.1046 14 37 14H9Z" />
			<path d="M36 27.6C36 26.7163 36.7089 26 37.5833 26H53.4167C54.2911 26 55 26.7163 55 27.6C55 28.4837 54.2911 29.2 53.4167 29.2H47.0833V48.4C47.0833 49.2837 46.3745 50 45.5 50C44.6255 50 43.9167 49.2837 43.9167 48.4V29.2H37.5833C36.7089 29.2 36 28.4837 36 27.6Z" />
		</motion.g>
	);
}

function LengthenText(props) {
	return (
		<motion.g>
			<path d="M14 15C12.8954 15 12 15.8954 12 17C12 18.1046 12.8954 19 14 19H50C51.1046 19 52 18.1046 52 17C52 15.8954 51.1046 15 50 15H14Z" />
			<path d="M14 25C12.8954 25 12 25.8954 12 27C12 28.1046 12.8954 29 14 29H50C51.1046 29 52 28.1046 52 27C52 25.8954 51.1046 25 50 25H14Z" />
			<path d="M12 37C12 35.8954 12.8954 35 14 35H50C51.1046 35 52 35.8954 52 37C52 38.1046 51.1046 39 50 39H14C12.8954 39 12 38.1046 12 37Z" />
			<path d="M14 45C12.8954 45 12 45.8954 12 47C12 48.1046 12.8954 49 14 49H34C35.1046 49 36 48.1046 36 47C36 45.8954 35.1046 45 34 45H14Z" />
		</motion.g>
	);
}

function ShortenText(props) {
	return (
		<motion.g>
			<path d="M14 25C12.8954 25 12 25.8954 12 27C12 28.1046 12.8954 29 14 29H50C51.1046 29 52 28.1046 52 27C52 25.8954 51.1046 25 50 25H14Z" />
			<path d="M14 35C12.8954 35 12 35.8954 12 37C12 38.1046 12.8954 39 14 39H34C35.1046 39 36 38.1046 36 37C36 35.8954 35.1046 35 34 35H14Z" />
		</motion.g>
	);
}

function TextSizeIncrease(props) {
	return (
		<motion.g>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M10.5586 46.4014C10.2341 47.3571 9.33696 48 8.32766 48C6.7028 48 5.5657 46.394 6.10548 44.8614L15.3636 18.5746C15.9069 17.032 17.3645 16 19.0001 16C20.6356 16 22.0932 17.032 22.6365 18.5746L31.8953 44.8632C32.4347 46.3949 31.2983 48 29.6744 48C28.6642 48 27.7667 47.3557 27.4435 46.3987L25.182 39.7013C25.1477 39.5997 25.0524 39.5312 24.9451 39.5312H13.07C12.9629 39.5312 12.8677 39.5995 12.8332 39.7009L10.5586 46.4014ZM14.3788 35.1387C14.3239 35.3007 14.4445 35.4688 14.6156 35.4688H23.3998C23.5709 35.4688 23.6915 35.3007 23.6367 35.1387L19.1692 21.9284C19.1458 21.8591 19.0808 21.8125 19.0077 21.8125C18.9346 21.8125 18.8696 21.8591 18.8462 21.9284L14.3788 35.1387Z"
			/>
			<path d="M50.4143 20.5858C49.6332 19.8047 48.3669 19.8047 47.5858 20.5858L39.5858 28.5858C38.8048 29.3668 38.8048 30.6332 39.5858 31.4142C40.3669 32.1953 41.6332 32.1953 42.4143 31.4142L47.0001 26.8284V42C47.0001 43.1046 47.8955 44 49.0001 44C50.1046 44 51.0001 43.1046 51.0001 42V26.8284L55.5858 31.4142C56.3669 32.1953 57.6332 32.1953 58.4143 31.4142C59.1953 30.6332 59.1953 29.3668 58.4143 28.5858L50.4143 20.5858Z" />
		</motion.g>
	);
}

function TextSizeDecrease(props) {
	return (
		<motion.g>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M10.5586 46.4014C10.2341 47.3571 9.33696 48 8.32766 48C6.7028 48 5.5657 46.394 6.10548 44.8614L15.3636 18.5746C15.9069 17.032 17.3645 16 19.0001 16C20.6356 16 22.0932 17.032 22.6365 18.5746L31.8953 44.8632C32.4347 46.3949 31.2983 48 29.6744 48C28.6642 48 27.7667 47.3557 27.4435 46.3987L25.182 39.7013C25.1477 39.5997 25.0524 39.5312 24.9451 39.5312H13.07C12.9629 39.5312 12.8677 39.5995 12.8332 39.7009L10.5586 46.4014ZM14.3788 35.1387C14.3239 35.3007 14.4445 35.4688 14.6156 35.4688H23.3998C23.5709 35.4688 23.6915 35.3007 23.6367 35.1387L19.1692 21.9284C19.1458 21.8591 19.0808 21.8125 19.0077 21.8125C18.9346 21.8125 18.8696 21.8591 18.8462 21.9284L14.3788 35.1387Z"
			/>
			<path d="M58.4143 35.4142L50.4143 43.4142C49.6332 44.1953 48.3669 44.1953 47.5858 43.4142L39.5858 35.4142C38.8048 34.6332 38.8048 33.3668 39.5858 32.5858C40.3669 31.8047 41.6332 31.8047 42.4143 32.5858L47.0001 37.1716V22C47.0001 20.8954 47.8955 20 49.0001 20C50.1046 20 51.0001 20.8954 51.0001 22V37.1716L55.5858 32.5858C56.3669 31.8047 57.6332 31.8047 58.4143 32.5858C59.1953 33.3668 59.1953 34.6332 58.4143 35.4142Z" />
		</motion.g>
	);
}

function FitLandscape(props) {
	return (
		<motion.g>
			<path d="M34.865 8C35.7128 8 36.176 8.98886 35.6332 9.64018L32.7682 13.0781C32.3684 13.5579 31.6316 13.5579 31.2318 13.0781L28.3668 9.64018C27.824 8.98886 28.2872 8 29.135 8H34.865Z" />
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M18 18C14.6863 18 12 20.6863 12 24V40C12 43.3137 14.6863 46 18 46H46C49.3137 46 52 43.3137 52 40V24C52 20.6863 49.3137 18 46 18H18ZM46 22H18C16.8954 22 16 22.8954 16 24V40C16 41.1046 16.8954 42 18 42H46C47.1046 42 48 41.1046 48 40V24C48 22.8954 47.1046 22 46 22Z"
			/>
			<path d="M29.135 56C28.2872 56 27.824 55.0111 28.3668 54.3598L31.2318 50.9219C31.6316 50.4421 32.3684 50.4421 32.7682 50.9219L35.6332 54.3598C36.176 55.0111 35.7128 56 34.865 56H29.135Z" />
		</motion.g>
	);
}

function FillLandscape(props) {
	return (
		<motion.g>
			<path d="M34.865 14C35.7128 14 36.176 13.0111 35.6332 12.3598L32.7682 8.92183C32.3684 8.44207 31.6316 8.44207 31.2318 8.92183L28.3668 12.3598C27.824 13.0111 28.2872 14 29.135 14H34.865Z" />
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M18 18C14.6863 18 12 20.6863 12 24V40C12 43.3137 14.6863 46 18 46H46C49.3137 46 52 43.3137 52 40V24C52 20.6863 49.3137 18 46 18H18ZM46 22H18C16.8954 22 16 22.8954 16 24V40C16 41.1045 16.8954 42 18 42H46C47.1046 42 48 41.1045 48 40V24C48 22.8954 47.1046 22 46 22Z"
			/>
			<path d="M29.135 50C28.2872 50 27.824 50.9888 28.3668 51.6401L31.2318 55.0781C31.6316 55.5578 32.3684 55.5578 32.7682 55.0781L35.6332 51.6401C36.176 50.9888 35.7128 50 34.865 50H29.135Z" />
		</motion.g>
	);
}

function Crop(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M16 10C16 8.89543 16.8954 8 18 8C19.1046 8 20 8.89543 20 10V16H42C45.3137 16 48 18.6863 48 22V44H54C55.1046 44 56 44.8954 56 46C56 47.1046 55.1046 48 54 48H48V54C48 55.1046 47.1046 56 46 56C44.8954 56 44 55.1046 44 54V48H22C18.6863 48 16 45.3137 16 42V20H10C8.89543 20 8 19.1046 8 18C8 16.8954 8.89543 16 10 16H16V10ZM21 20C20.4477 20 20 20.4477 20 21V42C20 43.1046 20.8954 44 22 44H43C43.5523 44 44 43.5523 44 43V22C44 20.8954 43.1046 20 42 20H21Z"
		/>
	);
}

function Cut(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M34.945 36.5209L39.3183 33.8277C39.9614 33.4318 40.7727 33.4318 41.4159 33.8277L55.5438 42.5277C55.981 42.7964 56.1439 43.3524 55.9207 43.8146C55.0956 45.531 52.62 48.9765 46.9649 45.4952C45.3012 44.4706 40.494 41.5652 34.9549 38.2302C34.4812 37.9455 34.3279 37.3308 34.6126 36.8571C34.6949 36.7201 34.8089 36.6048 34.945 36.5209H34.945ZM19.6985 51.7609C15.7298 54.0418 10.8872 53.0887 8.88247 49.6315C6.87777 46.1743 8.46957 41.5228 12.4381 39.2415C13.9848 38.3526 18.9081 35.4166 24.5964 32.0073C18.9081 28.5979 13.9848 25.6621 12.4381 24.7732C8.46957 22.492 6.87807 17.8404 8.88247 14.3832C10.8869 10.926 15.7298 9.97315 19.6985 12.2539C22.5303 13.7701 24.2163 16.8 24.0121 20.0057C23.881 21.6622 24.598 23.2725 25.9169 24.2835L31.6163 27.7935C38.48 23.667 44.9735 19.7463 46.9649 18.5204C52.6237 15.0367 55.0989 18.4888 55.9223 20.2041H55.9223C56.1447 20.6656 55.981 21.2205 55.5438 21.4875L25.9169 39.7311C24.598 40.742 23.881 42.3523 24.0121 44.0089C24.2163 47.2146 22.5303 50.2444 19.6985 51.7607V51.7609ZM19.5973 20.4083C20.5948 18.8029 19.8028 16.6426 17.8287 15.5834C15.8546 14.5242 13.446 14.9667 12.4487 16.5723C11.4514 18.1779 12.2433 20.3378 14.2174 21.3971C16.1915 22.4564 18.6002 22.0136 19.5973 20.4081V20.4083ZM17.8059 48.3956C19.7721 47.3316 20.561 45.1618 19.5674 43.5492C18.5738 41.9366 16.1748 41.4919 14.2086 42.556C12.2424 43.6201 11.4535 45.7898 12.4469 47.4024C13.4403 49.015 15.8397 49.4597 17.8059 48.3956Z"
		/>
	);
}

function Copy(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M24 19.2171V11C24 7.68629 26.6863 5 30 5H36.4006C38.0591 5 39.6435 5.68645 40.7778 6.89635L52.3772 19.269C52.5923 19.4985 52.7877 19.743 52.9624 20H53V20.056C53.6481 21.0331 54 22.1856 54 23.3727V39C54 42.3137 51.3137 45 48 45H40V53C40 56.3137 37.3137 59 34 59H16C12.6863 59 10 56.3137 10 53V25C10 21.6863 12.6863 19 16 19H22.4006C22.9462 19 23.4838 19.0743 24 19.2171ZM50 39C50 40.1046 49.1046 41 48 41H40V37.3727C40 36.1856 39.6481 35.0331 39 34.056V34H38.9624C38.7877 33.743 38.5923 33.4985 38.3772 33.269L28 22.2V11C28 9.89543 28.8954 9 30 9H35V18C35 21.3137 37.6863 24 41 24H50V39ZM47.5796 20H41C39.8954 20 39 19.1046 39 18V10.8485L47.5796 20ZM34 55C35.1046 55 36 54.1046 36 53V38H27C23.6863 38 21 35.3137 21 32V23H16C14.8954 23 14 23.8954 14 25V53C14 54.1046 14.8954 55 16 55H34ZM27 34H33.5796L25 24.8485V32C25 33.1046 25.8954 34 27 34Z"
		/>
	);
}

function Paste(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M32 6C35.866 6 39 9.13401 39 13H42C46.4183 13 50 16.5817 50 21V46C50 50.4183 46.4183 54 42 54H22C17.5817 54 14 50.4183 14 46V21C14 16.5817 17.5817 13 22 13H25C25 9.13401 28.134 6 32 6ZM40 17H42C44.2091 17 46 18.7909 46 21V46C46 48.2091 44.2091 50 42 50H22C19.7909 50 18 48.2091 18 46V21C18 18.7909 19.7909 17 22 17H24V21C24 22.1046 24.8954 23 26 23H38C39.1046 23 40 22.1046 40 21V17ZM32 16C33.6569 16 35 14.6569 35 13C35 11.3431 33.6569 10 32 10C30.3431 10 29 11.3431 29 13C29 14.6569 30.3431 16 32 16Z"
		/>
	);
}

function Share(props) {
	return (
		<motion.g>
			<path d="M33.4142 9.58579C32.6332 8.80474 31.3668 8.80474 30.5858 9.58579L24.5858 15.5858C23.8047 16.3668 23.8047 17.6332 24.5858 18.4142C25.3668 19.1953 26.6332 19.1953 27.4142 18.4142L30 15.8284V36C30 37.1046 30.8954 38 32 38C33.1046 38 34 37.1046 34 36V15.8284L36.5858 18.4142C37.3668 19.1953 38.6332 19.1953 39.4142 18.4142C40.1953 17.6332 40.1953 16.3668 39.4142 15.5858L33.4142 9.58579Z" />
			<path d="M14 30C14 25.5817 17.5817 22 22 22H24C25.1046 22 26 22.8954 26 24C26 25.1046 25.1046 26 24 26H22C19.7909 26 18 27.7909 18 30V46C18 48.2091 19.7909 50 22 50H42C44.2091 50 46 48.2091 46 46V30C46 27.7909 44.2091 26 42 26H40C38.8954 26 38 25.1046 38 24C38 22.8954 38.8954 22 40 22H42C46.4183 22 50 25.5817 50 30V46C50 50.4183 46.4183 54 42 54H22C17.5817 54 14 50.4183 14 46V30Z" />
		</motion.g>
	);
}

function Code(props) {
	return (
		<motion.g>
			<path d="M25.4142 19.4142C26.1953 18.6332 26.1953 17.3668 25.4142 16.5858C24.6332 15.8047 23.3668 15.8047 22.5858 16.5858L8.58579 30.5858C7.80474 31.3668 7.80474 32.6332 8.58579 33.4142L22.5858 47.4142C23.3668 48.1953 24.6332 48.1953 25.4142 47.4142C26.1953 46.6332 26.1953 45.3668 25.4142 44.5858L12.8284 32L25.4142 19.4142Z" />
			<path d="M38.5858 19.4142C37.8047 18.6332 37.8047 17.3668 38.5858 16.5858C39.3668 15.8047 40.6332 15.8047 41.4142 16.5858L55.4142 30.5858C56.1953 31.3668 56.1953 32.6332 55.4142 33.4142L41.4142 47.4142C40.6332 48.1953 39.3668 48.1953 38.5858 47.4142C37.8047 46.6332 37.8047 45.3668 38.5858 44.5858L51.1716 32L38.5858 19.4142Z" />{" "}
		</motion.g>
	);
}

function Image(props) {
	return (
		<g>
			<path d="M22 30C24.2091 30 26 28.2091 26 26C26 23.7909 24.2091 22 22 22C19.7909 22 18 23.7909 18 26C18 28.2091 19.7909 30 22 30Z" />
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M16 12C11.5817 12 8 15.5817 8 20V44C8 48.4183 11.5817 52 16 52H48C52.4183 52 56 48.4183 56 44V20C56 15.5817 52.4183 12 48 12H16ZM16 16C13.7909 16 12 17.7909 12 20V44L18.2131 37.7869C19.2456 36.7544 20.8716 36.6152 22.0645 37.4573L28.1796 41.7738C28.3677 41.9066 28.6222 41.8937 28.796 41.7426L37.8886 33.836C39.0777 32.802 40.8642 32.8642 41.9785 33.9785L52 44V20C52 17.7909 50.2091 16 48 16H16Z"
			/>
		</g>
	);
}

function Background(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M16 17C16 13.6863 18.6863 11 22 11H52C55.3137 11 58 13.6863 58 17V37C58 40.3137 55.3137 43 52 43V23C52 19.6863 49.3137 17 46 17H16ZM12 25H42C43.1046 25 44 25.8954 44 27V47C44 48.1046 43.1046 49 42 49H12C10.8954 49 10 48.1046 10 47V27C10 25.8954 10.8954 25 12 25ZM6 27C6 23.6863 8.68629 21 12 21H42C45.3137 21 48 23.6863 48 27V47C48 50.3137 45.3137 53 42 53H12C8.68629 53 6 50.3137 6 47V27Z"
		/>
	);
}

function MoveIndicator(props) {
	return (
		<g>
			<circle cx="15.2731" cy="24.0001" r="3.63636" />
			<circle cx="31.2731" cy="24.0001" r="3.63636" />
			<circle cx="47.2731" cy="24.0001" r="3.63636" />
			<circle cx="15.2731" cy="40.0001" r="3.63636" />
			<circle cx="31.2731" cy="40.0001" r="3.63636" />
			<circle cx="47.2731" cy="40.0001" r="3.63636" />
		</g>
	);
}

function MoveIndicator4Dots(props) {
	return (
		<g>
			<circle cx="21" cy="23" r="4" />
			<circle cx="42.8182" cy="23" r="4" />
			<circle cx="21" cy="41.9091" r="4" />
			<circle cx="42.8182" cy="41.9091" r="4" />
		</g>
	);
}

function VideoCamera(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M56.7661 45.8477C56.0186 46.1574 55.1582 45.9863 54.5861 45.4141L44.5861 35.4141C44.211 35.0391 44.0002 34.5304 44.0001 34V30V30.0003C44.0001 29.4699 44.2108 28.9612 44.5859 28.5861L54.5859 18.5861H54.5859C55.367 17.8052 56.6334 17.8054 57.4143 18.5866C57.7892 18.9615 57.9998 19.47 57.9999 20.0002V44.0002V44.0003C57.9999 44.8089 57.513 45.538 56.766 45.8477L56.7661 45.8477ZM12 16H36C39.3137 16 42 18.6863 42 22V42C42 45.3137 39.3137 48 36 48H12C8.68629 48 6 45.3137 6 42V22C6 18.6863 8.68629 16 12 16H12Z"
		/>
	);
}

function Microphone(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M34.0208 47.8686V52.0068H42.0208C43.1254 52.0068 44.0208 52.9023 44.0208 54.0068C44.0208 55.1114 43.1254 56.0068 42.0208 56.0068H22.0208C20.9162 56.0068 20.0208 55.1114 20.0208 54.0068C20.0208 52.9023 20.9162 52.0068 22.0208 52.0068H30.0208V47.8686C22.0241 46.8643 16.0241 40.0664 16.0208 32.0068V28.0068C16.0208 26.9023 16.9162 26.0068 18.0208 26.0068C19.1254 26.0068 20.0208 26.9023 20.0208 28.0068V32.0068C20.0208 38.6343 25.3934 44.0068 32.0208 44.0068C38.6482 44.0068 44.0208 38.6343 44.0208 32.0068V28.0068C44.0208 26.9023 44.9162 26.0068 46.0208 26.0068C47.1254 26.0068 48.0208 26.9023 48.0208 28.0068V32.0068V32.0058C48.018 40.0654 42.0185 46.8636 34.0218 47.8685L34.0208 47.8686ZM32.0208 40.0068C27.6025 40.0068 24.0208 36.4251 24.0208 32.0068V16.0068V16.0068C24.0208 11.5886 27.6025 8.00684 32.0208 8.00684C36.4391 8.00684 40.0208 11.5886 40.0208 16.0068V32.0068C40.0208 36.4251 36.4391 40.0068 32.0208 40.0068C32.0208 40.0068 32.0208 40.0068 32.0208 40.0068H32.0208Z"
		/>
	);
}

function Video(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M8 16C8 12.6863 10.6863 10 14 10H50C53.3137 10 56 12.6863 56 16V48C56 51.3137 53.3137 54 50 54H14C10.6863 54 8 51.3137 8 48V16ZM12 16C12 14.8954 12.8954 14 14 14H16C17.1046 14 18 14.8954 18 16V18C18 19.1046 17.1046 20 16 20H14C12.8954 20 12 19.1046 12 18V16ZM48 14C46.8954 14 46 14.8954 46 16V18C46 19.1046 46.8954 20 48 20H50C51.1046 20 52 19.1046 52 18V16C52 14.8954 51.1046 14 50 14H48ZM12 26C12 24.8954 12.8954 24 14 24H16C17.1046 24 18 24.8954 18 26V28C18 29.1046 17.1046 30 16 30H14C12.8954 30 12 29.1046 12 28V26ZM48 24C46.8954 24 46 24.8954 46 26V28C46 29.1046 46.8954 30 48 30H50C51.1046 30 52 29.1046 52 28V26C52 24.8954 51.1046 24 50 24H48ZM12 36C12 34.8954 12.8954 34 14 34H16C17.1046 34 18 34.8954 18 36V38C18 39.1046 17.1046 40 16 40H14C12.8954 40 12 39.1046 12 38V36ZM48 34C46.8954 34 46 34.8954 46 36V38C46 39.1046 46.8954 40 48 40H50C51.1046 40 52 39.1046 52 38V36C52 34.8954 51.1046 34 50 34H48ZM12 46C12 44.8954 12.8954 44 14 44H16C17.1046 44 18 44.8954 18 46V48C18 49.1046 17.1046 50 16 50H14C12.8954 50 12 49.1046 12 48V46ZM48 44C46.8954 44 46 44.8954 46 46V48C46 49.1046 46.8954 50 48 50H50C51.1046 50 52 49.1046 52 48V46C52 44.8954 51.1046 44 50 44H48ZM22 16C22 14.8954 22.8954 14 24 14H40C41.1046 14 42 14.8954 42 16V28C42 29.1046 41.1046 30 40 30H24C22.8954 30 22 29.1046 22 28V16ZM24 34C22.8954 34 22 34.8954 22 36V48C22 49.1046 22.8954 50 24 50H40C41.1046 50 42 49.1046 42 48V36C42 34.8954 41.1046 34 40 34H24Z"
		/>
	);
}

function Web(props) {
	return (
		<g>
			<path d="M18.9165 36.5962C16.5734 38.9394 16.5734 42.7384 18.9165 45.0815C21.2597 47.4246 25.0587 47.4246 27.4018 45.0815L33.7658 38.7175C36.1089 36.3744 36.1089 32.5754 33.7658 30.2323C32.9847 29.4512 32.9847 28.1849 33.7658 27.4038C34.5468 26.6228 35.8132 26.6228 36.5942 27.4038C40.4995 31.3091 40.4995 37.6407 36.5942 41.546L30.2302 47.9099C26.325 51.8152 19.9934 51.8152 16.0881 47.9099C12.1829 44.0047 12.1829 37.673 16.0881 33.7678L18.2094 31.6465C18.9905 30.8654 20.2568 30.8654 21.0379 31.6465C21.8189 32.4275 21.8189 33.6939 21.0379 34.4749L18.9165 36.5962Z" />
			<path d="M45.0795 27.4038C47.4226 25.0607 47.4226 21.2617 45.0795 18.9186C42.7363 16.5754 38.9374 16.5754 36.5942 18.9186L30.2302 25.2825C27.8871 27.6257 27.8871 31.4247 30.2302 33.7678C31.0113 34.5488 31.0113 35.8152 30.2302 36.5962C29.4492 37.3773 28.1829 37.3773 27.4018 36.5962C23.4966 32.691 23.4966 26.3593 27.4018 22.4541L33.7658 16.0901C37.671 12.1849 44.0027 12.1849 47.9079 16.0901C51.8132 19.9954 51.8132 26.327 47.9079 30.2323L45.7866 32.3536C45.0055 33.1346 43.7392 33.1346 42.9582 32.3536C42.1771 31.5725 42.1771 30.3062 42.9582 29.5252L45.0795 27.4038Z" />
		</g>
	);
}

function Table(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M8 20C8 15.5817 11.5817 12 16 12H48C52.4183 12 56 15.5817 56 20V44C56 48.4183 52.4183 52 48 52H16C11.5817 52 8 48.4183 8 44V20ZM12 20C12 17.7909 13.7909 16 16 16H29C29.5523 16 30 16.4477 30 17V23C30 23.5523 29.5523 24 29 24H13C12.4477 24 12 23.5523 12 23V20ZM13 28C12.4477 28 12 28.4477 12 29V35C12 35.5523 12.4477 36 13 36H29C29.5523 36 30 35.5523 30 35V29C30 28.4477 29.5523 28 29 28H13ZM12 41C12 40.4477 12.4477 40 13 40H29C29.5523 40 30 40.4477 30 41V47C30 47.5523 29.5523 48 29 48H16C13.7909 48 12 46.2091 12 44V41ZM35 16C34.4477 16 34 16.4477 34 17V23C34 23.5523 34.4477 24 35 24H51C51.5523 24 52 23.5523 52 23V20C52 17.7909 50.2091 16 48 16H35ZM34 29C34 28.4477 34.4477 28 35 28H51C51.5523 28 52 28.4477 52 29V35C52 35.5523 51.5523 36 51 36H35C34.4477 36 34 35.5523 34 35V29ZM35 40C34.4477 40 34 40.4477 34 41V47C34 47.5523 34.4477 48 35 48H48C50.2091 48 52 46.2091 52 44V41C52 40.4477 51.5523 40 51 40H35Z"
		/>
	);
}

function PaintBucket(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M26.45 12.08L25.0595 6.51097V6.51097C24.7896 5.44078 25.4385 4.35447 26.5086 4.08462C27.5788 3.81478 28.6651 4.46359 28.935 5.53378C28.9356 5.53618 28.9362 5.53858 28.9368 5.54098L30.54 11.9621L49.25 30.6713C50.2203 31.6412 50.2206 33.214 49.2508 34.1843C49.2505 34.1846 49.2502 34.1848 49.25 34.1851L29.2471 54.1873C26.826 56.6078 22.9012 56.6078 20.4801 54.1873L6.8 40.5083C4.37566 38.0841 4.37553 34.1536 6.79971 31.7293C6.79981 31.7292 6.7999 31.7291 6.8 31.729L26.45 12.08ZM33.01 31.0213C34.6668 31.0213 36.01 29.6781 36.01 28.0213C36.01 26.3644 34.6668 25.0213 33.01 25.0213C31.3531 25.0213 30.01 26.3644 30.01 28.0213V28.0209C30.01 29.6776 31.3529 31.0207 33.0096 31.0209L33.01 31.0213ZM51.7332 29.7518L45.7367 23.7553C45.4134 23.4316 45.4134 22.9073 45.7367 22.5837H45.7367C46.5177 21.8026 47.784 21.8025 48.5651 22.5835C48.5652 22.5836 48.5652 22.5836 48.5653 22.5837L54.7447 28.7637C57.3697 31.3887 59.01 39.1437 59.01 44.0217C59.01 46.2308 57.2191 48.0217 55.01 48.0217C52.8008 48.0217 51.01 46.2308 51.01 44.0217C51.01 39.8544 52.5193 36.8896 52.9433 33.0517C53.0584 31.8254 52.6139 30.6127 51.7336 29.7514L51.7332 29.7518Z"
		/>
	);
}
function Color(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M26.45 12.08L25.0595 6.51097V6.51097C24.7896 5.44078 25.4385 4.35447 26.5086 4.08462C27.5788 3.81478 28.6651 4.46359 28.935 5.53378C28.9356 5.53618 28.9362 5.53858 28.9368 5.54098L30.54 11.9621L49.25 30.6713C50.2203 31.6412 50.2206 33.214 49.2508 34.1843C49.2505 34.1846 49.2502 34.1848 49.25 34.1851L29.2471 54.1873C26.826 56.6078 22.9012 56.6078 20.4801 54.1873L6.8 40.5083C4.37566 38.0841 4.37553 34.1536 6.79971 31.7293C6.79981 31.7292 6.7999 31.7291 6.8 31.729L26.45 12.08ZM33.01 31.0213C34.6668 31.0213 36.01 29.6781 36.01 28.0213C36.01 26.3644 34.6668 25.0213 33.01 25.0213C31.3531 25.0213 30.01 26.3644 30.01 28.0213V28.0209C30.01 29.6776 31.3529 31.0207 33.0096 31.0209L33.01 31.0213ZM51.7332 29.7518L45.7367 23.7553C45.4134 23.4316 45.4134 22.9073 45.7367 22.5837H45.7367C46.5177 21.8026 47.784 21.8025 48.5651 22.5835C48.5652 22.5836 48.5652 22.5836 48.5653 22.5837L54.7447 28.7637C57.3697 31.3887 59.01 39.1437 59.01 44.0217C59.01 46.2308 57.2191 48.0217 55.01 48.0217C52.8008 48.0217 51.01 46.2308 51.01 44.0217C51.01 39.8544 52.5193 36.8896 52.9433 33.0517C53.0584 31.8254 52.6139 30.6127 51.7336 29.7514L51.7332 29.7518Z"
		/>
	);
}
function ColorPaletteFill(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M32 8H32C45.2548 8 56 18.7452 56 32C56 38.6167 50.0207 43 43 43H38C36.2316 43 34 43.3231 34 46C34 48.6266 36 50.28 36 53C36 54.6164 34.7273 56 32 56C18.7452 56 8 45.2548 8 32C8 18.7452 18.7452 8 32 8H32ZM45.5 35C47.9853 35 50 32.9853 50 30.5C50 28.0147 47.9853 26 45.5 26C43.0147 26 41 28.0147 41 30.5V30.4999C41 32.9849 43.0143 34.9995 45.4993 34.9999L45.5 35ZM38.5005 24C40.9858 24 43.0005 21.9853 43.0005 19.5C43.0005 17.0147 40.9858 15 38.5005 15C36.0152 15 34.0005 17.0147 34.0005 19.5V19.4999C34.0005 21.985 36.0149 23.9996 38.5 23.9999L38.5005 24ZM25.5005 24H25.5005C27.9858 24 30.0005 21.9853 30.0005 19.5C30.0005 17.0147 27.9858 15 25.5005 15C23.0152 15 21.0005 17.0147 21.0005 19.5V19.4999C21.0005 21.9849 23.0148 23.9995 25.4998 23.9999L25.5005 24ZM14.0005 30.5C14.0005 32.9853 16.0152 35 18.5005 35C20.9858 35 23.0005 32.9853 23.0005 30.5C23.0005 28.0147 20.9858 26 18.5005 26C16.0152 25.9994 14 28.0136 13.9994 30.4989C13.9994 30.4992 13.9994 30.4995 13.9994 30.4998L14.0005 30.5Z"
		/>
	);
}

function Twitter(props) {
	return (
		<path
			d="M23.78 49.5408C40.5 49.5408 49.6451 35.6884 49.6451 23.6757C49.6451 23.2823 49.6451 22.8906 49.6185 22.5007C51.3976 21.2138 52.9334 19.6205 54.1538 17.7952C52.4948 18.5303 50.7348 19.0125 48.9326 19.2254C50.8303 18.0894 52.2506 16.3025 52.9292 14.1974C51.1447 15.2563 49.1925 16.0025 47.1568 16.4039C45.7862 14.9465 43.9735 13.9815 41.9991 13.6581C40.0248 13.3347 37.9989 13.6711 36.235 14.6151C34.4711 15.5591 33.0675 17.0582 32.2414 18.8803C31.4153 20.7024 31.2127 22.746 31.665 24.6948C28.0509 24.5136 24.5152 23.5744 21.2875 21.9381C18.0599 20.3019 15.2124 18.0051 12.93 15.197C11.7675 17.1982 11.4115 19.5673 11.9343 21.8218C12.4572 24.0763 13.8197 26.0467 15.7444 27.332C14.2977 27.2891 12.8826 26.8988 11.6185 26.1942C11.6185 26.2314 11.6185 26.2704 11.6185 26.3094C11.619 28.4082 12.3456 30.4421 13.6748 32.0663C15.0041 33.6905 16.8543 34.8049 18.9115 35.2205C17.5732 35.5855 16.169 35.6389 14.8068 35.3765C15.3877 37.1828 16.5187 38.7623 18.0414 39.8942C19.5642 41.0261 21.4027 41.6538 23.2997 41.6894C20.0808 44.2193 16.1043 45.5926 12.0101 45.5885C11.2869 45.5871 10.5643 45.5433 9.84615 45.4574C14.0033 48.1252 18.8405 49.5403 23.78 49.5337"
			fill={props.forceColor ? props.color : "#1DA1F2"}
		/>
	);
}

function Giphy(props) {
	return (
		<g>
			<g clipPath="url(#clip0_2:32)">
				<path
					d="M13.9224 13.6433H19.0865V50.3567H13.9224V13.6433Z"
					fill={props.forceColor ? props.color : "#04FF8E"}
				/>
				<path
					d="M44.9135 23.7721H50.0775V50.3567H44.9135V23.7721Z"
					fill={props.forceColor ? props.color : "#8E2EFF"}
				/>
				<path
					d="M13.9224 49.0895H50.0775V54.1538H13.9224V49.0895Z"
					fill={props.forceColor ? props.color : "#00C5FF"}
				/>
				<path
					d="M13.9225 9.84615H34.5832V14.9105H13.9225V9.84615Z"
					fill={props.forceColor ? props.color : "#FFF152"}
				/>
				<path
					d="M44.9134 19.9727V14.9105H39.7472V9.84615H34.5831V25.037H50.0775V19.9727"
					fill={props.forceColor ? props.color : "#FF5B5B"}
				/>
				<path d="M44.9135 30.1014V25.037H50.0775" fill={props.forceColor ? props.color : "#551C99"} />
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M34.5831 9.84615V14.9105H29.4169"
					fill={props.forceColor ? props.color : "#999131"}
				/>
			</g>
			<defs>
				<clipPath id="clip0_2:32">
					<rect width="44.3077" height="44.3077" transform="translate(9.84615 9.84615)" />
				</clipPath>
			</defs>
		</g>
	);
}

function Figma(props) {
	return (
		<g>
			<g clipPath="url(#clip0_2:70)">
				<path
					d="M32 32.4064C32 30.3587 32.8134 28.3949 34.2613 26.947C35.7092 25.4991 37.673 24.6857 39.7207 24.6857C41.7683 24.6857 43.7321 25.4991 45.18 26.947C46.6279 28.3949 47.4413 30.3587 47.4413 32.4064C47.4413 34.454 46.6279 36.4178 45.18 37.8657C43.7321 39.3136 41.7683 40.127 39.7207 40.127C37.673 40.127 35.7092 39.3136 34.2613 37.8657C32.8134 36.4178 32 34.454 32 32.4064V32.4064Z"
					fill={props.forceColor ? props.color : "#1ABCFE"}
				/>
				<path
					d="M16.5588 47.8476C16.5588 45.8 17.3722 43.8362 18.8201 42.3883C20.268 40.9404 22.2317 40.127 24.2794 40.127H32V47.8476C32 49.8953 31.1866 51.859 29.7387 53.3069C28.2908 54.7548 26.327 55.5683 24.2794 55.5683C22.2317 55.5683 20.268 54.7548 18.8201 53.3069C17.3722 51.859 16.5588 49.8953 16.5588 47.8476V47.8476Z"
					fill={props.forceColor ? props.color : "#0ACF83"}
				/>
				<path
					d="M32 9.24445V24.6857H39.7207C41.7683 24.6857 43.7321 23.8723 45.18 22.4244C46.6279 20.9765 47.4413 19.0127 47.4413 16.9651C47.4413 14.9174 46.6279 12.9537 45.18 11.5058C43.7321 10.0579 41.7683 9.24445 39.7207 9.24445H32Z"
					fill={props.forceColor ? props.color : "#FF7262"}
				/>
				<path
					d="M16.5587 16.9651C16.5587 19.0127 17.3722 20.9765 18.8201 22.4244C20.268 23.8723 22.2317 24.6857 24.2794 24.6857H32V9.24442H24.2794C22.2317 9.24442 20.268 10.0578 18.8201 11.5057C17.3722 12.9536 16.5587 14.9174 16.5587 16.9651V16.9651Z"
					fill={props.forceColor ? props.color : "#F24E1E"}
				/>
				<path
					d="M16.5588 32.4064C16.5588 34.454 17.3722 36.4178 18.8201 37.8657C20.268 39.3136 22.2317 40.127 24.2794 40.127H32V24.6857H24.2794C22.2317 24.6857 20.268 25.4991 18.8201 26.947C17.3722 28.3949 16.5588 30.3587 16.5588 32.4064V32.4064Z"
					fill={props.forceColor ? props.color : "#A259FF"}
				/>
			</g>
			<defs>
				<clipPath id="clip0_2:70">
					<rect width="30.8825" height="46.3238" transform="translate(16.5587 9.24442)" />
				</clipPath>
			</defs>
		</g>
	);
}

function Airtable(props) {
	return (
		<g>
			<path
				d="M29.504 12.9536L12.0832 20.16C11.1104 20.5568 11.1232 21.9392 12.096 22.3232L29.5936 29.2608C31.1296 29.8752 32.8448 29.8752 34.3808 29.2608L51.8784 22.3232C52.8512 21.9392 52.864 20.5568 51.8912 20.16L34.4704 12.9536C32.8704 12.288 31.0912 12.288 29.504 12.9536Z"
				fill={props.forceColor ? props.color : "#FFBF00"}
			/>
			<path
				d="M33.536 33.0496V50.3808C33.536 51.2 34.368 51.7632 35.136 51.4688L54.6304 43.904C55.0784 43.7248 55.3728 43.3024 55.3728 42.816V25.4848C55.3728 24.6656 54.5408 24.1024 53.7728 24.3968L34.2784 31.9616C33.8304 32.1408 33.536 32.5632 33.536 33.0496Z"
				fill={props.forceColor ? props.color : "#26B5F8"}
			/>
			<path
				d="M28.9792 33.9456L23.1936 36.736L22.6048 37.0176L10.3936 42.8672C9.62563 43.2384 8.62723 42.6752 8.62723 41.8176V25.5488C8.62723 25.2416 8.78083 24.9728 8.99843 24.768C9.08803 24.6784 9.19043 24.6016 9.29283 24.5504C9.58723 24.3712 9.99683 24.3328 10.3552 24.4736L28.8768 31.808C29.824 32.1792 29.9008 33.4976 28.9792 33.9456Z"
				fill={props.forceColor ? props.color : "#ED3049"}
			/>
			<path
				d="M9.93283 24.3839C9.70243 24.3839 9.48483 24.4479 9.31843 24.5503C9.21603 24.6143 9.11363 24.6783 9.02403 24.7679L23.1936 36.7359L28.9792 33.9456C29.4144 33.728 29.632 33.3184 29.632 32.9088C29.632 32.4608 29.376 31.9999 28.8896 31.8079L10.368 24.4735C10.2272 24.4095 10.0736 24.3839 9.93283 24.3839Z"
				fill={props.forceColor ? props.color : "#B22437"}
			/>
		</g>
	);
}

function Dalle(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M55.5083 27.3426C56.8831 23.4934 56.3332 19.3692 54.4086 16.0699C51.3842 10.8459 45.3354 8.0965 39.5616 9.47123C36.2622 5.89695 31.3132 4.24727 26.3642 5.07211C21.4152 6.17189 17.566 9.74617 15.9163 14.4202C12.0671 15.2451 8.76776 17.7196 6.84315 21.0189C3.81876 26.2428 4.36865 32.8415 8.49282 37.2406C7.1181 41.0898 7.66799 45.214 9.5926 48.5134C12.617 53.7373 18.6658 56.4867 24.4396 55.112C27.1891 58.1364 30.7633 59.7861 34.8875 59.7861C40.9363 59.7861 46.1602 55.9369 48.0848 50.163C51.9341 49.3382 55.2334 46.8637 57.158 43.5643C60.1824 38.3404 59.6325 31.7417 55.5083 27.3426ZM34.8875 56.2118C32.413 56.2118 30.2134 55.387 28.2888 53.7373L28.5638 53.4624L39.5616 47.1386C40.1115 46.8637 40.3864 46.3138 40.3864 45.489V30.0921L45.0605 32.8415V45.7639C45.0605 51.5377 40.6613 56.2118 34.8875 56.2118ZM12.617 46.5887C11.5172 44.3892 10.9673 42.1896 11.5172 39.7151L11.7922 39.9901L22.7899 46.3138C23.3398 46.5887 23.8897 46.5887 24.7146 46.3138L38.1868 38.6153V43.8393C38.1868 43.8393 38.1868 43.8393 38.1868 44.1142L27.1891 50.438C21.9651 53.1874 15.6414 51.5377 12.617 46.5887ZM9.86754 22.9435C10.9673 20.7439 12.8919 19.3692 15.3664 18.5444V31.4668C15.3664 32.0167 15.6414 32.5666 16.1913 33.1165L29.3886 40.8149L24.7146 43.5643C24.7146 43.5643 24.7145 43.5643 24.4396 43.5643L13.4418 37.2406C8.76776 33.9413 7.1181 27.6176 9.86754 22.9435ZM47.8099 31.7417L34.6126 24.0433L39.2866 21.2938C39.2866 21.2938 39.2866 21.2938 39.5616 21.2938L50.5593 27.6176C54.1336 29.5422 56.0582 33.3914 55.7833 37.5156C55.5083 41.3648 52.7589 44.9391 49.1846 46.3138V33.3914C48.9097 32.5666 48.3598 32.0167 47.8099 31.7417ZM52.4839 24.8681L52.209 24.5932L41.2112 18.2695C40.6613 17.9945 39.8365 17.9945 39.2866 18.2695L26.0893 25.9679V20.744C26.0893 20.744 26.0893 20.744 26.0893 20.469L37.0871 14.1453C40.6613 12.2207 44.7855 12.2207 48.0848 14.6952C51.3842 16.8947 53.0338 20.744 52.4839 24.8681ZM23.6148 34.2162L18.9407 31.4668V18.5444C18.9407 14.4202 21.1403 10.8459 24.9895 9.19628C28.5638 7.54661 32.9629 8.0965 35.9873 10.571L35.7123 10.846L24.7146 17.1697C24.1647 17.4446 23.8897 17.9945 23.8897 18.8193L23.6148 34.2162ZM26.0893 28.7173L32.1381 25.418L38.1868 28.7173V35.591L32.1381 38.8903L26.0893 35.591V28.7173Z"
		/>
	);
}

function Framer(props) {
	return (
		<g>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M31.9989 24.7123H46.7682V10.2153H17.502V10.3515L31.9989 24.7123Z"
				fill={props.forceColor ? props.color : "#67DBFF"}
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M31.9997 24.7124H17.2305V39.2094H46.4967V39.0733L31.9997 24.7124Z"
				fill={props.forceColor ? props.color : "#01A3FF"}
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M17.2305 39.1411H31.8636V53.7742L17.2305 39.1411Z"
				fill={props.forceColor ? props.color : "#0162FF"}
			/>
		</g>
	);
}

function Miro(props) {
	return (
		<path
			d="M41.4004 11.0771H35.3089L40.7168 19.4583L29.284 11.0771H23.1925L28.6004 22.0594L17.1676 11.0771H11.0762L16.3949 25.2549L11.0762 52.9233H17.1676L28.6004 23.2565L23.1925 52.9233H29.284L40.7168 20.6566L35.3089 52.9233H41.4004L52.9223 17.4789L41.4004 11.0771Z"
			fill={props.forceColor ? props.color : "#FFD02F"}
		/>
	);
}

function Looker(props) {
	return (
		<g>
			<path
				d="M31.9006 7.38477C31.1202 7.38511 30.3546 7.59758 29.6857 7.99946C29.0167 8.40133 28.4696 8.9775 28.1028 9.66632C27.736 10.3551 27.5633 11.1307 27.6033 11.9101C27.6433 12.6895 27.8944 13.4433 28.3297 14.091L30.1683 12.255C30.1075 12.0718 30.0769 11.88 30.0776 11.687C30.0776 11.328 30.184 10.977 30.3835 10.6785C30.583 10.38 30.8665 10.1473 31.1982 10.0099C31.5299 9.87251 31.8949 9.83656 32.247 9.90661C32.5991 9.97665 32.9226 10.1495 33.1765 10.4034C33.4303 10.6573 33.6032 10.9807 33.6733 11.3329C33.7433 11.685 33.7074 12.05 33.57 12.3817C33.4326 12.7134 33.1999 12.9969 32.9014 13.1964C32.6029 13.3959 32.2519 13.5023 31.8928 13.5023C31.7007 13.5027 31.5098 13.4721 31.3275 13.4116L29.4915 15.2476C30.0487 15.6255 30.6869 15.8674 31.3546 15.9537C32.0223 16.0401 32.701 15.9685 33.3361 15.7448C33.9711 15.521 34.5448 15.1514 35.0109 14.6655C35.477 14.1796 35.8226 13.5912 36.0199 12.9474C36.2171 12.3036 36.2605 11.6226 36.1466 10.959C36.0326 10.2954 35.7645 9.66779 35.3638 9.1267C34.9631 8.5856 34.441 8.14611 33.8395 7.84356C33.238 7.54102 32.5739 7.38387 31.9006 7.38477V7.38477Z"
				fill={props.forceColor ? props.color : "#34A853"}
			/>
			<path
				d="M30.1886 19.923C30.1915 18.4697 29.7208 17.055 28.8479 15.8931L26.4621 18.2763C26.8249 18.9399 26.9576 19.705 26.8393 20.452C26.7211 21.199 26.3586 21.8857 25.8086 22.4048L27.1052 25.5738C28.0507 24.9649 28.8284 24.1285 29.3671 23.1413C29.9057 22.1542 30.1882 21.0476 30.1886 19.923V19.923Z"
				fill={props.forceColor ? props.color : "#FBBC04"}
			/>
			<path
				d="M23.5212 23.3438H23.459C22.9255 23.3438 22.3995 23.2192 21.9227 22.9798C21.446 22.7405 21.0318 22.393 20.7132 21.9651C20.3946 21.5373 20.1804 21.0409 20.0877 20.5155C19.995 19.9902 20.0263 19.4505 20.1792 18.9394C20.3321 18.4283 20.6024 17.9601 20.9684 17.572C21.3344 17.1839 21.7861 16.8867 22.2873 16.7042C22.7886 16.5216 23.3256 16.4588 23.8554 16.5206C24.3853 16.5824 24.8934 16.7672 25.3391 17.0603L27.7016 14.6978C26.8655 14.0199 25.8789 13.5526 24.8248 13.3351C23.7706 13.1176 22.6797 13.1562 21.6435 13.4477C20.6074 13.7392 19.6563 14.275 18.8702 15.0103C18.0841 15.7455 17.4859 16.6587 17.1258 17.673C16.7658 18.6874 16.6544 19.7733 16.801 20.8397C16.9476 21.906 17.348 22.9216 17.9685 23.8011C18.589 24.6806 19.4114 25.3984 20.3668 25.8942C21.3222 26.39 22.3826 26.6492 23.459 26.6502C23.9153 26.6505 24.3705 26.6053 24.8179 26.5154L23.5212 23.3438Z"
				fill={props.forceColor ? props.color : "#EA4335"}
			/>
			<path
				d="M31.9912 26.0846C30.498 26.0831 29.0127 26.3007 27.5826 26.7304L29.4732 31.349C30.2961 31.1451 31.1408 31.0423 31.9886 31.043C34.371 31.0437 36.6794 31.8704 38.5206 33.3822C40.3618 34.894 41.6219 36.9975 42.0861 39.3342C42.5504 41.6709 42.1901 44.0962 41.0667 46.1971C39.9432 48.2979 38.1261 49.9442 35.925 50.8556C33.7238 51.7669 31.2747 51.8869 28.9951 51.195C26.7154 50.5032 24.7461 49.0423 23.4227 47.0613C22.0993 45.0803 21.5037 42.7018 21.7374 40.3309C21.971 37.96 23.0195 35.7435 24.7041 34.059C25.429 33.3364 26.2565 32.7247 27.1599 32.2437L25.2902 27.638C21.9236 29.2868 19.2813 32.1166 17.8668 35.5882C16.4523 39.0597 16.3646 42.9304 17.6202 46.4625C18.8759 49.9946 21.3873 52.9413 24.6757 54.741C27.9641 56.5406 31.7997 57.0675 35.4516 56.2212C39.1035 55.3749 42.3164 53.2145 44.478 50.1518C46.6395 47.0891 47.5987 43.3381 47.1727 39.6137C46.7467 35.8893 44.9653 32.4519 42.1679 29.9564C39.3706 27.4609 35.7529 26.0818 32.0042 26.082L31.9912 26.0846Z"
				fill={props.forceColor ? props.color : "#4285F4"}
			/>
		</g>
	);
}

function SquareStack(props) {
	return (
		
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M15 9C11.6863 9 9 11.6863 9 15V39C9 42.3137 11.6863 45 15 45H19V49C19 52.3137 21.6863 55 25 55H49C52.3137 55 55 52.3137 55 49V25C55 21.6863 52.3137 19 49 19H45V15C45 11.6863 42.3137 9 39 9H15ZM41 19V15C41 13.8954 40.1046 13 39 13H15C13.8954 13 13 13.8954 13 15V39C13 40.1046 13.8954 41 15 41H19V25C19 21.6863 21.6863 19 25 19H41ZM25 23C23.8954 23 23 23.8954 23 25V49C23 50.1046 23.8954 51 25 51H49C50.1046 51 51 50.1046 51 49V25C51 23.8954 50.1046 23 49 23H25Z"
			/>
		
	);
}


function AIImage(props) {

	return (
		
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M33.5302 27.1828L32.7763 22.6595C32.7062 22.2308 32.3018 21.9402 31.8731 22.0103C31.5398 22.0649 31.2785 22.3262 31.2239 22.6595L30.4701 27.1828C30.1892 28.8685 28.8682 30.1895 27.1825 30.4704L22.6592 31.2241C22.2305 31.2945 21.9401 31.699 22.0105 32.1277C22.0652 32.4607 22.3262 32.7217 22.6592 32.7763L27.1825 33.5303C28.8682 33.8112 30.1891 35.1321 30.4701 36.8178L31.2239 41.3411C31.2941 41.7698 31.6985 42.0604 32.1272 41.9902C32.4605 41.9357 32.7218 41.6744 32.7763 41.3411L33.5302 36.8178C33.8111 35.1322 35.1319 33.8114 36.8174 33.5303L41.3408 32.7763C41.7695 32.7059 42.0599 32.3014 41.9895 31.8727C41.9348 31.5398 41.6738 31.2788 41.3408 31.2241L36.8174 30.4704C35.1318 30.1893 33.811 28.8684 33.5302 27.1828Z"
		/>
	

		
);

}



function PlusLandscape(props) {
	return (
		<g>
			<path d="M30 24C30 22.8954 30.8954 22 32 22C33.1046 22 34 22.8954 34 24V30H40C41.1046 30 42 30.8954 42 32C42 33.1046 41.1046 34 40 34H34V40C34 41.1046 33.1046 42 32 42C30.8954 42 30 41.1046 30 40V34H24C22.8954 34 22 33.1046 22 32C22 30.8954 22.8954 30 24 30H30V24Z" />
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M8 22C8 17.5817 11.5817 14 16 14H48C52.4183 14 56 17.5817 56 22V42C56 46.4183 52.4183 50 48 50H16C11.5817 50 8 46.4183 8 42V22ZM12 22C12 19.7909 13.7909 18 16 18H48C50.2091 18 52 19.7909 52 22V42C52 44.2091 50.2091 46 48 46H16C13.7909 46 12 44.2091 12 42V22Z"
			/>
		</g>
	);
}

function Diagram(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M26.4545 7C26.4545 5.89543 27.35 5 28.4545 5H41.5454C42.65 5 43.5454 5.89543 43.5454 7V20.0909C43.5454 21.1955 42.65 22.0909 41.5454 22.0909H36.9877V30.9877H48.4422C49.5468 30.9877 50.4422 31.8831 50.4422 32.9877V41.9091H55C56.1046 41.9091 57 42.8045 57 43.9091V57C57 58.1046 56.1046 59 55 59H41.9091C40.8045 59 39.9091 58.1046 39.9091 57V43.9091C39.9091 42.8045 40.8045 41.9091 41.9091 41.9091H46.4422V34.9877H24.0909V39.5455C24.0909 40.65 23.1955 41.5455 22.0909 41.5455H9C7.89543 41.5455 7 40.65 7 39.5455V26.4545C7 25.35 7.89543 24.4545 9 24.4545H22.0909C23.1955 24.4545 24.0909 25.35 24.0909 26.4545V30.9877H32.9877V22.0909H28.4545C27.35 22.0909 26.4545 21.1955 26.4545 20.0909V7Z"
		/>
	);
}

function Subtract(props) {
	return (
		<path d="M11.5 32C11.5 30.6193 12.6193 29.5 14 29.5H50C51.3807 29.5 52.5 30.6193 52.5 32C52.5 33.3807 51.3807 34.5 50 34.5H14C12.6193 34.5 11.5 33.3807 11.5 32Z" />
	);
}

function FitCanvasToContent(props) {
	return (
		<g>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M34.5 3.5V12.6588C43.2703 13.7812 50.2188 20.7297 51.3412 29.5H60.5V34.5H51.3412C50.2188 43.2703 43.2703 50.2188 34.5 51.3412V60.5H29.5V51.3412C20.7281 50.2186 13.7787 43.2678 12.6582 34.4953L3.49889 34.4912L3.50112 29.4912L12.6594 29.4953C13.7837 20.7272 20.7313 13.781 29.5 12.6588V3.5H34.5ZM32 17.5C23.9919 17.5 17.5 23.9919 17.5 32C17.5 40.0081 23.9919 46.5 32 46.5C40.0081 46.5 46.5 40.0081 46.5 32C46.5 23.9919 40.0081 17.5 32 17.5Z"
			/>
			<path d="M37 32C37 34.7614 34.7614 37 32 37C29.2386 37 27 34.7614 27 32C27 29.2386 29.2386 27 32 27C34.7614 27 37 29.2386 37 32Z" />
		</g>
	);
}

function DiagramPan(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M15.0662 28.7102C13.9591 28.6338 12.8782 29.0657 12.1364 29.8807C11.9545 30.1303 11.9545 30.4668 12.1364 30.7163C13.6389 34.7843 13.9369 35.395 15.7918 41.1322C18.8177 50.4907 25.6555 54 33.6496 54C41.5756 53.9994 48.0005 47.6541 48 39.8273V22.1838C48 21.0656 47.4421 19.9727 45.7767 19.9727C44.1114 19.9727 43.4269 21.0656 43.4269 22.1838V29.7049C43.4264 30.2636 42.9676 30.7163 42.4017 30.7163C41.8359 30.7163 41.3771 30.2636 41.3766 29.7049V15.6036C41.4034 14.2061 40.278 13.0517 38.8627 13.0252C37.4475 12.9987 36.2785 14.1101 36.2517 15.5076C36.251 15.5396 36.251 15.5716 36.2517 15.6036V28.6926C36.2511 29.2513 35.7923 29.704 35.2265 29.704C34.6607 29.7044 34.2017 29.2518 34.2013 28.6931L34.2013 12.5666C34.2213 11.169 33.0902 10.02 31.6749 10.0003C30.2596 9.9805 29.096 11.0975 29.076 12.4951C29.0757 12.5189 29.0757 12.5428 29.076 12.5666V28.6926C29.0758 29.2513 28.6169 29.7042 28.0511 29.704C27.4853 29.704 27.0261 29.2513 27.0256 28.6926V15.6036C27.0493 14.2061 25.9212 13.0542 24.5059 13.0308C23.0907 13.0074 21.9242 14.1214 21.9005 15.5189C21.9 15.5472 21.9 15.5754 21.9005 15.6036V35.3261C21.9024 35.6944 21.6015 35.9945 21.2285 35.9964C20.9894 35.9975 20.7674 35.8738 20.645 35.6709C18.206 31.6134 18.2424 28.7102 15.0662 28.7102Z"
		/>
	);
}
/*
function DiagramShapeRectangle(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M19.6966 11.5H44.3034C46.9216 11.5 49.0335 11.5 50.7455 11.6352C52.5078 11.7745 54.0579 12.0685 55.4992 12.7747C57.9905 13.9951 60.0049 16.0095 61.2253 18.5008C61.9315 19.9421 62.2255 21.4922 62.3648 23.2545C62.5 24.9665 62.5 27.0783 62.5 29.6966V34.3034C62.5 36.9217 62.5 39.0335 62.3648 40.7455C62.2255 42.5078 61.9315 44.0579 61.2253 45.4992C60.0049 47.9905 57.9905 50.0049 55.4992 51.2253C54.0579 51.9315 52.5078 52.2255 50.7455 52.3648C49.0335 52.5 46.9217 52.5 44.3034 52.5H19.6966C17.0783 52.5 14.9665 52.5 13.2545 52.3648C11.4923 52.2255 9.94214 51.9315 8.50076 51.2253C6.00955 50.0049 3.99509 47.9905 2.77466 45.4992C2.06853 44.0579 1.77448 42.5078 1.63523 40.7455C1.49996 39.0335 1.49998 36.9216 1.5 34.3034V29.6966C1.49998 27.0784 1.49996 24.9665 1.63523 23.2545C1.77448 21.4922 2.06853 19.9421 2.77466 18.5008C3.99509 16.0095 6.00955 13.9951 8.50076 12.7747C9.94214 12.0685 11.4923 11.7745 13.2545 11.6352C14.9665 11.5 17.0784 11.5 19.6966 11.5ZM13.6483 16.6197C12.1842 16.7354 11.3406 16.9512 10.7005 17.2648C9.20573 17.9971 7.99705 19.2057 7.26479 20.7005C6.9512 21.3406 6.73539 22.1842 6.6197 23.6483C6.50182 25.1402 6.5 27.0542 6.5 29.8V34.2C6.5 36.9458 6.50182 38.8598 6.6197 40.3517C6.73539 41.8158 6.9512 42.6594 7.26479 43.2995C7.99705 44.7943 9.20573 46.0029 10.7005 46.7352C11.3406 47.0488 12.1842 47.2646 13.6483 47.3803C15.1402 47.4982 17.0542 47.5 19.8 47.5H44.2C46.9458 47.5 48.8598 47.4982 50.3517 47.3803C51.8158 47.2646 52.6594 47.0488 53.2995 46.7352C54.7943 46.0029 56.0029 44.7943 56.7352 43.2995C57.0488 42.6594 57.2646 41.8158 57.3803 40.3517C57.4982 38.8598 57.5 36.9458 57.5 34.2V29.8C57.5 27.0542 57.4982 25.1402 57.3803 23.6483C57.2646 22.1842 57.0488 21.3406 56.7352 20.7005C56.0029 19.2057 54.7943 17.9971 53.2995 17.2648C52.6594 16.9512 51.8158 16.7354 50.3517 16.6197C48.8598 16.5018 46.9458 16.5 44.2 16.5H19.8C17.0542 16.5 15.1402 16.5018 13.6483 16.6197Z"
		/>
	);
}
*/

function DiagramShapeCircle(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M7.5 32C7.5 18.469 18.469 7.5 32 7.5C45.531 7.5 56.5 18.469 56.5 32C56.5 45.531 45.531 56.5 32 56.5C18.469 56.5 7.5 45.531 7.5 32ZM32 12.5C21.2304 12.5 12.5 21.2304 12.5 32C12.5 42.7696 21.2304 51.5 32 51.5C42.7696 51.5 51.5 42.7696 51.5 32C51.5 21.2304 42.7696 12.5 32 12.5Z"
		/>
	);
}

function DiagramShapeRectangle(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M26.6966 8.5H37.3034C39.9216 8.49998 42.0335 8.49996 43.7455 8.63523C45.5078 8.77448 47.0579 9.06853 48.4992 9.77466C50.9905 10.9951 53.0049 13.0095 54.2253 15.5008C54.9315 16.9421 55.2255 18.4923 55.3648 20.2545C55.5 21.9665 55.5 24.0783 55.5 26.6966V37.3034C55.5 39.9217 55.5 42.0335 55.3648 43.7455C55.2255 45.5078 54.9315 47.0579 54.2253 48.4992C53.0049 50.9905 50.9905 53.0049 48.4992 54.2253C47.0579 54.9315 45.5078 55.2255 43.7455 55.3648C42.0335 55.5 39.9217 55.5 37.3034 55.5H26.6966C24.0783 55.5 21.9665 55.5 20.2545 55.3648C18.4923 55.2255 16.9421 54.9315 15.5008 54.2253C13.0095 53.0049 10.9951 50.9905 9.77466 48.4992C9.06853 47.0579 8.77448 45.5078 8.63523 43.7455C8.49996 42.0335 8.49998 39.9216 8.5 37.3034V26.6966C8.49998 24.0784 8.49996 21.9665 8.63523 20.2545C8.77448 18.4923 9.06853 16.9421 9.77466 15.5008C10.9951 13.0095 13.0095 10.9951 15.5008 9.77466C16.9421 9.06853 18.4923 8.77448 20.2545 8.63523C21.9665 8.49996 24.0784 8.49998 26.6966 8.5ZM20.6483 13.6197C19.1842 13.7354 18.3406 13.9512 17.7005 14.2648C16.2057 14.9971 14.9971 16.2057 14.2648 17.7005C13.9512 18.3406 13.7354 19.1842 13.6197 20.6483C13.5018 22.1402 13.5 24.0542 13.5 26.8V37.2C13.5 39.9458 13.5018 41.8598 13.6197 43.3517C13.7354 44.8158 13.9512 45.6594 14.2648 46.2995C14.9971 47.7943 16.2057 49.0029 17.7005 49.7352C18.3406 50.0488 19.1842 50.2646 20.6483 50.3803C22.1402 50.4982 24.0542 50.5 26.8 50.5H37.2C39.9458 50.5 41.8598 50.4982 43.3517 50.3803C44.8158 50.2646 45.6594 50.0488 46.2995 49.7352C47.7943 49.0029 49.0029 47.7943 49.7352 46.2995C50.0488 45.6594 50.2646 44.8158 50.3803 43.3517C50.4982 41.8598 50.5 39.9458 50.5 37.2V26.8C50.5 24.0542 50.4982 22.1402 50.3803 20.6483C50.2646 19.1842 50.0488 18.3406 49.7352 17.7005C49.0029 16.2057 47.7943 14.9971 46.2995 14.2648C45.6594 13.9512 44.8158 13.7354 43.3517 13.6197C41.8598 13.5018 39.9458 13.5 37.2 13.5H26.8C24.0542 13.5 22.1402 13.5018 20.6483 13.6197Z"
		/>
	);
}

function DiagramShapeDiamond(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M9.6614 23.8031L23.6731 9.79133C24.6685 8.79598 25.5086 7.95578 26.2493 7.31498C27.0238 6.64491 27.832 6.0635 28.8032 5.68779C30.7765 4.92437 32.9636 4.92437 34.937 5.68779C35.9081 6.0635 36.7164 6.64491 37.4909 7.31497C38.2315 7.95579 39.0717 8.79602 40.0671 9.7914L54.0787 23.803C55.0741 24.7983 55.9143 25.6385 56.5551 26.3792C57.2252 27.1537 57.8066 27.962 58.1823 28.9331C58.9457 30.9064 58.9457 33.0936 58.1823 35.0669C57.8066 36.038 57.2252 36.8463 56.5551 37.6208C55.9143 38.3615 55.0741 39.2017 54.0787 40.197L40.0671 54.2086C39.0717 55.204 38.2315 56.0442 37.4909 56.685C36.7164 57.3551 35.9081 57.9365 34.937 58.3122C32.9636 59.0756 30.7765 59.0756 28.8032 58.3122C27.832 57.9365 27.0238 57.3551 26.2493 56.685C25.5086 56.0442 24.6685 55.204 23.6731 54.2087L9.6614 40.1969C8.66605 39.2016 7.82585 38.3614 7.18505 37.6208C6.51499 36.8463 5.93357 36.038 5.55786 35.0669C4.79444 33.0936 4.79444 30.9064 5.55786 28.9331C5.93357 27.962 6.51499 27.1537 7.18505 26.3792C7.82585 25.6386 8.66605 24.7984 9.6614 23.8031ZM10.9663 29.6507C10.4738 30.2198 10.3025 30.5265 10.2211 30.7372C9.90671 31.5497 9.90671 32.4503 10.2211 33.2628C10.3025 33.4735 10.4738 33.7802 10.9663 34.3493C11.4747 34.937 12.1851 35.6496 13.259 36.7235L27.1466 50.611C28.2205 51.6849 28.9331 52.3954 29.5207 52.9038C30.0899 53.3962 30.3966 53.5675 30.6072 53.649C31.4198 53.9634 32.3204 53.9634 33.1329 53.649C33.3435 53.5675 33.6502 53.3962 34.2194 52.9038C34.8071 52.3954 35.5197 51.6849 36.5935 50.6111L50.4811 36.7235C51.555 35.6496 52.2655 34.937 52.7739 34.3493C53.2663 33.7802 53.4376 33.4735 53.5191 33.2628C53.8334 32.4503 53.8334 31.5497 53.5191 30.7372C53.4376 30.5265 53.2663 30.2198 52.7739 29.6507C52.2655 29.063 51.555 28.3504 50.4811 27.2765L36.5935 13.3889C35.5197 12.3151 34.8071 11.6046 34.2194 11.0962C33.6502 10.6038 33.3435 10.4325 33.1329 10.351C32.3204 10.0366 31.4198 10.0366 30.6072 10.351C30.3966 10.4325 30.0899 10.6038 29.5207 11.0962C28.9331 11.6046 28.2205 12.3151 27.1466 13.389L13.259 27.2765C12.1851 28.3504 11.4747 29.063 10.9663 29.6507Z"
		/>
	);
}

function DiagramShapeParallelogram(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M14.4703 15.0312C15.3819 11.2022 18.8031 8.5 22.7391 8.5H49.4037C54.8942 8.5 58.9443 13.6276 57.6725 18.9688L50.5297 48.9688C49.618 52.7978 46.1968 55.5 42.2608 55.5H15.5963C10.1058 55.5 6.05571 50.3724 7.32742 45.0312L14.4703 15.0312ZM22.7391 13.5C21.1184 13.5 19.7097 14.6127 19.3343 16.1893L12.1915 46.1893C11.6678 48.3886 13.3355 50.5 15.5963 50.5H42.2608C43.8815 50.5 45.2903 49.3873 45.6656 47.8107L52.8085 17.8107C53.3322 15.6114 51.6645 13.5 49.4037 13.5H22.7391Z"
		/>
	);
}

function DiagramShapeCylinder(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M14.6484 15C14.7321 15.0786 14.8509 15.1778 15.018 15.2963C15.7194 15.7938 16.8966 16.3442 18.5762 16.8481C21.9037 17.8463 26.6503 18.5 32 18.5C37.3496 18.5 42.0962 17.8463 45.4237 16.8481C47.1033 16.3442 48.2805 15.7938 48.9819 15.2963C49.149 15.1778 49.2678 15.0786 49.3516 15C49.2678 14.9214 49.149 14.8222 48.9819 14.7037C48.2805 14.2062 47.1033 13.6558 45.4237 13.1519C42.0962 12.1537 37.3496 11.5 32 11.5C26.6503 11.5 21.9037 12.1537 18.5762 13.1519C16.8966 13.6558 15.7194 14.2062 15.018 14.7037C14.8509 14.8222 14.7321 14.9214 14.6484 15ZM49.4999 20.6831C48.6813 21.0408 47.7926 21.3576 46.8604 21.6372C42.9493 22.8105 37.696 23.5 32 23.5C26.3039 23.5 21.0506 22.8105 17.1395 21.6372C16.2073 21.3576 15.3186 21.0408 14.5 20.6831V50C14.5 50.0003 14.5 50.0008 14.4999 50.0013C14.4995 50.008 14.4979 50.0315 14.5409 50.1019C14.5994 50.1974 14.7434 50.3777 15.0632 50.6139C15.7275 51.1045 16.8642 51.6278 18.5398 52.09C21.8608 53.0061 26.611 53.5 32 53.5C37.389 53.5 42.1392 53.0061 45.4602 52.09C47.1358 51.6278 48.2725 51.1045 48.9368 50.6139C49.2566 50.3777 49.4006 50.1974 49.4591 50.1019C49.5021 50.0315 49.5005 50.008 49.5001 50.0013C49.5001 50.0008 49.5 50.0003 49.5 50L49.4999 20.6831ZM49.5317 14.7948C49.5353 14.786 49.5379 14.7817 49.5383 14.7817C49.5386 14.7817 49.5368 14.7861 49.5317 14.7948ZM17.1395 8.36279C21.0506 7.18945 26.3039 6.5 32 6.5C37.696 6.5 42.9493 7.18945 46.8604 8.36279C48.8001 8.94468 50.5519 9.68721 51.8745 10.6254C53.1323 11.5175 54.4999 12.9595 54.4999 15L54.5 50C54.5 52.073 53.2964 53.61 51.907 54.6361C50.5401 55.6455 48.7392 56.3722 46.7898 56.91C42.8608 57.9939 37.611 58.5 32 58.5C26.389 58.5 21.1392 57.9939 17.2102 56.91C15.2608 56.3722 13.46 55.6455 12.093 54.6361C10.7036 53.61 9.5 52.073 9.5 50V15C9.5 12.9595 10.8676 11.5175 12.1254 10.6254C13.4481 9.68721 15.1998 8.94468 17.1395 8.36279ZM14.4682 14.7948C14.4631 14.7861 14.4613 14.7817 14.4616 14.7817C14.462 14.7817 14.4646 14.786 14.4682 14.7948Z"
		/>
	);
}

function DiagramShapeCloud(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M29 15.5C35.9834 15.5 41.9594 19.8393 44.3671 25.9776L45.0585 27.7403L46.9426 27.5524C47.2896 27.5178 47.6424 27.5 48 27.5C53.799 27.5 58.5 32.201 58.5 38C58.5 43.799 53.799 48.5 48 48.5H14C9.30558 48.5 5.5 44.6944 5.5 40C5.5 36.3596 7.78968 33.2477 11.016 32.0378L12.4379 31.5046L12.6201 29.9969C13.6069 21.83 20.5661 15.5 29 15.5ZM48.2933 22.5027C44.788 15.3951 37.4683 10.5 29 10.5C18.5042 10.5 9.76797 18.0188 7.87842 27.9652C3.50201 30.1956 0.5 34.7446 0.5 40C0.5 47.4558 6.54416 53.5 14 53.5H48C56.5604 53.5 63.5 46.5604 63.5 38C63.5 29.5376 56.7184 22.6591 48.2933 22.5027Z"
		/>
	);
}

function DiagramConnectorStartCapArrow(props) {
	return (
		<path d="M31.4821 16.7322C32.4584 15.7559 34.0413 15.7559 35.0176 16.7322C35.9939 17.7085 35.9939 19.2915 35.0176 20.2678L25.5967 29.6887L42.3926 29.6887C43.759 29.6887 44.8667 30.8194 44.8667 32.2143C44.8667 33.6092 43.759 34.7399 42.3926 34.7399L25.5967 34.7399L35.0176 44.1608C35.9939 45.1371 35.9939 46.72 35.0176 47.6963C34.0413 48.6726 32.4584 48.6726 31.4821 47.6963L16 32.2143L31.4821 16.7322Z" />
	);
}

function DiagramConnectorStartCapDot(props) {
	return (
		<path d="M31.9324 34.6685L45.9999 34.6685C47.3664 34.6685 48.474 33.5378 48.474 32.1429C48.474 30.748 47.3664 29.6172 46 29.6172L31.9324 29.6172C30.8365 25.7962 27.3162 23 23.1429 23C18.0934 23 14 27.0934 14 32.1429C14 37.1923 18.0934 41.2857 23.1429 41.2857C27.3162 41.2857 30.8364 38.4896 31.9324 34.6685Z" />
	);
}

function DiagramConnectorEndCapArrow(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M31.9106 16.5179C30.9343 15.5416 29.3513 15.5416 28.375 16.5179C27.3987 17.4942 27.3987 19.0772 28.375 20.0535L37.7959 29.4744L21 29.4744C19.6336 29.4744 18.5259 30.6051 18.5259 32C18.5259 33.3949 19.6336 34.5256 21 34.5256L37.7959 34.5256L28.375 43.9465C27.3987 44.9228 27.3987 46.5057 28.375 47.482C29.3513 48.4584 30.9343 48.4584 31.9106 47.482L47.3926 32L31.9106 16.5179Z"
		/>
	);
}

function DiagramConnectorEndCapDot(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M31.5416 34.6685L17.4741 34.6685C16.1077 34.6685 15 33.5378 15 32.1429C15 30.748 16.1077 29.6172 17.4741 29.6172L31.5416 29.6172C32.6376 25.7962 36.1578 23 40.3312 23C45.3806 23 49.474 27.0934 49.474 32.1429C49.474 37.1923 45.3806 41.2857 40.3312 41.2857C36.1579 41.2857 32.6376 38.4896 31.5416 34.6685Z"
		/>
	);
}

function DiagramConnectorLineSolid(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M9.5 32C9.5 30.6193 10.6193 29.5 12 29.5L52 29.5C53.3807 29.5 54.5 30.6193 54.5 32C54.5 33.3807 53.3807 34.5 52 34.5L12 34.5C10.6193 34.5 9.5 33.3807 9.5 32Z"
		/>
	);
}

function DiagramConnectorLineDotted(props) {
	return (
		<g>
			<path d="M41 32C41 33.6569 39.6569 35 38 35C36.3431 35 35 33.6569 35 32C35 30.3431 36.3431 29 38 29C39.6569 29 41 30.3431 41 32Z" />
			<path d="M52 32C52 33.6569 50.6569 35 49 35C47.3431 35 46 33.6569 46 32C46 30.3431 47.3431 29 49 29C50.6569 29 52 30.3431 52 32Z" />
			<path d="M30 32C30 33.6569 28.6569 35 27 35C25.3431 35 24 33.6569 24 32C24 30.3431 25.3431 29 27 29C28.6569 29 30 30.3431 30 32Z" />
			<path d="M19 32C19 33.6569 17.6569 35 16 35C14.3431 35 13 33.6569 13 32C13 30.3431 14.3431 29 16 29C17.6569 29 19 30.3431 19 32Z" />
		</g>
	);
}

function DiagramConnectorDotArrowSolid(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M40.231 7.23348C41.2066 6.25648 42.7895 6.25536 43.7665 7.23098L53.5355 16.9862L43.769 26.7665C42.7934 27.7435 41.2105 27.7446 40.2335 26.769C39.2565 25.7934 39.2554 24.2105 40.231 23.2335L43.9592 19.5H25C23.2762 19.5 21.623 20.1849 20.4039 21.4039C19.1849 22.623 18.5 24.2762 18.5 26C18.5 27.7239 19.1849 29.3773 20.4039 30.5963C21.6229 31.8153 23.276 32.5 25 32.5H39C42.0499 32.5 44.975 33.7114 47.1317 35.8681C49.2884 38.0248 50.5 40.9501 50.5 44C50.5 47.05 49.2884 49.975 47.1317 52.1316C44.9751 54.2882 42.0501 55.5 39 55.5H24C22.6193 55.5 21.5 54.3807 21.5 53C21.5 51.6193 22.6193 50.5 24 50.5H39C40.7238 50.5 42.3772 49.8151 43.5962 48.5961C44.8152 47.3771 45.5 45.7239 45.5 44C45.5 42.276 44.8152 40.6226 43.5962 39.4037C42.3773 38.1847 40.724 37.5 39 37.5H25C21.9501 37.5 19.0251 36.2886 16.8684 34.1319C14.7118 31.9752 13.5 29.05 13.5 26C13.5 22.9499 14.7118 20.025 16.8684 17.8684C19.025 15.7118 21.9499 14.5 25 14.5H43.9698L40.2335 10.769C39.2565 9.7934 39.2554 8.21049 40.231 7.23348ZM14.5 57.5C16.9853 57.5 19 55.4853 19 53C19 50.5147 16.9853 48.5 14.5 48.5C12.0147 48.5 10 50.5147 10 53C10 55.4853 12.0147 57.5 14.5 57.5Z"
		/>
	);
}

function DiagramConnectorDotDotSolid(props) {
	return (
		<g>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M25 16.5C23.2762 16.5 21.623 17.1849 20.4039 18.4039C19.1849 19.623 18.5 21.2762 18.5 23C18.5 24.7239 19.1849 26.3773 20.4039 27.5963C21.6229 28.8153 23.276 29.5 25 29.5H39C42.0499 29.5 44.975 30.7114 47.1317 32.8681C49.2884 35.0248 50.5 37.9501 50.5 41C50.5 44.05 49.2884 46.975 47.1317 49.1316C44.9751 51.2882 42.0501 52.5 39 52.5H24C22.6193 52.5 21.5 51.3807 21.5 50C21.5 48.6193 22.6193 47.5 24 47.5H39C40.7238 47.5 42.3771 46.8151 43.5962 45.5961C44.8152 44.3771 45.5 42.7239 45.5 41C45.5 39.276 44.8152 37.6226 43.5962 36.4037C42.3773 35.1847 40.724 34.5 39 34.5H25C21.9501 34.5 19.0251 33.2886 16.8684 31.1319C14.7118 28.9752 13.5 26.05 13.5 23C13.5 19.9499 14.7118 17.025 16.8684 14.8684C19.025 12.7118 21.9499 11.5 25 11.5H40C41.3807 11.5 42.5 12.6193 42.5 14C42.5 15.3807 41.3807 16.5 40 16.5H25Z"
			/>
			<path d="M19 50C19 52.4853 16.9853 54.5 14.5 54.5C12.0147 54.5 10 52.4853 10 50C10 47.5147 12.0147 45.5 14.5 45.5C16.9853 45.5 19 47.5147 19 50Z" />
			<path d="M54 13.5C54 15.9853 51.9853 18 49.5 18C47.0147 18 45 15.9853 45 13.5C45 11.0147 47.0147 9 49.5 9C51.9853 9 54 11.0147 54 13.5Z" />
		</g>
	);
}

function DiagramConnectorArrowArrowSolid(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M40.231 4.23348C41.2066 3.25648 42.7895 3.25536 43.7665 4.23098L53.5355 13.9862L43.769 23.7665C42.7934 24.7435 41.2105 24.7446 40.2335 23.769C39.2565 22.7934 39.2554 21.2105 40.231 20.2335L43.9592 16.5H25C21.4102 16.5 18.5 19.4102 18.5 23C18.5 26.5899 21.4102 29.5 25 29.5H39C45.3513 29.5 50.5 34.6487 50.5 41C50.5 47.3513 45.3513 52.5 39 52.5H20.0408L23.769 56.2335C24.7446 57.2105 24.7435 58.7934 23.7665 59.769C22.7895 60.7446 21.2066 60.7435 20.231 59.7665L10.4645 49.9862L20.2335 40.231C21.2105 39.2554 22.7934 39.2565 23.769 40.2335C24.7446 41.2105 24.7435 42.7934 23.7665 43.769L20.0303 47.5H39C42.5899 47.5 45.5 44.5899 45.5 41C45.5 37.4102 42.5899 34.5 39 34.5H25C18.6487 34.5 13.5 29.3513 13.5 23C13.5 16.6487 18.6487 11.5 25 11.5H43.9698L40.2335 7.76902C39.2565 6.7934 39.2554 5.21049 40.231 4.23348Z"
		/>
	);
}

function DiagramConnectorArrowDotSolid(props) {
	return (
		<g>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M25 16.5C23.2762 16.5 21.623 17.1849 20.4039 18.4039C19.1849 19.623 18.5 21.2762 18.5 23C18.5 24.7239 19.1849 26.3773 20.4039 27.5963C21.6229 28.8153 23.276 29.5 25 29.5H39C42.0499 29.5 44.975 30.7114 47.1317 32.8681C49.2884 35.0248 50.5 37.9501 50.5 41C50.5 44.05 49.2884 46.975 47.1317 49.1316C44.9751 51.2882 42.0501 52.5 39 52.5H20.0408L23.769 56.2335C24.7446 57.2105 24.7435 58.7934 23.7665 59.769C22.7895 60.7446 21.2066 60.7435 20.231 59.7665L10.4645 49.9862L20.2335 40.231C21.2105 39.2554 22.7934 39.2565 23.769 40.2335C24.7446 41.2105 24.7435 42.7934 23.7665 43.769L20.0303 47.5H39C40.7238 47.5 42.3772 46.8151 43.5962 45.5961C44.8152 44.3771 45.5 42.7239 45.5 41C45.5 39.276 44.8152 37.6226 43.5962 36.4037C42.3773 35.1847 40.724 34.5 39 34.5H25C21.9501 34.5 19.0251 33.2886 16.8684 31.1319C14.7118 28.9752 13.5 26.05 13.5 23C13.5 19.9499 14.7118 17.025 16.8684 14.8684C19.025 12.7118 21.9499 11.5 25 11.5H40C41.3807 11.5 42.5 12.6193 42.5 14C42.5 15.3807 41.3807 16.5 40 16.5H25Z"
			/>
			<path d="M54 13.5C54 15.9853 51.9853 18 49.5 18C47.0147 18 45 15.9853 45 13.5C45 11.0147 47.0147 9 49.5 9C51.9853 9 54 11.0147 54 13.5Z" />
		</g>
	);
}

function DiagramConnectorDotArrowDotted(props) {
	return (
		<g>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M40.231 4.23348C41.2066 3.25648 42.7895 3.25536 43.7665 4.23098L53.5355 13.9862L43.769 23.7665C42.7934 24.7435 41.2105 24.7446 40.2335 23.769C39.2565 22.7934 39.2554 21.2105 40.231 20.2335L46.4645 13.9912L40.2335 7.76902C39.2565 6.7934 39.2554 5.21049 40.231 4.23348Z"
			/>
			<path d="M19 50C19 52.4853 16.9853 54.5 14.5 54.5C12.0147 54.5 10 52.4853 10 50C10 47.5147 12.0147 45.5 14.5 45.5C16.9853 45.5 19 47.5147 19 50Z" />
			<path d="M39.4366 14C39.4366 15.6569 38.0935 17 36.4366 17C34.7798 17 33.4366 15.6569 33.4366 14C33.4366 12.3432 34.7798 11 36.4366 11C38.0935 11 39.4366 12.3432 39.4366 14Z" />
			<path d="M21.6363 14.1231C21.5723 12.4675 22.8627 11.0735 24.5183 11.0096C26.1739 10.9456 27.5679 12.236 27.6318 13.8916C27.6957 15.5472 26.4054 16.9412 24.7498 17.0051C23.0942 17.069 21.7002 15.7787 21.6363 14.1231Z" />
			<path d="M15.5443 23.7931C13.9342 23.4024 12.9456 21.7804 13.3363 20.1703C13.727 18.5601 15.349 17.5716 16.9591 17.9623C18.5693 18.353 19.5578 19.975 19.1671 21.5851C18.7764 23.1952 17.1544 24.1838 15.5443 23.7931Z" />
			<path d="M23.1941 32.3091C22.3831 33.7539 20.5545 34.2677 19.1096 33.4567C17.6648 32.6458 17.151 30.8171 17.962 29.3723C18.7729 27.9275 20.6016 27.4136 22.0464 28.2246C23.4912 29.0356 24.0051 30.8643 23.1941 32.3091Z" />
			<path d="M35.0742 32C35.0742 33.6569 33.7311 35 32.0742 35C30.4174 35 29.0742 33.6569 29.0742 32C29.0742 30.3432 30.4174 29 32.0742 29C33.7311 29 35.0742 30.3432 35.0742 32Z" />
			<path d="M46.1391 34.7626C45.2964 36.1891 43.4568 36.6624 42.0302 35.8197C40.6037 34.977 40.1304 33.1374 40.9731 31.7108C41.8159 30.2843 43.6554 29.811 45.082 30.6537C46.5085 31.4964 46.9818 33.336 46.1391 34.7626Z" />
			<path d="M46.9217 46.229C45.3209 45.8017 44.3696 44.1576 44.7969 42.5568C45.2242 40.956 46.8683 40.0046 48.4691 40.4319C50.0699 40.8592 51.0212 42.5033 50.5939 44.1041C50.1666 45.705 48.5225 46.6563 46.9217 46.229Z" />
			<path d="M36.1171 50.0456C36.0915 48.3889 37.4137 47.0252 39.0704 46.9996C40.727 46.974 42.0908 48.2963 42.1164 49.9529C42.1419 51.6096 40.8197 52.9733 39.163 52.9989C37.5064 53.0245 36.1426 51.7022 36.1171 50.0456Z" />
			<path d="M30.465 50C30.465 51.6569 29.1218 53 27.465 53C25.8081 53 24.465 51.6569 24.465 50C24.465 48.3432 25.8081 47 27.465 47C29.1218 47 30.465 48.3432 30.465 50Z" />
		</g>
	);
}

function DiagramConnectorDotDotDotted(props) {
	return (
		<g>
			<path d="M19 50C19 52.4853 16.9853 54.5 14.5 54.5C12.0147 54.5 10 52.4853 10 50C10 47.5147 12.0147 45.5 14.5 45.5C16.9853 45.5 19 47.5147 19 50Z" />
			<path d="M54 13.5C54 15.9853 51.9853 18 49.5 18C47.0147 18 45 15.9853 45 13.5C45 11.0147 47.0147 9 49.5 9C51.9853 9 54 11.0147 54 13.5Z" />
			<path d="M39.4366 14C39.4366 15.6569 38.0935 17 36.4366 17C34.7798 17 33.4366 15.6569 33.4366 14C33.4366 12.3432 34.7798 11 36.4366 11C38.0935 11 39.4366 12.3432 39.4366 14Z" />
			<path d="M21.6363 14.1231C21.5723 12.4675 22.8627 11.0735 24.5183 11.0096C26.1739 10.9456 27.5679 12.236 27.6318 13.8916C27.6957 15.5472 26.4054 16.9412 24.7498 17.0051C23.0942 17.069 21.7002 15.7787 21.6363 14.1231Z" />
			<path d="M15.5443 23.7931C13.9342 23.4024 12.9456 21.7804 13.3363 20.1703C13.727 18.5601 15.349 17.5716 16.9591 17.9623C18.5693 18.353 19.5578 19.975 19.1671 21.5851C18.7764 23.1952 17.1544 24.1838 15.5443 23.7931Z" />
			<path d="M23.1941 32.3091C22.3831 33.7539 20.5545 34.2677 19.1096 33.4567C17.6648 32.6458 17.151 30.8171 17.962 29.3723C18.7729 27.9275 20.6016 27.4136 22.0464 28.2246C23.4912 29.0356 24.0051 30.8643 23.1941 32.3091Z" />
			<path d="M35.0742 32C35.0742 33.6569 33.7311 35 32.0742 35C30.4174 35 29.0742 33.6569 29.0742 32C29.0742 30.3432 30.4174 29 32.0742 29C33.7311 29 35.0742 30.3432 35.0742 32Z" />
			<path d="M46.1391 34.7626C45.2964 36.1891 43.4568 36.6624 42.0302 35.8197C40.6037 34.977 40.1304 33.1374 40.9731 31.7108C41.8159 30.2843 43.6554 29.811 45.082 30.6537C46.5085 31.4964 46.9818 33.336 46.1391 34.7626Z" />
			<path d="M46.9217 46.229C45.3209 45.8017 44.3696 44.1576 44.7969 42.5568C45.2242 40.956 46.8683 40.0046 48.4691 40.4319C50.0699 40.8592 51.0212 42.5033 50.5939 44.1041C50.1666 45.705 48.5225 46.6563 46.9217 46.229Z" />
			<path d="M36.1171 50.0456C36.0915 48.3889 37.4137 47.0252 39.0704 46.9996C40.727 46.974 42.0908 48.2963 42.1164 49.9529C42.1419 51.6096 40.8197 52.9733 39.163 52.9989C37.5064 53.0245 36.1426 51.7022 36.1171 50.0456Z" />
			<path d="M30.465 50C30.465 51.6569 29.1218 53 27.465 53C25.8081 53 24.465 51.6569 24.465 50C24.465 48.3432 25.8081 47 27.465 47C29.1218 47 30.465 48.3432 30.465 50Z" />
		</g>
	);
}

function DiagramConnectorArrowArrowDotted(props) {
	return (
		<g>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M40.231 4.23348C41.2066 3.25648 42.7895 3.25536 43.7665 4.23098L53.5355 13.9862L43.769 23.7665C42.7934 24.7435 41.2105 24.7446 40.2335 23.769C39.2565 22.7934 39.2554 21.2105 40.231 20.2335L46.4645 13.9912L40.2335 7.76902C39.2565 6.7934 39.2554 5.21049 40.231 4.23348Z"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M23.769 40.2335C22.7934 39.2565 21.2105 39.2554 20.2335 40.231L10.4645 49.9862L20.231 59.7665C21.2066 60.7435 22.7895 60.7446 23.7665 59.769C24.7435 58.7934 24.7446 57.2105 23.769 56.2335L17.5355 49.9912L23.7665 43.769C24.7435 42.7934 24.7446 41.2105 23.769 40.2335Z"
			/>
			<path d="M39.4367 14C39.4367 15.6569 38.0935 17 36.4367 17C34.7798 17 33.4367 15.6569 33.4367 14C33.4367 12.3432 34.7798 11 36.4367 11C38.0935 11 39.4367 12.3432 39.4367 14Z" />
			<path d="M21.6363 14.1231C21.5724 12.4675 22.8627 11.0735 24.5183 11.0096C26.1739 10.9456 27.5679 12.236 27.6318 13.8916C27.6958 15.5472 26.4054 16.9412 24.7498 17.0051C23.0942 17.069 21.7002 15.7787 21.6363 14.1231Z" />
			<path d="M15.5443 23.7931C13.9342 23.4024 12.9456 21.7804 13.3363 20.1703C13.727 18.5601 15.349 17.5716 16.9592 17.9623C18.5693 18.353 19.5578 19.975 19.1671 21.5851C18.7764 23.1952 17.1545 24.1838 15.5443 23.7931Z" />
			<path d="M23.1941 32.3091C22.3831 33.7539 20.5545 34.2677 19.1097 33.4567C17.6648 32.6458 17.151 30.8171 17.962 29.3723C18.7729 27.9275 20.6016 27.4136 22.0464 28.2246C23.4913 29.0356 24.0051 30.8643 23.1941 32.3091Z" />
			<path d="M35.0743 32C35.0743 33.6569 33.7311 35 32.0743 35C30.4174 35 29.0743 33.6569 29.0743 32C29.0743 30.3432 30.4174 29 32.0743 29C33.7311 29 35.0743 30.3432 35.0743 32Z" />
			<path d="M46.1391 34.7626C45.2964 36.1891 43.4568 36.6624 42.0303 35.8197C40.6037 34.977 40.1304 33.1374 40.9732 31.7108C41.8159 30.2843 43.6555 29.811 45.082 30.6537C46.5085 31.4964 46.9818 33.336 46.1391 34.7626Z" />
			<path d="M46.9217 46.229C45.3209 45.8017 44.3696 44.1576 44.7969 42.5568C45.2242 40.956 46.8683 40.0046 48.4691 40.4319C50.0699 40.8592 51.0212 42.5033 50.5939 44.1041C50.1666 45.705 48.5225 46.6563 46.9217 46.229Z" />
			<path d="M36.1171 50.0456C36.0915 48.3889 37.4137 47.0252 39.0704 46.9996C40.7271 46.974 42.0908 48.2963 42.1164 49.9529C42.1419 51.6096 40.8197 52.9733 39.163 52.9989C37.5064 53.0245 36.1427 51.7022 36.1171 50.0456Z" />
			<path d="M30.465 50C30.465 51.6569 29.1219 53 27.465 53C25.8081 53 24.465 51.6569 24.465 50C24.465 48.3432 25.8081 47 27.465 47C29.1219 47 30.465 48.3432 30.465 50Z" />
		</g>
	);
}

function DiagramConnectorArrowDotDotted(props) {
	return (
		<g>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M23.769 40.2335C22.7934 39.2565 21.2105 39.2554 20.2335 40.231L10.4645 49.9862L20.231 59.7665C21.2066 60.7435 22.7895 60.7446 23.7665 59.769C24.7435 58.7934 24.7446 57.2105 23.769 56.2335L17.5355 49.9912L23.7665 43.769C24.7435 42.7934 24.7446 41.2105 23.769 40.2335Z"
			/>

			<path d="M54 13.5C54 15.9853 51.9853 18 49.5 18C47.0147 18 45 15.9853 45 13.5C45 11.0147 47.0147 9 49.5 9C51.9853 9 54 11.0147 54 13.5Z" />
			<path d="M39.4367 14C39.4367 15.6569 38.0935 17 36.4367 17C34.7798 17 33.4367 15.6569 33.4367 14C33.4367 12.3432 34.7798 11 36.4367 11C38.0935 11 39.4367 12.3432 39.4367 14Z" />
			<path d="M21.6363 14.1231C21.5724 12.4675 22.8627 11.0735 24.5183 11.0096C26.1739 10.9456 27.5679 12.236 27.6318 13.8916C27.6958 15.5472 26.4054 16.9412 24.7498 17.0051C23.0942 17.069 21.7002 15.7787 21.6363 14.1231Z" />
			<path d="M15.5443 23.7931C13.9342 23.4024 12.9456 21.7804 13.3363 20.1703C13.727 18.5601 15.349 17.5716 16.9592 17.9623C18.5693 18.353 19.5578 19.975 19.1671 21.5851C18.7764 23.1952 17.1545 24.1838 15.5443 23.7931Z" />
			<path d="M23.1941 32.3091C22.3831 33.7539 20.5545 34.2677 19.1097 33.4567C17.6648 32.6458 17.151 30.8171 17.962 29.3723C18.7729 27.9275 20.6016 27.4136 22.0464 28.2246C23.4913 29.0356 24.0051 30.8643 23.1941 32.3091Z" />
			<path d="M35.0743 32C35.0743 33.6569 33.7311 35 32.0743 35C30.4174 35 29.0743 33.6569 29.0743 32C29.0743 30.3432 30.4174 29 32.0743 29C33.7311 29 35.0743 30.3432 35.0743 32Z" />
			<path d="M46.1391 34.7626C45.2964 36.1891 43.4568 36.6624 42.0303 35.8197C40.6037 34.977 40.1304 33.1374 40.9732 31.7108C41.8159 30.2843 43.6555 29.811 45.082 30.6537C46.5085 31.4964 46.9818 33.336 46.1391 34.7626Z" />
			<path d="M46.9217 46.229C45.3209 45.8017 44.3696 44.1576 44.7969 42.5568C45.2242 40.956 46.8683 40.0046 48.4691 40.4319C50.0699 40.8592 51.0212 42.5033 50.5939 44.1041C50.1666 45.705 48.5225 46.6563 46.9217 46.229Z" />
			<path d="M36.1171 50.0456C36.0915 48.3889 37.4137 47.0252 39.0704 46.9996C40.7271 46.974 42.0908 48.2963 42.1164 49.9529C42.1419 51.6096 40.8197 52.9733 39.163 52.9989C37.5064 53.0245 36.1427 51.7022 36.1171 50.0456Z" />
			<path d="M30.465 50C30.465 51.6569 29.1219 53 27.465 53C25.8081 53 24.465 51.6569 24.465 50C24.465 48.3432 25.8081 47 27.465 47C29.1219 47 30.465 48.3432 30.465 50Z" />
		</g>
	);
}

function ColorRing(props) {
	return (
		<g>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M32 54C44.1503 54 54 44.1503 54 32C54 19.8497 44.1503 10 32 10C19.8497 10 10 19.8497 10 32C10 44.1503 19.8497 54 32 54ZM32 58C46.3594 58 58 46.3594 58 32C58 17.6406 46.3594 6 32 6C17.6406 6 6 17.6406 6 32C6 46.3594 17.6406 58 32 58Z"
				fill={props.selected ? props.color : "url(#pattern0)"}
			/>
			<circle cx="32" cy="32" r="16" fill={props.color} />
			<defs>
				<pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
					<use xlinkHref="#image0" transform="scale(0.00217391)" />
				</pattern>
				<image id="image0" width="460" height="460" xlinkHref={gradient} />
			</defs>
		</g>
	);
}

function DoubleSparkle(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M50.7763 6.6595L51.5301 11.1828C51.811 12.8684 53.1318 14.1893 54.8173 14.4704L59.3408 15.2241C59.6737 15.2788 59.9347 15.5398 59.9894 15.8728C60.0598 16.3014 59.7694 16.706 59.3408 16.7764L54.8173 17.5304C53.1318 17.8114 51.811 19.1323 51.5301 20.8178L50.7763 25.3411C50.7217 25.6745 50.4604 25.9357 50.1271 25.9903C49.6985 26.0605 49.2941 25.7698 49.2239 25.3411L48.47 20.8178C48.1891 19.1322 46.8681 17.8113 45.1825 17.5304L40.6591 16.7764C40.3261 16.7217 40.0651 16.4607 40.0105 16.1277C39.9401 15.6991 40.2305 15.2945 40.6591 15.2241L45.1825 14.4704C46.8682 14.1895 48.1891 12.8685 48.47 11.1828L49.2239 6.6595C49.2784 6.32619 49.5397 6.06493 49.873 6.01037C50.3017 5.94019 50.7061 6.23082 50.7763 6.6595ZM29.5533 19.319L31.061 28.3654C31.6226 31.7364 34.2641 34.3781 37.635 34.9402L46.6816 36.4476C47.3476 36.557 47.8695 37.079 47.9789 37.7449C48.1197 38.6021 47.5389 39.4112 46.6816 39.552L37.635 41.06C34.2642 41.622 31.6227 44.2636 31.061 47.6346L29.5533 56.6809C29.4442 57.3475 28.9217 57.87 28.2551 57.9791C27.3978 58.1194 26.589 57.5382 26.4486 56.6809L24.941 47.6346C24.3791 44.2634 21.7373 41.6217 18.3661 41.06L9.31978 39.552C8.65385 39.4426 8.13187 38.9207 8.0225 38.2548C7.88171 37.3975 8.46252 36.5884 9.31978 36.4476L18.3661 34.9402C21.7374 34.3784 24.3792 31.7366 24.941 28.3654L26.4486 19.319C26.5578 18.6524 27.0803 18.1299 27.7468 18.0208C28.6042 17.8805 29.413 18.4617 29.5533 19.319Z"
			fill={props.color}
		/>
	);
}

function Upload(props) {
	return (
		<g>
			<path d="M34 52C34 53.1046 33.1046 54 32 54C30.8954 54 30 53.1046 30 52V28.8284L23.4142 35.4142C22.6332 36.1953 21.3668 36.1953 20.5858 35.4142C19.8047 34.6332 19.8047 33.3668 20.5858 32.5858L30.5858 22.5858C31.3668 21.8047 32.6332 21.8047 33.4142 22.5858L43.4142 32.5858C44.1953 33.3668 44.1953 34.6332 43.4142 35.4142C42.6332 36.1953 41.3668 36.1953 40.5858 35.4142L34 28.8284V52Z" />
			<path d="M14 14C12.8954 14 12 13.1046 12 12C12 10.8954 12.8954 10 14 10H50C51.1046 10 52 10.8954 52 12C52 13.1046 51.1046 14 50 14H14Z" />
		</g>
	);
}

function Info(props) {
	return (
		<g>
			<path d="M34 22C34 23.6569 32.6569 25 31 25C29.3431 25 28 23.6569 28 22C28 20.3431 29.3431 19 31 19C32.6569 19 34 20.3431 34 22Z" />
			<path d="M26 30C26 28.8954 26.8954 28 28 28H32C33.1046 28 34 28.8954 34 30V39.5C34 39.7761 34.2239 40 34.5 40H37C38.1046 40 39 40.8954 39 42C39 43.1046 38.1046 44 37 44H27C25.8954 44 25 43.1046 25 42C25 40.8954 25.8954 40 27 40H29.5C29.7761 40 30 39.7761 30 39.5V32.5C30 32.2239 29.7761 32 29.5 32H28C26.8954 32 26 31.1046 26 30Z" />
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M56 32C56 45.2548 45.2548 56 32 56C18.7452 56 8 45.2548 8 32C8 18.7452 18.7452 8 32 8C45.2548 8 56 18.7452 56 32ZM52 32C52 43.0457 43.0457 52 32 52C20.9543 52 12 43.0457 12 32C12 20.9543 20.9543 12 32 12C43.0457 12 52 20.9543 52 32Z"
			/>
		</g>
	);
}

function Retake(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M16 12C16 10.8954 15.1046 10 14 10C12.8954 10 12 10.8954 12 12V22C12 23.1046 12.8954 24 14 24H24C25.1046 24 26 23.1046 26 22C26 20.8954 25.1046 20 24 20H18.5836C20.7681 17.5575 23.5854 15.7502 26.7373 14.7865C30.3725 13.6751 34.2661 13.7431 37.8603 14.9807C41.4544 16.2182 44.5645 18.5618 46.7448 21.6756C48.9251 24.7894 50.0636 28.5135 49.9973 32.3142C49.9309 36.1148 48.6631 39.7969 46.3755 42.8327C44.0878 45.8685 40.8978 48.1021 37.2627 49.2135C33.6276 50.3249 29.7339 50.2569 26.1398 49.0193C23.1785 47.9997 20.5458 46.2292 18.491 43.8957C17.7611 43.0667 16.5218 42.838 15.617 43.4715C14.7122 44.1051 14.4856 45.3591 15.1987 46.2027C17.7503 49.2212 21.0771 51.5066 24.8375 52.8014C29.2303 54.314 33.9892 54.397 38.4322 53.0387C42.8751 51.6804 46.774 48.9504 49.57 45.2399C52.366 41.5295 53.9156 37.0292 53.9967 32.384C54.0778 27.7387 52.6862 23.1871 50.0214 19.3813C47.3566 15.5756 43.5554 12.7112 39.1625 11.1986C34.7697 9.68602 30.0108 9.60295 25.5678 10.9613C21.9042 12.0814 18.6104 14.1342 16 16.9003V12ZM16 19.9431V20H16.0755L16 19.9431Z"
		/>
	);
}

function Warning(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M55.0064 52.0079H9.02337C7.36602 52.0069 6.02328 50.6625 6.02429 49.0052C6.02462 48.458 6.17456 47.9213 6.45788 47.4532L29.4494 9.4424C30.3058 8.02554 32.1487 7.57122 33.5655 8.42765C33.9809 8.67875 34.3292 9.02698 34.5803 9.4424L57.5719 47.4532H57.5719C58.43 48.8711 57.9763 50.7162 56.5584 51.5743C56.0902 51.8576 55.5536 52.0076 55.0064 52.0079L55.0064 52.0079ZM32.0148 48.0207C33.6716 48.0207 35.0148 46.6775 35.0148 45.0207C35.0148 43.3638 33.6716 42.0207 32.0148 42.0207C30.3579 42.0207 29.0148 43.3638 29.0148 45.0207C29.0148 46.6775 30.3579 48.0207 32.0148 48.0207ZM34.0133 20.0207H30.0344H30.0344C29.4766 20.0142 29.0192 20.4611 29.0126 21.0188C29.0124 21.037 29.0127 21.0552 29.0135 21.0733L29.9282 38.0733C29.9628 38.6102 30.4112 39.0262 30.9492 39.0207H33.0985C33.6364 39.0261 34.0848 38.6101 34.1196 38.0733L35.0343 21.0733C35.0578 20.516 34.6251 20.0451 34.0677 20.0216C34.0496 20.0209 34.0314 20.0206 34.0133 20.0208V20.0207Z"
		/>
	);
}

function Report(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M32.0208 56.021H32.0208C18.766 56.021 8.02081 45.2758 8.02081 32.021C8.02081 18.7662 18.766 8.021 32.0208 8.021C45.2756 8.021 56.0208 18.7662 56.0208 32.021V32.021C56.0208 45.2758 45.2756 56.021 32.0208 56.021H32.0208ZM32.0208 12.021H32.0208C20.9751 12.021 12.0208 20.9753 12.0208 32.021C12.0208 43.0667 20.9751 52.021 32.0208 52.021C43.0665 52.021 52.0208 43.0667 52.0208 32.021V32.0211C52.0208 20.9754 43.0666 12.0212 32.0209 12.0211L32.0208 12.021ZM33.0985 37.021H30.9492C30.4113 37.0265 29.9629 36.6105 29.9281 36.0736L29.0135 19.0736V19.0736C28.99 18.5163 29.4226 18.0454 29.9799 18.0218C29.9981 18.0211 30.0162 18.0208 30.0343 18.021H34.0134C34.5712 18.0145 35.0286 18.4614 35.0351 19.0191C35.0354 19.0373 35.0351 19.0554 35.0343 19.0736L34.1196 36.0736C34.0848 36.6104 33.6364 37.0264 33.0985 37.021V37.021ZM32.0148 40.021C33.6717 40.021 35.0148 41.3641 35.0148 43.021C35.0148 44.6778 33.6717 46.021 32.0148 46.021C30.358 46.021 29.0148 44.6778 29.0148 43.021C29.0148 41.3641 30.358 40.021 32.0148 40.021Z"
		/>
	);
}

function TwoArrowCirclePathCounterclockwise(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M8.3874 28.7406C8.36474 29.2899 8.7917 29.7536 9.34103 29.7763C9.46128 29.7812 9.58142 29.7643 9.69564 29.7264L21.2798 25.9666C21.8206 25.7953 22.1201 25.2179 21.9488 24.677C21.8862 24.4795 21.7653 24.3055 21.602 24.1779L17.622 21.1787C23.6108 13.2426 34.8989 11.6645 42.835 17.6533C46.1357 20.1442 48.4783 23.6954 49.469 27.71C49.7113 28.788 50.7817 29.4653 51.8596 29.223C52.9375 28.9806 53.6149 27.9103 53.3725 26.8323C50.5055 15.0237 38.6085 7.7751 26.7998 10.6421C21.8605 11.8414 17.4886 14.7137 14.4272 18.7712L10.4392 15.766C9.98008 15.4326 9.3376 15.5345 9.00421 15.9937C8.8825 16.1613 8.81429 16.3618 8.80853 16.5688L8.3874 28.7406ZM54.2882 34.3152L42.7041 38.075C42.1632 38.2463 41.8637 38.8236 42.035 39.3645C42.0976 39.5619 42.2184 39.7359 42.3816 39.8635L46.3612 42.8623C40.3724 50.7983 29.084 52.3771 21.148 46.3884C17.8471 43.8973 15.5044 40.3458 14.5139 36.3307C14.2714 35.2528 13.2009 34.5756 12.1231 34.8182C11.0452 35.0607 10.368 36.1312 10.6105 37.209C13.4775 49.0175 25.3743 56.2661 37.1828 53.3992C42.1222 52.1999 46.4941 49.3275 49.5555 45.2699L53.5445 48.2758C54.0036 48.6092 54.6461 48.5072 54.9795 48.0481C55.1011 47.8805 55.1693 47.6801 55.1751 47.4731L55.5962 35.3014C55.619 34.7521 55.1921 34.2883 54.6428 34.2655C54.5225 34.2606 54.4024 34.2773 54.2882 34.3152Z"
		/>
	);
}

function TomeLogo(props) {
	return (
		<path d="M56.8661 29.9812L52.4396 14.161C52.2661 13.5408 51.9357 12.9759 51.4803 12.5206C51.0249 12.0653 50.4599 11.7351 49.8398 11.5616L34.0193 7.13445C32.6981 6.76475 31.3008 6.76475 29.9796 7.13445L14.1604 11.561C13.5404 11.7345 12.9756 12.0648 12.5203 12.5201C12.065 12.9754 11.7347 13.5403 11.5612 14.1603L7.13477 29.9819C6.76497 31.3027 6.76497 32.6997 7.13477 34.0205L11.5593 49.8414C11.7327 50.4615 12.063 51.0265 12.5183 51.4819C12.9736 51.9373 13.5385 52.2677 14.1586 52.4413L29.9796 56.866C31.3009 57.2352 32.6981 57.2352 34.0193 56.866L49.8416 52.4388C50.4617 52.2652 51.0267 51.9348 51.4819 51.4794C51.9372 51.024 52.2675 50.459 52.4409 49.8389L56.8661 34.0186C57.2355 32.6982 57.2355 31.3017 56.8661 29.9812ZM50.7443 34.8282L34.827 50.744C34.0773 51.4936 33.0606 51.9147 32.0004 51.9147C30.9403 51.9147 29.9235 51.4936 29.1738 50.744L13.2578 34.8282C12.8866 34.4569 12.5921 34.0162 12.3912 33.5311C12.1902 33.0461 12.0868 32.5262 12.0868 32.0012C12.0868 31.4761 12.1902 30.9562 12.3912 30.4712C12.5921 29.9861 12.8866 29.5454 13.2578 29.1741L29.1738 13.2577C29.9235 12.5081 30.9403 12.087 32.0004 12.087C33.0606 12.087 34.0773 12.5081 34.827 13.2577L50.743 29.1741C51.1143 29.5454 51.4088 29.9861 51.6097 30.4712C51.8106 30.9562 51.914 31.4761 51.914 32.0012C51.914 32.5262 51.8106 33.0461 51.6097 33.5311C51.4088 34.0162 51.1143 34.4569 50.743 34.8282H50.7443Z" />
	);
}

function Doc(props) {
	return (
		<g>
			<path d="M24 20C22.8954 20 22 20.8954 22 22C22 23.1046 22.8954 24 24 24H40C41.1046 24 42 23.1046 42 22C42 20.8954 41.1046 20 40 20H24Z" />
			<path d="M22 30C22 28.8954 22.8954 28 24 28H40C41.1046 28 42 28.8954 42 30C42 31.1046 41.1046 32 40 32H24C22.8954 32 22 31.1046 22 30Z" />
			<path d="M24 36C22.8954 36 22 36.8954 22 38C22 39.1046 22.8954 40 24 40H32C33.1046 40 34 39.1046 34 38C34 36.8954 33.1046 36 32 36H24Z" />
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M22 8C17.5817 8 14 11.5817 14 16V48C14 52.4183 17.5817 56 22 56H42C46.4183 56 50 52.4183 50 48V16C50 11.5817 46.4183 8 42 8H22ZM22 12C19.7909 12 18 13.7909 18 16V48C18 50.2091 19.7909 52 22 52H42C44.2091 52 46 50.2091 46 48V16C46 13.7909 44.2091 12 42 12H22Z"
			/>
		</g>
	);
}

function OutlineAlt(props) {
	return (
		<g>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M16 10C12.6863 10 10 12.6863 10 16V48C10 51.3137 12.6863 54 16 54H32C35.3137 54 38 51.3137 38 48V16C38 12.6863 35.3137 10 32 10H16ZM16 14C14.8954 14 14 14.8954 14 16V48C14 49.1046 14.8954 50 16 50H32C33.1046 50 34 49.1046 34 48V16C34 14.8954 33.1046 14 32 14H16Z"
			/>
			<path d="M42 17C42 16.4477 42.4477 16 43 16C44.6569 16 46 17.3431 46 19V45C46 46.6569 44.6569 48 43 48C42.4477 48 42 47.5523 42 47V17Z" />
			<path d="M51 22C50.4477 22 50 22.4477 50 23V41C50 41.5523 50.4477 42 51 42C52.6569 42 54 40.6569 54 39V25C54 23.3431 52.6569 22 51 22Z" />
		</g>
	);
}

function Page(props) {
	return (
		<g>
			<path d="M24 16C22.8954 16 22 16.8954 22 18C22 19.1046 22.8954 20 24 20H40C41.1046 20 42 19.1046 42 18C42 16.8954 41.1046 16 40 16H24Z" />
			<path d="M22 26C22 24.8954 22.8954 24 24 24H32C33.1046 24 34 24.8954 34 26C34 27.1046 33.1046 28 32 28H24C22.8954 28 22 27.1046 22 26Z" />
			<path d="M24 34C22.8954 34 22 34.8954 22 36V46C22 47.1046 22.8954 48 24 48H40C41.1046 48 42 47.1046 42 46V36C42 34.8954 41.1046 34 40 34H24Z" />
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M22 8C17.5817 8 14 11.5817 14 16V48C14 52.4183 17.5817 56 22 56H42C46.4183 56 50 52.4183 50 48V16C50 11.5817 46.4183 8 42 8H22ZM22 12C19.7909 12 18 13.7909 18 16V48C18 50.2091 19.7909 52 22 52H42C44.2091 52 46 50.2091 46 48V16C46 13.7909 44.2091 12 42 12H22Z"
			/>
		</g>
	);
}

function MultiplePagesLandscape(props) {
	return (
		<g>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M14 17C9.58172 17 6 20.5817 6 25V39C6 43.4183 9.58172 47 14 47H38C42.4183 47 46 43.4183 46 39V25C46 20.5817 42.4183 17 38 17H14ZM38 21H14C11.7909 21 10 22.7909 10 25V39C10 41.2091 11.7909 43 14 43H38C40.2091 43 42 41.2091 42 39V25C42 22.7909 40.2091 21 38 21Z"
			/>
			<path d="M50 23C50 22.4477 50.4477 22 51 22C52.6569 22 54 23.3431 54 25V39C54 40.6569 52.6569 42 51 42C50.4477 42 50 41.5523 50 41V23Z" />
			<path d="M59 26C58.4477 26 58 26.4477 58 27V37C58 37.5523 58.4477 38 59 38C60.6569 38 62 36.6569 62 35V29C62 27.3431 60.6569 26 59 26Z" />
		</g>
	);
}

function PageLandscape(props) {
	return (
		<g>
			<path d="M18 26C16.8954 26 16 26.8954 16 28C16 29.1046 16.8954 30 18 30H30C31.1046 30 32 29.1046 32 28C32 26.8954 31.1046 26 30 26H18Z" />
			<path d="M16 36C16 34.8954 16.8954 34 18 34H26C27.1046 34 28 34.8954 28 36C28 37.1046 27.1046 38 26 38H18C16.8954 38 16 37.1046 16 36Z" />
			<path d="M38 24C36.8954 24 36 24.8954 36 26V38C36 39.1046 36.8954 40 38 40H46C47.1046 40 48 39.1046 48 38V26C48 24.8954 47.1046 24 46 24H38Z" />
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M16 50C11.5817 50 8 46.4183 8 42V22C8 17.5817 11.5817 14 16 14H48C52.4183 14 56 17.5817 56 22V42C56 46.4183 52.4183 50 48 50H16ZM16 46C13.7909 46 12 44.2091 12 42V22C12 19.7909 13.7909 18 16 18H48C50.2091 18 52 19.7909 52 22V42C52 44.2091 50.2091 46 48 46H16Z"
			/>
		</g>
	);
}

function PagesStacked(props) {
	return (
		<g>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M14 13C10.6863 13 8 15.6863 8 19V35C8 38.3137 10.6863 41 14 41H18V45C18 48.3137 20.6863 51 24 51H50C53.3137 51 56 48.3137 56 45V29C56 25.6863 53.3137 23 50 23H46V19C46 15.6863 43.3137 13 40 13H14ZM42 23V19C42 17.8954 41.1046 17 40 17H14C12.8954 17 12 17.8954 12 19V35C12 36.1046 12.8954 37 14 37H18V29C18 25.6863 20.6863 23 24 23H42ZM24 27C22.8954 27 22 27.8954 22 29V45C22 46.1046 22.8954 47 24 47H50C51.1046 47 52 46.1046 52 45V29C52 27.8954 51.1046 27 50 27H24Z"
			/>
		</g>
	);
}

function BigText(props) {
	return (
		<path d="M22.8146 46L25.7521 37.5312H38.2521L41.174 46H46.299L34.7833 14H29.2052L17.6896 46H22.8146ZM27.1583 33.4688L31.8771 19.8125H32.1271L36.8458 33.4688H27.1583Z" />
	);
}

function Clock(props) {
	return (
		<g>
			<path d="M34 20C34 18.8954 33.1046 18 32 18C30.8954 18 30 18.8954 30 20V32C30 32.5304 30.2107 33.0391 30.5858 33.4142L39.0858 41.9142C39.8668 42.6953 41.1332 42.6953 41.9142 41.9142C42.6953 41.1332 42.6953 39.8668 41.9142 39.0858L34 31.1716V20Z" />
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M56 32C56 45.2548 45.2548 56 32 56C18.7452 56 8 45.2548 8 32C8 18.7452 18.7452 8 32 8C45.2548 8 56 18.7452 56 32ZM52 32C52 43.0457 43.0457 52 32 52C20.9543 52 12 43.0457 12 32C12 20.9543 20.9543 12 32 12C43.0457 12 52 20.9543 52 32Z"
			/>
		</g>
	);
}

function AddTableRow(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M4 20C4 15.5817 7.58172 12 12 12H44C48.4183 12 52 15.5817 52 20V32C52 33.1046 51.1046 34 50 34H8V44C8 46.2091 9.79086 48 12 48H32C33.1046 48 34 48.8954 34 50C34 51.1046 33.1046 52 32 52H12C7.58172 52 4 48.4183 4 44V20ZM48 20V30H8V20C8 17.7909 9.79086 16 12 16H44C46.2091 16 48 17.7909 48 20ZM48 42C48 40.8954 48.8954 40 50 40C51.1046 40 52 40.8954 52 42V48H58C59.1046 48 60 48.8954 60 50C60 51.1046 59.1046 52 58 52H52V58C52 59.1046 51.1046 60 50 60C48.8954 60 48 59.1046 48 58V52H42C40.8954 52 40 51.1046 40 50C40 48.8954 40.8954 48 42 48H48V42Z"
		/>
	);
}

function AddTableColumn(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M4 20C4 15.5817 7.58172 12 12 12H44C48.4183 12 52 15.5817 52 20V32C52 33.1046 51.1046 34 50 34C48.8954 34 48 33.1046 48 32V20C48 17.7909 46.2091 16 44 16H30V50C30 51.1046 29.1046 52 28 52H12C7.58172 52 4 48.4183 4 44V20ZM12 16H26V48H12C9.79086 48 8 46.2091 8 44V20C8 17.7909 9.79086 16 12 16ZM48 42C48 40.8954 48.8954 40 50 40C51.1046 40 52 40.8954 52 42V48H58C59.1046 48 60 48.8954 60 50C60 51.1046 59.1046 52 58 52H52V58C52 59.1046 51.1046 60 50 60C48.8954 60 48 59.1046 48 58V52H42C40.8954 52 40 51.1046 40 50C40 48.8954 40.8954 48 42 48H48V42Z"
		/>
	);
}

function RemoveTableColumn(props) {
	return (
		<g>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12 12C7.58172 12 4 15.5817 4 20V44C4 48.4183 7.58172 52 12 52H28C29.1046 52 30 51.1046 30 50V16H44C46.2091 16 48 17.7909 48 20V32C48 33.1046 48.8954 34 50 34C51.1046 34 52 33.1046 52 32V20C52 15.5817 48.4183 12 44 12H12ZM26 16H12C9.79086 16 8 17.7909 8 20V44C8 46.2091 9.79086 48 12 48H26V16Z"
			/>
			<path d="M42.9289 45.7574C42.1479 44.9763 42.1479 43.71 42.9289 42.9289C43.71 42.1479 44.9763 42.1479 45.7574 42.9289L50 47.1716L54.2426 42.9289C55.0237 42.1479 56.29 42.1479 57.0711 42.9289C57.8521 43.71 57.8521 44.9763 57.0711 45.7574L52.8284 50L57.0711 54.2426C57.8521 55.0237 57.8521 56.29 57.0711 57.0711C56.29 57.8521 55.0237 57.8521 54.2426 57.0711L50 52.8284L45.7574 57.0711C44.9763 57.8521 43.71 57.8521 42.9289 57.0711C42.1479 56.29 42.1479 55.0237 42.9289 54.2426L47.1716 50L42.9289 45.7574Z" />
		</g>
	);
}

function RemoveTableRow(props) {
	return (
		<g>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12 12C7.58172 12 4 15.5817 4 20V44C4 48.4183 7.58172 52 12 52H32C33.1046 52 34 51.1046 34 50C34 48.8954 33.1046 48 32 48H12C9.79086 48 8 46.2091 8 44V34H50C51.1046 34 52 33.1046 52 32V20C52 15.5817 48.4183 12 44 12H12ZM48 30V20C48 17.7909 46.2091 16 44 16H12C9.79086 16 8 17.7909 8 20V30H48Z"
			/>
			<path d="M42.9286 45.7574C42.1475 44.9763 42.1475 43.71 42.9286 42.9289C43.7096 42.1479 44.9759 42.1479 45.757 42.9289L49.9996 47.1716L54.2423 42.9289C55.0233 42.1479 56.2896 42.1479 57.0707 42.9289C57.8517 43.71 57.8517 44.9763 57.0707 45.7574L52.8281 50L57.0707 54.2426C57.8517 55.0237 57.8517 56.29 57.0707 57.0711C56.2896 57.8521 55.0233 57.8521 54.2423 57.0711L49.9996 52.8284L45.757 57.0711C44.9759 57.8521 43.7096 57.8521 42.9286 57.0711C42.1475 56.29 42.1475 55.0237 42.9286 54.2426L47.1712 50L42.9286 45.7574Z" />
		</g>
	);
}

function WrapText(props) {
	return (
		<g>
			<path d="M12 14C10.8954 14 10 14.8954 10 16V48C10 49.1046 10.8954 50 12 50C13.1046 50 14 49.1046 14 48V16C14 14.8954 13.1046 14 12 14Z" />
			<path d="M52 14C50.8954 14 50 14.8954 50 16V48C50 49.1046 50.8954 50 52 50C53.1046 50 54 49.1046 54 48V16C54 14.8954 53.1046 14 52 14Z" />
			<path d="M22 22C22 20.8954 22.8954 20 24 20H40C41.1046 20 42 20.8954 42 22C42 23.1046 41.1046 24 40 24H24C22.8954 24 22 23.1046 22 22Z" />
			<path d="M22 32C22 30.8954 22.8954 30 24 30H40C41.1046 30 42 30.8954 42 32C42 33.1046 41.1046 34 40 34H24C22.8954 34 22 33.1046 22 32Z" />
			<path d="M24 40C22.8954 40 22 40.8954 22 42C22 43.1046 22.8954 44 24 44H32C33.1046 44 34 43.1046 34 42C34 40.8954 33.1046 40 32 40H24Z" />
		</g>
	);
}

function UnwrapText(props) {
	return (
		<g>
			<path d="M14 14C12.8954 14 12 14.8954 12 16V48C12 49.1046 12.8954 50 14 50C15.1046 50 16 49.1046 16 48V16C16 14.8954 15.1046 14 14 14Z" />
			<path d="M50 14C48.8954 14 48 14.8954 48 16V30H28C26.8954 30 26 30.8954 26 32C26 33.1046 26.8954 34 28 34H48V48C48 49.1046 48.8954 50 50 50C51.1046 50 52 49.1046 52 48V16C52 14.8954 51.1046 14 50 14Z" />
		</g>
	);
}
